/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from 'protobufjs/minimal';

// Common aliases
const $Reader = $protobuf.Reader,
  $Writer = $protobuf.Writer,
  $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = {});

export const base = ($root.base = (() => {
  /**
   * Namespace base.
   * @exports base
   * @namespace
   */
  const base = {};

  base.Base = (function () {
    /**
     * Properties of a Base.
     * @memberof base
     * @interface IBase
     * @property {Object.<string,string>|null} [extra] Base extra
     */

    /**
     * Constructs a new Base.
     * @memberof base
     * @classdesc Represents a Base.
     * @implements IBase
     * @constructor
     * @param {base.IBase=} [properties] Properties to set
     */
    function Base(properties) {
      this.extra = {};
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Base extra.
     * @member {Object.<string,string>} extra
     * @memberof base.Base
     * @instance
     */
    Base.prototype.extra = $util.emptyObject;

    /**
     * Creates a new Base instance using the specified properties.
     * @function create
     * @memberof base.Base
     * @static
     * @param {base.IBase=} [properties] Properties to set
     * @returns {base.Base} Base instance
     */
    Base.create = function create(properties) {
      return new Base(properties);
    };

    /**
     * Encodes the specified Base message. Does not implicitly {@link base.Base.verify|verify} messages.
     * @function encode
     * @memberof base.Base
     * @static
     * @param {base.IBase} message Base message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Base.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.extra != null && Object.hasOwnProperty.call(message, 'extra'))
        for (let keys = Object.keys(message.extra), i = 0; i < keys.length; ++i)
          writer
            .uint32(/* id 10, wireType 2 =*/ 82)
            .fork()
            .uint32(/* id 1, wireType 2 =*/ 10)
            .string(keys[i])
            .uint32(/* id 2, wireType 2 =*/ 18)
            .string(message.extra[keys[i]])
            .ldelim();
      return writer;
    };

    /**
     * Encodes the specified Base message, length delimited. Does not implicitly {@link base.Base.verify|verify} messages.
     * @function encodeDelimited
     * @memberof base.Base
     * @static
     * @param {base.IBase} message Base message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Base.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Base message from the specified reader or buffer.
     * @function decode
     * @memberof base.Base
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {base.Base} Base
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Base.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.base.Base(),
        key,
        value;
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 10:
            if (message.extra === $util.emptyObject) message.extra = {};
            let end2 = reader.uint32() + reader.pos;
            key = '';
            value = '';
            while (reader.pos < end2) {
              let tag2 = reader.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  key = reader.string();
                  break;
                case 2:
                  value = reader.string();
                  break;
                default:
                  reader.skipType(tag2 & 7);
                  break;
              }
            }
            message.extra[key] = value;
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Base message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof base.Base
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {base.Base} Base
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Base.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Base message.
     * @function verify
     * @memberof base.Base
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Base.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.extra != null && message.hasOwnProperty('extra')) {
        if (!$util.isObject(message.extra)) return 'extra: object expected';
        let key = Object.keys(message.extra);
        for (let i = 0; i < key.length; ++i)
          if (!$util.isString(message.extra[key[i]]))
            return 'extra: string{k:string} expected';
      }
      return null;
    };

    /**
     * Creates a Base message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof base.Base
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {base.Base} Base
     */
    Base.fromObject = function fromObject(object) {
      if (object instanceof $root.base.Base) return object;
      let message = new $root.base.Base();
      if (object.extra) {
        if (typeof object.extra !== 'object')
          throw TypeError('.base.Base.extra: object expected');
        message.extra = {};
        for (let keys = Object.keys(object.extra), i = 0; i < keys.length; ++i)
          message.extra[keys[i]] = String(object.extra[keys[i]]);
      }
      return message;
    };

    /**
     * Creates a plain object from a Base message. Also converts values to other types if specified.
     * @function toObject
     * @memberof base.Base
     * @static
     * @param {base.Base} message Base
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Base.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.objects || options.defaults) object.extra = {};
      let keys2;
      if (message.extra && (keys2 = Object.keys(message.extra)).length) {
        object.extra = {};
        for (let j = 0; j < keys2.length; ++j)
          object.extra[keys2[j]] = message.extra[keys2[j]];
      }
      return object;
    };

    /**
     * Converts this Base to JSON.
     * @function toJSON
     * @memberof base.Base
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Base.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Base;
  })();

  base.BaseResp = (function () {
    /**
     * Properties of a BaseResp.
     * @memberof base
     * @interface IBaseResp
     * @property {number|null} [statusCode] BaseResp statusCode
     * @property {string|null} [statusMessage] BaseResp statusMessage
     * @property {Object.<string,string>|null} [extra] BaseResp extra
     */

    /**
     * Constructs a new BaseResp.
     * @memberof base
     * @classdesc Represents a BaseResp.
     * @implements IBaseResp
     * @constructor
     * @param {base.IBaseResp=} [properties] Properties to set
     */
    function BaseResp(properties) {
      this.extra = {};
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * BaseResp statusCode.
     * @member {number} statusCode
     * @memberof base.BaseResp
     * @instance
     */
    BaseResp.prototype.statusCode = 0;

    /**
     * BaseResp statusMessage.
     * @member {string} statusMessage
     * @memberof base.BaseResp
     * @instance
     */
    BaseResp.prototype.statusMessage = '';

    /**
     * BaseResp extra.
     * @member {Object.<string,string>} extra
     * @memberof base.BaseResp
     * @instance
     */
    BaseResp.prototype.extra = $util.emptyObject;

    /**
     * Creates a new BaseResp instance using the specified properties.
     * @function create
     * @memberof base.BaseResp
     * @static
     * @param {base.IBaseResp=} [properties] Properties to set
     * @returns {base.BaseResp} BaseResp instance
     */
    BaseResp.create = function create(properties) {
      return new BaseResp(properties);
    };

    /**
     * Encodes the specified BaseResp message. Does not implicitly {@link base.BaseResp.verify|verify} messages.
     * @function encode
     * @memberof base.BaseResp
     * @static
     * @param {base.IBaseResp} message BaseResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BaseResp.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.statusCode != null &&
        Object.hasOwnProperty.call(message, 'statusCode')
      )
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.statusCode);
      if (
        message.statusMessage != null &&
        Object.hasOwnProperty.call(message, 'statusMessage')
      )
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.statusMessage);
      if (message.extra != null && Object.hasOwnProperty.call(message, 'extra'))
        for (let keys = Object.keys(message.extra), i = 0; i < keys.length; ++i)
          writer
            .uint32(/* id 10, wireType 2 =*/ 82)
            .fork()
            .uint32(/* id 1, wireType 2 =*/ 10)
            .string(keys[i])
            .uint32(/* id 2, wireType 2 =*/ 18)
            .string(message.extra[keys[i]])
            .ldelim();
      return writer;
    };

    /**
     * Encodes the specified BaseResp message, length delimited. Does not implicitly {@link base.BaseResp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof base.BaseResp
     * @static
     * @param {base.IBaseResp} message BaseResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BaseResp.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BaseResp message from the specified reader or buffer.
     * @function decode
     * @memberof base.BaseResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {base.BaseResp} BaseResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BaseResp.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.base.BaseResp(),
        key,
        value;
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.statusCode = reader.int32();
            break;
          case 2:
            message.statusMessage = reader.string();
            break;
          case 10:
            if (message.extra === $util.emptyObject) message.extra = {};
            let end2 = reader.uint32() + reader.pos;
            key = '';
            value = '';
            while (reader.pos < end2) {
              let tag2 = reader.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  key = reader.string();
                  break;
                case 2:
                  value = reader.string();
                  break;
                default:
                  reader.skipType(tag2 & 7);
                  break;
              }
            }
            message.extra[key] = value;
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a BaseResp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof base.BaseResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {base.BaseResp} BaseResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BaseResp.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BaseResp message.
     * @function verify
     * @memberof base.BaseResp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BaseResp.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.statusCode != null && message.hasOwnProperty('statusCode'))
        if (!$util.isInteger(message.statusCode))
          return 'statusCode: integer expected';
      if (
        message.statusMessage != null &&
        message.hasOwnProperty('statusMessage')
      )
        if (!$util.isString(message.statusMessage))
          return 'statusMessage: string expected';
      if (message.extra != null && message.hasOwnProperty('extra')) {
        if (!$util.isObject(message.extra)) return 'extra: object expected';
        let key = Object.keys(message.extra);
        for (let i = 0; i < key.length; ++i)
          if (!$util.isString(message.extra[key[i]]))
            return 'extra: string{k:string} expected';
      }
      return null;
    };

    /**
     * Creates a BaseResp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof base.BaseResp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {base.BaseResp} BaseResp
     */
    BaseResp.fromObject = function fromObject(object) {
      if (object instanceof $root.base.BaseResp) return object;
      let message = new $root.base.BaseResp();
      if (object.statusCode != null) message.statusCode = object.statusCode | 0;
      if (object.statusMessage != null)
        message.statusMessage = String(object.statusMessage);
      if (object.extra) {
        if (typeof object.extra !== 'object')
          throw TypeError('.base.BaseResp.extra: object expected');
        message.extra = {};
        for (let keys = Object.keys(object.extra), i = 0; i < keys.length; ++i)
          message.extra[keys[i]] = String(object.extra[keys[i]]);
      }
      return message;
    };

    /**
     * Creates a plain object from a BaseResp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof base.BaseResp
     * @static
     * @param {base.BaseResp} message BaseResp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BaseResp.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.objects || options.defaults) object.extra = {};
      if (options.defaults) {
        object.statusCode = 0;
        object.statusMessage = '';
      }
      if (message.statusCode != null && message.hasOwnProperty('statusCode'))
        object.statusCode = message.statusCode;
      if (
        message.statusMessage != null &&
        message.hasOwnProperty('statusMessage')
      )
        object.statusMessage = message.statusMessage;
      let keys2;
      if (message.extra && (keys2 = Object.keys(message.extra)).length) {
        object.extra = {};
        for (let j = 0; j < keys2.length; ++j)
          object.extra[keys2[j]] = message.extra[keys2[j]];
      }
      return object;
    };

    /**
     * Converts this BaseResp to JSON.
     * @function toJSON
     * @memberof base.BaseResp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BaseResp.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BaseResp;
  })();

  base.MapEntry = (function () {
    /**
     * Properties of a MapEntry.
     * @memberof base
     * @interface IMapEntry
     * @property {string|null} [key] MapEntry key
     * @property {string|null} [value] MapEntry value
     */

    /**
     * Constructs a new MapEntry.
     * @memberof base
     * @classdesc Represents a MapEntry.
     * @implements IMapEntry
     * @constructor
     * @param {base.IMapEntry=} [properties] Properties to set
     */
    function MapEntry(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * MapEntry key.
     * @member {string} key
     * @memberof base.MapEntry
     * @instance
     */
    MapEntry.prototype.key = '';

    /**
     * MapEntry value.
     * @member {string} value
     * @memberof base.MapEntry
     * @instance
     */
    MapEntry.prototype.value = '';

    /**
     * Creates a new MapEntry instance using the specified properties.
     * @function create
     * @memberof base.MapEntry
     * @static
     * @param {base.IMapEntry=} [properties] Properties to set
     * @returns {base.MapEntry} MapEntry instance
     */
    MapEntry.create = function create(properties) {
      return new MapEntry(properties);
    };

    /**
     * Encodes the specified MapEntry message. Does not implicitly {@link base.MapEntry.verify|verify} messages.
     * @function encode
     * @memberof base.MapEntry
     * @static
     * @param {base.IMapEntry} message MapEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MapEntry.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.key != null && Object.hasOwnProperty.call(message, 'key'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.key);
      if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.value);
      return writer;
    };

    /**
     * Encodes the specified MapEntry message, length delimited. Does not implicitly {@link base.MapEntry.verify|verify} messages.
     * @function encodeDelimited
     * @memberof base.MapEntry
     * @static
     * @param {base.IMapEntry} message MapEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MapEntry.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MapEntry message from the specified reader or buffer.
     * @function decode
     * @memberof base.MapEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {base.MapEntry} MapEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MapEntry.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.base.MapEntry();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.key = reader.string();
            break;
          case 2:
            message.value = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a MapEntry message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof base.MapEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {base.MapEntry} MapEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MapEntry.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MapEntry message.
     * @function verify
     * @memberof base.MapEntry
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MapEntry.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.key != null && message.hasOwnProperty('key'))
        if (!$util.isString(message.key)) return 'key: string expected';
      if (message.value != null && message.hasOwnProperty('value'))
        if (!$util.isString(message.value)) return 'value: string expected';
      return null;
    };

    /**
     * Creates a MapEntry message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof base.MapEntry
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {base.MapEntry} MapEntry
     */
    MapEntry.fromObject = function fromObject(object) {
      if (object instanceof $root.base.MapEntry) return object;
      let message = new $root.base.MapEntry();
      if (object.key != null) message.key = String(object.key);
      if (object.value != null) message.value = String(object.value);
      return message;
    };

    /**
     * Creates a plain object from a MapEntry message. Also converts values to other types if specified.
     * @function toObject
     * @memberof base.MapEntry
     * @static
     * @param {base.MapEntry} message MapEntry
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MapEntry.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.key = '';
        object.value = '';
      }
      if (message.key != null && message.hasOwnProperty('key'))
        object.key = message.key;
      if (message.value != null && message.hasOwnProperty('value'))
        object.value = message.value;
      return object;
    };

    /**
     * Converts this MapEntry to JSON.
     * @function toJSON
     * @memberof base.MapEntry
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MapEntry.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MapEntry;
  })();

  return base;
})());

export const live = ($root.live = (() => {
  /**
   * Namespace live.
   * @exports live
   * @namespace
   */
  const live = {};

  live.Subtitle = (function () {
    /**
     * Properties of a Subtitle.
     * @memberof live
     * @interface ISubtitle
     * @property {string|null} [language] Subtitle language
     * @property {string|null} [text] Subtitle text
     * @property {boolean|null} [isSpoken] Subtitle isSpoken
     * @property {Array.<base.IMapEntry>|null} [extra] Subtitle extra
     */

    /**
     * Constructs a new Subtitle.
     * @memberof live
     * @classdesc Represents a Subtitle.
     * @implements ISubtitle
     * @constructor
     * @param {live.ISubtitle=} [properties] Properties to set
     */
    function Subtitle(properties) {
      this.extra = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Subtitle language.
     * @member {string} language
     * @memberof live.Subtitle
     * @instance
     */
    Subtitle.prototype.language = '';

    /**
     * Subtitle text.
     * @member {string} text
     * @memberof live.Subtitle
     * @instance
     */
    Subtitle.prototype.text = '';

    /**
     * Subtitle isSpoken.
     * @member {boolean} isSpoken
     * @memberof live.Subtitle
     * @instance
     */
    Subtitle.prototype.isSpoken = false;

    /**
     * Subtitle extra.
     * @member {Array.<base.IMapEntry>} extra
     * @memberof live.Subtitle
     * @instance
     */
    Subtitle.prototype.extra = $util.emptyArray;

    /**
     * Creates a new Subtitle instance using the specified properties.
     * @function create
     * @memberof live.Subtitle
     * @static
     * @param {live.ISubtitle=} [properties] Properties to set
     * @returns {live.Subtitle} Subtitle instance
     */
    Subtitle.create = function create(properties) {
      return new Subtitle(properties);
    };

    /**
     * Encodes the specified Subtitle message. Does not implicitly {@link live.Subtitle.verify|verify} messages.
     * @function encode
     * @memberof live.Subtitle
     * @static
     * @param {live.ISubtitle} message Subtitle message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Subtitle.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.language != null &&
        Object.hasOwnProperty.call(message, 'language')
      )
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.language);
      if (message.text != null && Object.hasOwnProperty.call(message, 'text'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.text);
      if (
        message.isSpoken != null &&
        Object.hasOwnProperty.call(message, 'isSpoken')
      )
        writer.uint32(/* id 3, wireType 0 =*/ 24).bool(message.isSpoken);
      if (message.extra != null && message.extra.length)
        for (let i = 0; i < message.extra.length; ++i)
          $root.base.MapEntry.encode(
            message.extra[i],
            writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified Subtitle message, length delimited. Does not implicitly {@link live.Subtitle.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.Subtitle
     * @static
     * @param {live.ISubtitle} message Subtitle message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Subtitle.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Subtitle message from the specified reader or buffer.
     * @function decode
     * @memberof live.Subtitle
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.Subtitle} Subtitle
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Subtitle.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.Subtitle();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.language = reader.string();
            break;
          case 2:
            message.text = reader.string();
            break;
          case 3:
            message.isSpoken = reader.bool();
            break;
          case 4:
            if (!(message.extra && message.extra.length)) message.extra = [];
            message.extra.push(
              $root.base.MapEntry.decode(reader, reader.uint32())
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Subtitle message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.Subtitle
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.Subtitle} Subtitle
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Subtitle.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Subtitle message.
     * @function verify
     * @memberof live.Subtitle
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Subtitle.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.language != null && message.hasOwnProperty('language'))
        if (!$util.isString(message.language))
          return 'language: string expected';
      if (message.text != null && message.hasOwnProperty('text'))
        if (!$util.isString(message.text)) return 'text: string expected';
      if (message.isSpoken != null && message.hasOwnProperty('isSpoken'))
        if (typeof message.isSpoken !== 'boolean')
          return 'isSpoken: boolean expected';
      if (message.extra != null && message.hasOwnProperty('extra')) {
        if (!Array.isArray(message.extra)) return 'extra: array expected';
        for (let i = 0; i < message.extra.length; ++i) {
          let error = $root.base.MapEntry.verify(message.extra[i]);
          if (error) return 'extra.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a Subtitle message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.Subtitle
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.Subtitle} Subtitle
     */
    Subtitle.fromObject = function fromObject(object) {
      if (object instanceof $root.live.Subtitle) return object;
      let message = new $root.live.Subtitle();
      if (object.language != null) message.language = String(object.language);
      if (object.text != null) message.text = String(object.text);
      if (object.isSpoken != null) message.isSpoken = Boolean(object.isSpoken);
      if (object.extra) {
        if (!Array.isArray(object.extra))
          throw TypeError('.live.Subtitle.extra: array expected');
        message.extra = [];
        for (let i = 0; i < object.extra.length; ++i) {
          if (typeof object.extra[i] !== 'object')
            throw TypeError('.live.Subtitle.extra: object expected');
          message.extra[i] = $root.base.MapEntry.fromObject(object.extra[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a Subtitle message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.Subtitle
     * @static
     * @param {live.Subtitle} message Subtitle
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Subtitle.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.extra = [];
      if (options.defaults) {
        object.language = '';
        object.text = '';
        object.isSpoken = false;
      }
      if (message.language != null && message.hasOwnProperty('language'))
        object.language = message.language;
      if (message.text != null && message.hasOwnProperty('text'))
        object.text = message.text;
      if (message.isSpoken != null && message.hasOwnProperty('isSpoken'))
        object.isSpoken = message.isSpoken;
      if (message.extra && message.extra.length) {
        object.extra = [];
        for (let j = 0; j < message.extra.length; ++j)
          object.extra[j] = $root.base.MapEntry.toObject(
            message.extra[j],
            options
          );
      }
      return object;
    };

    /**
     * Converts this Subtitle to JSON.
     * @function toJSON
     * @memberof live.Subtitle
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Subtitle.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Subtitle;
  })();

  live.FinalSubtitle = (function () {
    /**
     * Properties of a FinalSubtitle.
     * @memberof live
     * @interface IFinalSubtitle
     * @property {number|null} [key] FinalSubtitle key
     * @property {number|null} [version] FinalSubtitle version
     * @property {number|null} [subversion] FinalSubtitle subversion
     * @property {live.ISubtitle|null} [subtitle] FinalSubtitle subtitle
     * @property {si.ITimestamp|null} [range] FinalSubtitle range
     */

    /**
     * Constructs a new FinalSubtitle.
     * @memberof live
     * @classdesc Represents a FinalSubtitle.
     * @implements IFinalSubtitle
     * @constructor
     * @param {live.IFinalSubtitle=} [properties] Properties to set
     */
    function FinalSubtitle(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * FinalSubtitle key.
     * @member {number} key
     * @memberof live.FinalSubtitle
     * @instance
     */
    FinalSubtitle.prototype.key = 0;

    /**
     * FinalSubtitle version.
     * @member {number} version
     * @memberof live.FinalSubtitle
     * @instance
     */
    FinalSubtitle.prototype.version = 0;

    /**
     * FinalSubtitle subversion.
     * @member {number} subversion
     * @memberof live.FinalSubtitle
     * @instance
     */
    FinalSubtitle.prototype.subversion = 0;

    /**
     * FinalSubtitle subtitle.
     * @member {live.ISubtitle|null|undefined} subtitle
     * @memberof live.FinalSubtitle
     * @instance
     */
    FinalSubtitle.prototype.subtitle = null;

    /**
     * FinalSubtitle range.
     * @member {si.ITimestamp|null|undefined} range
     * @memberof live.FinalSubtitle
     * @instance
     */
    FinalSubtitle.prototype.range = null;

    /**
     * Creates a new FinalSubtitle instance using the specified properties.
     * @function create
     * @memberof live.FinalSubtitle
     * @static
     * @param {live.IFinalSubtitle=} [properties] Properties to set
     * @returns {live.FinalSubtitle} FinalSubtitle instance
     */
    FinalSubtitle.create = function create(properties) {
      return new FinalSubtitle(properties);
    };

    /**
     * Encodes the specified FinalSubtitle message. Does not implicitly {@link live.FinalSubtitle.verify|verify} messages.
     * @function encode
     * @memberof live.FinalSubtitle
     * @static
     * @param {live.IFinalSubtitle} message FinalSubtitle message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FinalSubtitle.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.key != null && Object.hasOwnProperty.call(message, 'key'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.key);
      if (
        message.version != null &&
        Object.hasOwnProperty.call(message, 'version')
      )
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.version);
      if (
        message.subtitle != null &&
        Object.hasOwnProperty.call(message, 'subtitle')
      )
        $root.live.Subtitle.encode(
          message.subtitle,
          writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
        ).ldelim();
      if (message.range != null && Object.hasOwnProperty.call(message, 'range'))
        $root.si.Timestamp.encode(
          message.range,
          writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
        ).ldelim();
      if (
        message.subversion != null &&
        Object.hasOwnProperty.call(message, 'subversion')
      )
        writer.uint32(/* id 6, wireType 0 =*/ 48).int32(message.subversion);
      return writer;
    };

    /**
     * Encodes the specified FinalSubtitle message, length delimited. Does not implicitly {@link live.FinalSubtitle.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.FinalSubtitle
     * @static
     * @param {live.IFinalSubtitle} message FinalSubtitle message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FinalSubtitle.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FinalSubtitle message from the specified reader or buffer.
     * @function decode
     * @memberof live.FinalSubtitle
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.FinalSubtitle} FinalSubtitle
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FinalSubtitle.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.FinalSubtitle();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.key = reader.int32();
            break;
          case 2:
            message.version = reader.int32();
            break;
          case 6:
            message.subversion = reader.int32();
            break;
          case 3:
            message.subtitle = $root.live.Subtitle.decode(
              reader,
              reader.uint32()
            );
            break;
          case 4:
            message.range = $root.si.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a FinalSubtitle message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.FinalSubtitle
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.FinalSubtitle} FinalSubtitle
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FinalSubtitle.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FinalSubtitle message.
     * @function verify
     * @memberof live.FinalSubtitle
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FinalSubtitle.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.key != null && message.hasOwnProperty('key'))
        if (!$util.isInteger(message.key)) return 'key: integer expected';
      if (message.version != null && message.hasOwnProperty('version'))
        if (!$util.isInteger(message.version))
          return 'version: integer expected';
      if (message.subversion != null && message.hasOwnProperty('subversion'))
        if (!$util.isInteger(message.subversion))
          return 'subversion: integer expected';
      if (message.subtitle != null && message.hasOwnProperty('subtitle')) {
        let error = $root.live.Subtitle.verify(message.subtitle);
        if (error) return 'subtitle.' + error;
      }
      if (message.range != null && message.hasOwnProperty('range')) {
        let error = $root.si.Timestamp.verify(message.range);
        if (error) return 'range.' + error;
      }
      return null;
    };

    /**
     * Creates a FinalSubtitle message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.FinalSubtitle
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.FinalSubtitle} FinalSubtitle
     */
    FinalSubtitle.fromObject = function fromObject(object) {
      if (object instanceof $root.live.FinalSubtitle) return object;
      let message = new $root.live.FinalSubtitle();
      if (object.key != null) message.key = object.key | 0;
      if (object.version != null) message.version = object.version | 0;
      if (object.subversion != null) message.subversion = object.subversion | 0;
      if (object.subtitle != null) {
        if (typeof object.subtitle !== 'object')
          throw TypeError('.live.FinalSubtitle.subtitle: object expected');
        message.subtitle = $root.live.Subtitle.fromObject(object.subtitle);
      }
      if (object.range != null) {
        if (typeof object.range !== 'object')
          throw TypeError('.live.FinalSubtitle.range: object expected');
        message.range = $root.si.Timestamp.fromObject(object.range);
      }
      return message;
    };

    /**
     * Creates a plain object from a FinalSubtitle message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.FinalSubtitle
     * @static
     * @param {live.FinalSubtitle} message FinalSubtitle
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FinalSubtitle.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.key = 0;
        object.version = 0;
        object.subtitle = null;
        object.range = null;
        object.subversion = 0;
      }
      if (message.key != null && message.hasOwnProperty('key'))
        object.key = message.key;
      if (message.version != null && message.hasOwnProperty('version'))
        object.version = message.version;
      if (message.subtitle != null && message.hasOwnProperty('subtitle'))
        object.subtitle = $root.live.Subtitle.toObject(
          message.subtitle,
          options
        );
      if (message.range != null && message.hasOwnProperty('range'))
        object.range = $root.si.Timestamp.toObject(message.range, options);
      if (message.subversion != null && message.hasOwnProperty('subversion'))
        object.subversion = message.subversion;
      return object;
    };

    /**
     * Converts this FinalSubtitle to JSON.
     * @function toJSON
     * @memberof live.FinalSubtitle
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FinalSubtitle.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FinalSubtitle;
  })();

  live.VolatileSubtitle = (function () {
    /**
     * Properties of a VolatileSubtitle.
     * @memberof live
     * @interface IVolatileSubtitle
     * @property {live.ISubtitle|null} [subtitle] VolatileSubtitle subtitle
     */

    /**
     * Constructs a new VolatileSubtitle.
     * @memberof live
     * @classdesc Represents a VolatileSubtitle.
     * @implements IVolatileSubtitle
     * @constructor
     * @param {live.IVolatileSubtitle=} [properties] Properties to set
     */
    function VolatileSubtitle(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * VolatileSubtitle subtitle.
     * @member {live.ISubtitle|null|undefined} subtitle
     * @memberof live.VolatileSubtitle
     * @instance
     */
    VolatileSubtitle.prototype.subtitle = null;

    /**
     * Creates a new VolatileSubtitle instance using the specified properties.
     * @function create
     * @memberof live.VolatileSubtitle
     * @static
     * @param {live.IVolatileSubtitle=} [properties] Properties to set
     * @returns {live.VolatileSubtitle} VolatileSubtitle instance
     */
    VolatileSubtitle.create = function create(properties) {
      return new VolatileSubtitle(properties);
    };

    /**
     * Encodes the specified VolatileSubtitle message. Does not implicitly {@link live.VolatileSubtitle.verify|verify} messages.
     * @function encode
     * @memberof live.VolatileSubtitle
     * @static
     * @param {live.IVolatileSubtitle} message VolatileSubtitle message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    VolatileSubtitle.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.subtitle != null &&
        Object.hasOwnProperty.call(message, 'subtitle')
      )
        $root.live.Subtitle.encode(
          message.subtitle,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified VolatileSubtitle message, length delimited. Does not implicitly {@link live.VolatileSubtitle.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.VolatileSubtitle
     * @static
     * @param {live.IVolatileSubtitle} message VolatileSubtitle message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    VolatileSubtitle.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a VolatileSubtitle message from the specified reader or buffer.
     * @function decode
     * @memberof live.VolatileSubtitle
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.VolatileSubtitle} VolatileSubtitle
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    VolatileSubtitle.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.VolatileSubtitle();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.subtitle = $root.live.Subtitle.decode(
              reader,
              reader.uint32()
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a VolatileSubtitle message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.VolatileSubtitle
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.VolatileSubtitle} VolatileSubtitle
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    VolatileSubtitle.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a VolatileSubtitle message.
     * @function verify
     * @memberof live.VolatileSubtitle
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    VolatileSubtitle.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.subtitle != null && message.hasOwnProperty('subtitle')) {
        let error = $root.live.Subtitle.verify(message.subtitle);
        if (error) return 'subtitle.' + error;
      }
      return null;
    };

    /**
     * Creates a VolatileSubtitle message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.VolatileSubtitle
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.VolatileSubtitle} VolatileSubtitle
     */
    VolatileSubtitle.fromObject = function fromObject(object) {
      if (object instanceof $root.live.VolatileSubtitle) return object;
      let message = new $root.live.VolatileSubtitle();
      if (object.subtitle != null) {
        if (typeof object.subtitle !== 'object')
          throw TypeError('.live.VolatileSubtitle.subtitle: object expected');
        message.subtitle = $root.live.Subtitle.fromObject(object.subtitle);
      }
      return message;
    };

    /**
     * Creates a plain object from a VolatileSubtitle message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.VolatileSubtitle
     * @static
     * @param {live.VolatileSubtitle} message VolatileSubtitle
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    VolatileSubtitle.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.subtitle = null;
      if (message.subtitle != null && message.hasOwnProperty('subtitle'))
        object.subtitle = $root.live.Subtitle.toObject(
          message.subtitle,
          options
        );
      return object;
    };

    /**
     * Converts this VolatileSubtitle to JSON.
     * @function toJSON
     * @memberof live.VolatileSubtitle
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    VolatileSubtitle.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return VolatileSubtitle;
  })();

  live.BroadcastFinalMsg = (function () {
    /**
     * Properties of a BroadcastFinalMsg.
     * @memberof live
     * @interface IBroadcastFinalMsg
     * @property {live.IFinalSubtitle|null} [finalSubtitle] BroadcastFinalMsg finalSubtitle
     * @property {boolean|null} [isManual] BroadcastFinalMsg isManual
     */

    /**
     * Constructs a new BroadcastFinalMsg.
     * @memberof live
     * @classdesc Represents a BroadcastFinalMsg.
     * @implements IBroadcastFinalMsg
     * @constructor
     * @param {live.IBroadcastFinalMsg=} [properties] Properties to set
     */
    function BroadcastFinalMsg(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * BroadcastFinalMsg finalSubtitle.
     * @member {live.IFinalSubtitle|null|undefined} finalSubtitle
     * @memberof live.BroadcastFinalMsg
     * @instance
     */
    BroadcastFinalMsg.prototype.finalSubtitle = null;

    /**
     * BroadcastFinalMsg isManual.
     * @member {boolean} isManual
     * @memberof live.BroadcastFinalMsg
     * @instance
     */
    BroadcastFinalMsg.prototype.isManual = false;

    /**
     * Creates a new BroadcastFinalMsg instance using the specified properties.
     * @function create
     * @memberof live.BroadcastFinalMsg
     * @static
     * @param {live.IBroadcastFinalMsg=} [properties] Properties to set
     * @returns {live.BroadcastFinalMsg} BroadcastFinalMsg instance
     */
    BroadcastFinalMsg.create = function create(properties) {
      return new BroadcastFinalMsg(properties);
    };

    /**
     * Encodes the specified BroadcastFinalMsg message. Does not implicitly {@link live.BroadcastFinalMsg.verify|verify} messages.
     * @function encode
     * @memberof live.BroadcastFinalMsg
     * @static
     * @param {live.IBroadcastFinalMsg} message BroadcastFinalMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BroadcastFinalMsg.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.finalSubtitle != null &&
        Object.hasOwnProperty.call(message, 'finalSubtitle')
      )
        $root.live.FinalSubtitle.encode(
          message.finalSubtitle,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.isManual != null &&
        Object.hasOwnProperty.call(message, 'isManual')
      )
        writer.uint32(/* id 2, wireType 0 =*/ 16).bool(message.isManual);
      return writer;
    };

    /**
     * Encodes the specified BroadcastFinalMsg message, length delimited. Does not implicitly {@link live.BroadcastFinalMsg.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.BroadcastFinalMsg
     * @static
     * @param {live.IBroadcastFinalMsg} message BroadcastFinalMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BroadcastFinalMsg.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BroadcastFinalMsg message from the specified reader or buffer.
     * @function decode
     * @memberof live.BroadcastFinalMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.BroadcastFinalMsg} BroadcastFinalMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BroadcastFinalMsg.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.BroadcastFinalMsg();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.finalSubtitle = $root.live.FinalSubtitle.decode(
              reader,
              reader.uint32()
            );
            break;
          case 2:
            message.isManual = reader.bool();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a BroadcastFinalMsg message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.BroadcastFinalMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.BroadcastFinalMsg} BroadcastFinalMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BroadcastFinalMsg.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BroadcastFinalMsg message.
     * @function verify
     * @memberof live.BroadcastFinalMsg
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BroadcastFinalMsg.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (
        message.finalSubtitle != null &&
        message.hasOwnProperty('finalSubtitle')
      ) {
        let error = $root.live.FinalSubtitle.verify(message.finalSubtitle);
        if (error) return 'finalSubtitle.' + error;
      }
      if (message.isManual != null && message.hasOwnProperty('isManual'))
        if (typeof message.isManual !== 'boolean')
          return 'isManual: boolean expected';
      return null;
    };

    /**
     * Creates a BroadcastFinalMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.BroadcastFinalMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.BroadcastFinalMsg} BroadcastFinalMsg
     */
    BroadcastFinalMsg.fromObject = function fromObject(object) {
      if (object instanceof $root.live.BroadcastFinalMsg) return object;
      let message = new $root.live.BroadcastFinalMsg();
      if (object.finalSubtitle != null) {
        if (typeof object.finalSubtitle !== 'object')
          throw TypeError(
            '.live.BroadcastFinalMsg.finalSubtitle: object expected'
          );
        message.finalSubtitle = $root.live.FinalSubtitle.fromObject(
          object.finalSubtitle
        );
      }
      if (object.isManual != null) message.isManual = Boolean(object.isManual);
      return message;
    };

    /**
     * Creates a plain object from a BroadcastFinalMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.BroadcastFinalMsg
     * @static
     * @param {live.BroadcastFinalMsg} message BroadcastFinalMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BroadcastFinalMsg.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.finalSubtitle = null;
        object.isManual = false;
      }
      if (
        message.finalSubtitle != null &&
        message.hasOwnProperty('finalSubtitle')
      )
        object.finalSubtitle = $root.live.FinalSubtitle.toObject(
          message.finalSubtitle,
          options
        );
      if (message.isManual != null && message.hasOwnProperty('isManual'))
        object.isManual = message.isManual;
      return object;
    };

    /**
     * Converts this BroadcastFinalMsg to JSON.
     * @function toJSON
     * @memberof live.BroadcastFinalMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BroadcastFinalMsg.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BroadcastFinalMsg;
  })();

  live.BroadcastVolatileMsg = (function () {
    /**
     * Properties of a BroadcastVolatileMsg.
     * @memberof live
     * @interface IBroadcastVolatileMsg
     * @property {live.IVolatileSubtitle|null} [volatileSubtitle] BroadcastVolatileMsg volatileSubtitle
     */

    /**
     * Constructs a new BroadcastVolatileMsg.
     * @memberof live
     * @classdesc Represents a BroadcastVolatileMsg.
     * @implements IBroadcastVolatileMsg
     * @constructor
     * @param {live.IBroadcastVolatileMsg=} [properties] Properties to set
     */
    function BroadcastVolatileMsg(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * BroadcastVolatileMsg volatileSubtitle.
     * @member {live.IVolatileSubtitle|null|undefined} volatileSubtitle
     * @memberof live.BroadcastVolatileMsg
     * @instance
     */
    BroadcastVolatileMsg.prototype.volatileSubtitle = null;

    /**
     * Creates a new BroadcastVolatileMsg instance using the specified properties.
     * @function create
     * @memberof live.BroadcastVolatileMsg
     * @static
     * @param {live.IBroadcastVolatileMsg=} [properties] Properties to set
     * @returns {live.BroadcastVolatileMsg} BroadcastVolatileMsg instance
     */
    BroadcastVolatileMsg.create = function create(properties) {
      return new BroadcastVolatileMsg(properties);
    };

    /**
     * Encodes the specified BroadcastVolatileMsg message. Does not implicitly {@link live.BroadcastVolatileMsg.verify|verify} messages.
     * @function encode
     * @memberof live.BroadcastVolatileMsg
     * @static
     * @param {live.IBroadcastVolatileMsg} message BroadcastVolatileMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BroadcastVolatileMsg.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.volatileSubtitle != null &&
        Object.hasOwnProperty.call(message, 'volatileSubtitle')
      )
        $root.live.VolatileSubtitle.encode(
          message.volatileSubtitle,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified BroadcastVolatileMsg message, length delimited. Does not implicitly {@link live.BroadcastVolatileMsg.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.BroadcastVolatileMsg
     * @static
     * @param {live.IBroadcastVolatileMsg} message BroadcastVolatileMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BroadcastVolatileMsg.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BroadcastVolatileMsg message from the specified reader or buffer.
     * @function decode
     * @memberof live.BroadcastVolatileMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.BroadcastVolatileMsg} BroadcastVolatileMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BroadcastVolatileMsg.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.BroadcastVolatileMsg();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.volatileSubtitle = $root.live.VolatileSubtitle.decode(
              reader,
              reader.uint32()
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a BroadcastVolatileMsg message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.BroadcastVolatileMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.BroadcastVolatileMsg} BroadcastVolatileMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BroadcastVolatileMsg.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BroadcastVolatileMsg message.
     * @function verify
     * @memberof live.BroadcastVolatileMsg
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BroadcastVolatileMsg.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (
        message.volatileSubtitle != null &&
        message.hasOwnProperty('volatileSubtitle')
      ) {
        let error = $root.live.VolatileSubtitle.verify(
          message.volatileSubtitle
        );
        if (error) return 'volatileSubtitle.' + error;
      }
      return null;
    };

    /**
     * Creates a BroadcastVolatileMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.BroadcastVolatileMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.BroadcastVolatileMsg} BroadcastVolatileMsg
     */
    BroadcastVolatileMsg.fromObject = function fromObject(object) {
      if (object instanceof $root.live.BroadcastVolatileMsg) return object;
      let message = new $root.live.BroadcastVolatileMsg();
      if (object.volatileSubtitle != null) {
        if (typeof object.volatileSubtitle !== 'object')
          throw TypeError(
            '.live.BroadcastVolatileMsg.volatileSubtitle: object expected'
          );
        message.volatileSubtitle = $root.live.VolatileSubtitle.fromObject(
          object.volatileSubtitle
        );
      }
      return message;
    };

    /**
     * Creates a plain object from a BroadcastVolatileMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.BroadcastVolatileMsg
     * @static
     * @param {live.BroadcastVolatileMsg} message BroadcastVolatileMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BroadcastVolatileMsg.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.volatileSubtitle = null;
      if (
        message.volatileSubtitle != null &&
        message.hasOwnProperty('volatileSubtitle')
      )
        object.volatileSubtitle = $root.live.VolatileSubtitle.toObject(
          message.volatileSubtitle,
          options
        );
      return object;
    };

    /**
     * Converts this BroadcastVolatileMsg to JSON.
     * @function toJSON
     * @memberof live.BroadcastVolatileMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BroadcastVolatileMsg.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BroadcastVolatileMsg;
  })();

  live.BroadcastMsg = (function () {
    /**
     * Properties of a BroadcastMsg.
     * @memberof live
     * @interface IBroadcastMsg
     * @property {base.IBaseResp|null} [baseResp] BroadcastMsg baseResp
     * @property {live.BroadcastMsg.Type|null} [msgType] BroadcastMsg msgType
     * @property {live.IBroadcastFinalMsg|null} [finalMsg] BroadcastMsg finalMsg
     * @property {live.IBroadcastVolatileMsg|null} [volatileMsg] BroadcastMsg volatileMsg
     * @property {live.ITerminalInfo|null} [terminalInfo] BroadcastMsg terminalInfo
     */

    /**
     * Constructs a new BroadcastMsg.
     * @memberof live
     * @classdesc Represents a BroadcastMsg.
     * @implements IBroadcastMsg
     * @constructor
     * @param {live.IBroadcastMsg=} [properties] Properties to set
     */
    function BroadcastMsg(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * BroadcastMsg baseResp.
     * @member {base.IBaseResp|null|undefined} baseResp
     * @memberof live.BroadcastMsg
     * @instance
     */
    BroadcastMsg.prototype.baseResp = null;

    /**
     * BroadcastMsg msgType.
     * @member {live.BroadcastMsg.Type} msgType
     * @memberof live.BroadcastMsg
     * @instance
     */
    BroadcastMsg.prototype.msgType = 0;

    /**
     * BroadcastMsg finalMsg.
     * @member {live.IBroadcastFinalMsg|null|undefined} finalMsg
     * @memberof live.BroadcastMsg
     * @instance
     */
    BroadcastMsg.prototype.finalMsg = null;

    /**
     * BroadcastMsg volatileMsg.
     * @member {live.IBroadcastVolatileMsg|null|undefined} volatileMsg
     * @memberof live.BroadcastMsg
     * @instance
     */
    BroadcastMsg.prototype.volatileMsg = null;

    /**
     * BroadcastMsg terminalInfo.
     * @member {live.ITerminalInfo|null|undefined} terminalInfo
     * @memberof live.BroadcastMsg
     * @instance
     */
    BroadcastMsg.prototype.terminalInfo = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * BroadcastMsg msg.
     * @member {"finalMsg"|"volatileMsg"|undefined} msg
     * @memberof live.BroadcastMsg
     * @instance
     */
    Object.defineProperty(BroadcastMsg.prototype, 'msg', {
      get: $util.oneOfGetter(($oneOfFields = ['finalMsg', 'volatileMsg'])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new BroadcastMsg instance using the specified properties.
     * @function create
     * @memberof live.BroadcastMsg
     * @static
     * @param {live.IBroadcastMsg=} [properties] Properties to set
     * @returns {live.BroadcastMsg} BroadcastMsg instance
     */
    BroadcastMsg.create = function create(properties) {
      return new BroadcastMsg(properties);
    };

    /**
     * Encodes the specified BroadcastMsg message. Does not implicitly {@link live.BroadcastMsg.verify|verify} messages.
     * @function encode
     * @memberof live.BroadcastMsg
     * @static
     * @param {live.IBroadcastMsg} message BroadcastMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BroadcastMsg.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.baseResp != null &&
        Object.hasOwnProperty.call(message, 'baseResp')
      )
        $root.base.BaseResp.encode(
          message.baseResp,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.msgType != null &&
        Object.hasOwnProperty.call(message, 'msgType')
      )
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.msgType);
      if (
        message.finalMsg != null &&
        Object.hasOwnProperty.call(message, 'finalMsg')
      )
        $root.live.BroadcastFinalMsg.encode(
          message.finalMsg,
          writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
        ).ldelim();
      if (
        message.volatileMsg != null &&
        Object.hasOwnProperty.call(message, 'volatileMsg')
      )
        $root.live.BroadcastVolatileMsg.encode(
          message.volatileMsg,
          writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
        ).ldelim();
      if (
        message.terminalInfo != null &&
        Object.hasOwnProperty.call(message, 'terminalInfo')
      )
        $root.live.TerminalInfo.encode(
          message.terminalInfo,
          writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified BroadcastMsg message, length delimited. Does not implicitly {@link live.BroadcastMsg.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.BroadcastMsg
     * @static
     * @param {live.IBroadcastMsg} message BroadcastMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BroadcastMsg.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BroadcastMsg message from the specified reader or buffer.
     * @function decode
     * @memberof live.BroadcastMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.BroadcastMsg} BroadcastMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BroadcastMsg.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.BroadcastMsg();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.baseResp = $root.base.BaseResp.decode(
              reader,
              reader.uint32()
            );
            break;
          case 2:
            message.msgType = reader.int32();
            break;
          case 3:
            message.finalMsg = $root.live.BroadcastFinalMsg.decode(
              reader,
              reader.uint32()
            );
            break;
          case 4:
            message.volatileMsg = $root.live.BroadcastVolatileMsg.decode(
              reader,
              reader.uint32()
            );
            break;
          case 5:
            message.terminalInfo = $root.live.TerminalInfo.decode(
              reader,
              reader.uint32()
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a BroadcastMsg message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.BroadcastMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.BroadcastMsg} BroadcastMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BroadcastMsg.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BroadcastMsg message.
     * @function verify
     * @memberof live.BroadcastMsg
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BroadcastMsg.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      let properties = {};
      if (message.baseResp != null && message.hasOwnProperty('baseResp')) {
        let error = $root.base.BaseResp.verify(message.baseResp);
        if (error) return 'baseResp.' + error;
      }
      if (message.msgType != null && message.hasOwnProperty('msgType'))
        switch (message.msgType) {
          default:
            return 'msgType: enum value expected';
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.finalMsg != null && message.hasOwnProperty('finalMsg')) {
        properties.msg = 1;
        {
          let error = $root.live.BroadcastFinalMsg.verify(message.finalMsg);
          if (error) return 'finalMsg.' + error;
        }
      }
      if (
        message.volatileMsg != null &&
        message.hasOwnProperty('volatileMsg')
      ) {
        if (properties.msg === 1) return 'msg: multiple values';
        properties.msg = 1;
        {
          let error = $root.live.BroadcastVolatileMsg.verify(
            message.volatileMsg
          );
          if (error) return 'volatileMsg.' + error;
        }
      }
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      ) {
        let error = $root.live.TerminalInfo.verify(message.terminalInfo);
        if (error) return 'terminalInfo.' + error;
      }
      return null;
    };

    /**
     * Creates a BroadcastMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.BroadcastMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.BroadcastMsg} BroadcastMsg
     */
    BroadcastMsg.fromObject = function fromObject(object) {
      if (object instanceof $root.live.BroadcastMsg) return object;
      let message = new $root.live.BroadcastMsg();
      if (object.baseResp != null) {
        if (typeof object.baseResp !== 'object')
          throw TypeError('.live.BroadcastMsg.baseResp: object expected');
        message.baseResp = $root.base.BaseResp.fromObject(object.baseResp);
      }
      switch (object.msgType) {
        case 'UNSPECIFIED':
        case 0:
          message.msgType = 0;
          break;
        case 'FINAL':
        case 1:
          message.msgType = 1;
          break;
        case 'VOLATILE':
        case 2:
          message.msgType = 2;
          break;
      }
      if (object.finalMsg != null) {
        if (typeof object.finalMsg !== 'object')
          throw TypeError('.live.BroadcastMsg.finalMsg: object expected');
        message.finalMsg = $root.live.BroadcastFinalMsg.fromObject(
          object.finalMsg
        );
      }
      if (object.volatileMsg != null) {
        if (typeof object.volatileMsg !== 'object')
          throw TypeError('.live.BroadcastMsg.volatileMsg: object expected');
        message.volatileMsg = $root.live.BroadcastVolatileMsg.fromObject(
          object.volatileMsg
        );
      }
      if (object.terminalInfo != null) {
        if (typeof object.terminalInfo !== 'object')
          throw TypeError('.live.BroadcastMsg.terminalInfo: object expected');
        message.terminalInfo = $root.live.TerminalInfo.fromObject(
          object.terminalInfo
        );
      }
      return message;
    };

    /**
     * Creates a plain object from a BroadcastMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.BroadcastMsg
     * @static
     * @param {live.BroadcastMsg} message BroadcastMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BroadcastMsg.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.baseResp = null;
        object.msgType = options.enums === String ? 'UNSPECIFIED' : 0;
        object.terminalInfo = null;
      }
      if (message.baseResp != null && message.hasOwnProperty('baseResp'))
        object.baseResp = $root.base.BaseResp.toObject(
          message.baseResp,
          options
        );
      if (message.msgType != null && message.hasOwnProperty('msgType'))
        object.msgType =
          options.enums === String
            ? $root.live.BroadcastMsg.Type[message.msgType]
            : message.msgType;
      if (message.finalMsg != null && message.hasOwnProperty('finalMsg')) {
        object.finalMsg = $root.live.BroadcastFinalMsg.toObject(
          message.finalMsg,
          options
        );
        if (options.oneofs) object.msg = 'finalMsg';
      }
      if (
        message.volatileMsg != null &&
        message.hasOwnProperty('volatileMsg')
      ) {
        object.volatileMsg = $root.live.BroadcastVolatileMsg.toObject(
          message.volatileMsg,
          options
        );
        if (options.oneofs) object.msg = 'volatileMsg';
      }
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      )
        object.terminalInfo = $root.live.TerminalInfo.toObject(
          message.terminalInfo,
          options
        );
      return object;
    };

    /**
     * Converts this BroadcastMsg to JSON.
     * @function toJSON
     * @memberof live.BroadcastMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BroadcastMsg.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Type enum.
     * @name live.BroadcastMsg.Type
     * @enum {number}
     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
     * @property {number} FINAL=1 FINAL value
     * @property {number} VOLATILE=2 VOLATILE value
     */
    BroadcastMsg.Type = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'UNSPECIFIED')] = 0;
      values[(valuesById[1] = 'FINAL')] = 1;
      values[(valuesById[2] = 'VOLATILE')] = 2;
      return values;
    })();

    return BroadcastMsg;
  })();

  live.TerminalInfo = (function () {
    /**
     * Properties of a TerminalInfo.
     * @memberof live
     * @interface ITerminalInfo
     * @property {number|null} [deviceId] TerminalInfo deviceId
     * @property {number|null} [nid] TerminalInfo nid
     * @property {string|null} [cid] TerminalInfo cid
     */

    /**
     * Constructs a new TerminalInfo.
     * @memberof live
     * @classdesc Represents a TerminalInfo.
     * @implements ITerminalInfo
     * @constructor
     * @param {live.ITerminalInfo=} [properties] Properties to set
     */
    function TerminalInfo(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * TerminalInfo deviceId.
     * @member {number} deviceId
     * @memberof live.TerminalInfo
     * @instance
     */
    TerminalInfo.prototype.deviceId = 0;

    /**
     * TerminalInfo nid.
     * @member {number} nid
     * @memberof live.TerminalInfo
     * @instance
     */
    TerminalInfo.prototype.nid = 0;

    /**
     * TerminalInfo cid.
     * @member {string} cid
     * @memberof live.TerminalInfo
     * @instance
     */
    TerminalInfo.prototype.cid = '';

    /**
     * Creates a new TerminalInfo instance using the specified properties.
     * @function create
     * @memberof live.TerminalInfo
     * @static
     * @param {live.ITerminalInfo=} [properties] Properties to set
     * @returns {live.TerminalInfo} TerminalInfo instance
     */
    TerminalInfo.create = function create(properties) {
      return new TerminalInfo(properties);
    };

    /**
     * Encodes the specified TerminalInfo message. Does not implicitly {@link live.TerminalInfo.verify|verify} messages.
     * @function encode
     * @memberof live.TerminalInfo
     * @static
     * @param {live.ITerminalInfo} message TerminalInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TerminalInfo.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.deviceId != null &&
        Object.hasOwnProperty.call(message, 'deviceId')
      )
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.deviceId);
      if (message.nid != null && Object.hasOwnProperty.call(message, 'nid'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.nid);
      if (message.cid != null && Object.hasOwnProperty.call(message, 'cid'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.cid);
      return writer;
    };

    /**
     * Encodes the specified TerminalInfo message, length delimited. Does not implicitly {@link live.TerminalInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.TerminalInfo
     * @static
     * @param {live.ITerminalInfo} message TerminalInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TerminalInfo.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TerminalInfo message from the specified reader or buffer.
     * @function decode
     * @memberof live.TerminalInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.TerminalInfo} TerminalInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TerminalInfo.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.TerminalInfo();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.deviceId = reader.int32();
            break;
          case 2:
            message.nid = reader.int32();
            break;
          case 3:
            message.cid = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a TerminalInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.TerminalInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.TerminalInfo} TerminalInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TerminalInfo.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TerminalInfo message.
     * @function verify
     * @memberof live.TerminalInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TerminalInfo.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.deviceId != null && message.hasOwnProperty('deviceId'))
        if (!$util.isInteger(message.deviceId))
          return 'deviceId: integer expected';
      if (message.nid != null && message.hasOwnProperty('nid'))
        if (!$util.isInteger(message.nid)) return 'nid: integer expected';
      if (message.cid != null && message.hasOwnProperty('cid'))
        if (!$util.isString(message.cid)) return 'cid: string expected';
      return null;
    };

    /**
     * Creates a TerminalInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.TerminalInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.TerminalInfo} TerminalInfo
     */
    TerminalInfo.fromObject = function fromObject(object) {
      if (object instanceof $root.live.TerminalInfo) return object;
      let message = new $root.live.TerminalInfo();
      if (object.deviceId != null) message.deviceId = object.deviceId | 0;
      if (object.nid != null) message.nid = object.nid | 0;
      if (object.cid != null) message.cid = String(object.cid);
      return message;
    };

    /**
     * Creates a plain object from a TerminalInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.TerminalInfo
     * @static
     * @param {live.TerminalInfo} message TerminalInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TerminalInfo.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.deviceId = 0;
        object.nid = 0;
        object.cid = '';
      }
      if (message.deviceId != null && message.hasOwnProperty('deviceId'))
        object.deviceId = message.deviceId;
      if (message.nid != null && message.hasOwnProperty('nid'))
        object.nid = message.nid;
      if (message.cid != null && message.hasOwnProperty('cid'))
        object.cid = message.cid;
      return object;
    };

    /**
     * Converts this TerminalInfo to JSON.
     * @function toJSON
     * @memberof live.TerminalInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TerminalInfo.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TerminalInfo;
  })();

  live.ConferenceInfo = (function () {
    /**
     * Properties of a ConferenceInfo.
     * @memberof live
     * @interface IConferenceInfo
     * @property {string|null} [cname] ConferenceInfo cname
     * @property {Array.<base.IMapEntry>|null} [entry] ConferenceInfo entry
     */

    /**
     * Constructs a new ConferenceInfo.
     * @memberof live
     * @classdesc Represents a ConferenceInfo.
     * @implements IConferenceInfo
     * @constructor
     * @param {live.IConferenceInfo=} [properties] Properties to set
     */
    function ConferenceInfo(properties) {
      this.entry = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * ConferenceInfo cname.
     * @member {string} cname
     * @memberof live.ConferenceInfo
     * @instance
     */
    ConferenceInfo.prototype.cname = '';

    /**
     * ConferenceInfo entry.
     * @member {Array.<base.IMapEntry>} entry
     * @memberof live.ConferenceInfo
     * @instance
     */
    ConferenceInfo.prototype.entry = $util.emptyArray;

    /**
     * Creates a new ConferenceInfo instance using the specified properties.
     * @function create
     * @memberof live.ConferenceInfo
     * @static
     * @param {live.IConferenceInfo=} [properties] Properties to set
     * @returns {live.ConferenceInfo} ConferenceInfo instance
     */
    ConferenceInfo.create = function create(properties) {
      return new ConferenceInfo(properties);
    };

    /**
     * Encodes the specified ConferenceInfo message. Does not implicitly {@link live.ConferenceInfo.verify|verify} messages.
     * @function encode
     * @memberof live.ConferenceInfo
     * @static
     * @param {live.IConferenceInfo} message ConferenceInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ConferenceInfo.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.cname != null && Object.hasOwnProperty.call(message, 'cname'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.cname);
      if (message.entry != null && message.entry.length)
        for (let i = 0; i < message.entry.length; ++i)
          $root.base.MapEntry.encode(
            message.entry[i],
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified ConferenceInfo message, length delimited. Does not implicitly {@link live.ConferenceInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.ConferenceInfo
     * @static
     * @param {live.IConferenceInfo} message ConferenceInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ConferenceInfo.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ConferenceInfo message from the specified reader or buffer.
     * @function decode
     * @memberof live.ConferenceInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.ConferenceInfo} ConferenceInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ConferenceInfo.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.ConferenceInfo();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.cname = reader.string();
            break;
          case 2:
            if (!(message.entry && message.entry.length)) message.entry = [];
            message.entry.push(
              $root.base.MapEntry.decode(reader, reader.uint32())
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a ConferenceInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.ConferenceInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.ConferenceInfo} ConferenceInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ConferenceInfo.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ConferenceInfo message.
     * @function verify
     * @memberof live.ConferenceInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ConferenceInfo.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.cname != null && message.hasOwnProperty('cname'))
        if (!$util.isString(message.cname)) return 'cname: string expected';
      if (message.entry != null && message.hasOwnProperty('entry')) {
        if (!Array.isArray(message.entry)) return 'entry: array expected';
        for (let i = 0; i < message.entry.length; ++i) {
          let error = $root.base.MapEntry.verify(message.entry[i]);
          if (error) return 'entry.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a ConferenceInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.ConferenceInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.ConferenceInfo} ConferenceInfo
     */
    ConferenceInfo.fromObject = function fromObject(object) {
      if (object instanceof $root.live.ConferenceInfo) return object;
      let message = new $root.live.ConferenceInfo();
      if (object.cname != null) message.cname = String(object.cname);
      if (object.entry) {
        if (!Array.isArray(object.entry))
          throw TypeError('.live.ConferenceInfo.entry: array expected');
        message.entry = [];
        for (let i = 0; i < object.entry.length; ++i) {
          if (typeof object.entry[i] !== 'object')
            throw TypeError('.live.ConferenceInfo.entry: object expected');
          message.entry[i] = $root.base.MapEntry.fromObject(object.entry[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a ConferenceInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.ConferenceInfo
     * @static
     * @param {live.ConferenceInfo} message ConferenceInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ConferenceInfo.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.entry = [];
      if (options.defaults) object.cname = '';
      if (message.cname != null && message.hasOwnProperty('cname'))
        object.cname = message.cname;
      if (message.entry && message.entry.length) {
        object.entry = [];
        for (let j = 0; j < message.entry.length; ++j)
          object.entry[j] = $root.base.MapEntry.toObject(
            message.entry[j],
            options
          );
      }
      return object;
    };

    /**
     * Converts this ConferenceInfo to JSON.
     * @function toJSON
     * @memberof live.ConferenceInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ConferenceInfo.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConferenceInfo;
  })();

  live.GetLatestFinalSubtitleReq = (function () {
    /**
     * Properties of a GetLatestFinalSubtitleReq.
     * @memberof live
     * @interface IGetLatestFinalSubtitleReq
     * @property {base.IBase|null} [base] GetLatestFinalSubtitleReq base
     * @property {live.ITerminalInfo|null} [terminalInfo] GetLatestFinalSubtitleReq terminalInfo
     * @property {string|null} [language] GetLatestFinalSubtitleReq language
     * @property {boolean|null} [isSpoken] GetLatestFinalSubtitleReq isSpoken
     */

    /**
     * Constructs a new GetLatestFinalSubtitleReq.
     * @memberof live
     * @classdesc Represents a GetLatestFinalSubtitleReq.
     * @implements IGetLatestFinalSubtitleReq
     * @constructor
     * @param {live.IGetLatestFinalSubtitleReq=} [properties] Properties to set
     */
    function GetLatestFinalSubtitleReq(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetLatestFinalSubtitleReq base.
     * @member {base.IBase|null|undefined} base
     * @memberof live.GetLatestFinalSubtitleReq
     * @instance
     */
    GetLatestFinalSubtitleReq.prototype.base = null;

    /**
     * GetLatestFinalSubtitleReq terminalInfo.
     * @member {live.ITerminalInfo|null|undefined} terminalInfo
     * @memberof live.GetLatestFinalSubtitleReq
     * @instance
     */
    GetLatestFinalSubtitleReq.prototype.terminalInfo = null;

    /**
     * GetLatestFinalSubtitleReq language.
     * @member {string} language
     * @memberof live.GetLatestFinalSubtitleReq
     * @instance
     */
    GetLatestFinalSubtitleReq.prototype.language = '';

    /**
     * GetLatestFinalSubtitleReq isSpoken.
     * @member {boolean} isSpoken
     * @memberof live.GetLatestFinalSubtitleReq
     * @instance
     */
    GetLatestFinalSubtitleReq.prototype.isSpoken = false;

    /**
     * Creates a new GetLatestFinalSubtitleReq instance using the specified properties.
     * @function create
     * @memberof live.GetLatestFinalSubtitleReq
     * @static
     * @param {live.IGetLatestFinalSubtitleReq=} [properties] Properties to set
     * @returns {live.GetLatestFinalSubtitleReq} GetLatestFinalSubtitleReq instance
     */
    GetLatestFinalSubtitleReq.create = function create(properties) {
      return new GetLatestFinalSubtitleReq(properties);
    };

    /**
     * Encodes the specified GetLatestFinalSubtitleReq message. Does not implicitly {@link live.GetLatestFinalSubtitleReq.verify|verify} messages.
     * @function encode
     * @memberof live.GetLatestFinalSubtitleReq
     * @static
     * @param {live.IGetLatestFinalSubtitleReq} message GetLatestFinalSubtitleReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetLatestFinalSubtitleReq.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.base != null && Object.hasOwnProperty.call(message, 'base'))
        $root.base.Base.encode(
          message.base,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.terminalInfo != null &&
        Object.hasOwnProperty.call(message, 'terminalInfo')
      )
        $root.live.TerminalInfo.encode(
          message.terminalInfo,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      if (
        message.language != null &&
        Object.hasOwnProperty.call(message, 'language')
      )
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.language);
      if (
        message.isSpoken != null &&
        Object.hasOwnProperty.call(message, 'isSpoken')
      )
        writer.uint32(/* id 4, wireType 0 =*/ 32).bool(message.isSpoken);
      return writer;
    };

    /**
     * Encodes the specified GetLatestFinalSubtitleReq message, length delimited. Does not implicitly {@link live.GetLatestFinalSubtitleReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.GetLatestFinalSubtitleReq
     * @static
     * @param {live.IGetLatestFinalSubtitleReq} message GetLatestFinalSubtitleReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetLatestFinalSubtitleReq.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetLatestFinalSubtitleReq message from the specified reader or buffer.
     * @function decode
     * @memberof live.GetLatestFinalSubtitleReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.GetLatestFinalSubtitleReq} GetLatestFinalSubtitleReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetLatestFinalSubtitleReq.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.GetLatestFinalSubtitleReq();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.base = $root.base.Base.decode(reader, reader.uint32());
            break;
          case 2:
            message.terminalInfo = $root.live.TerminalInfo.decode(
              reader,
              reader.uint32()
            );
            break;
          case 3:
            message.language = reader.string();
            break;
          case 4:
            message.isSpoken = reader.bool();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a GetLatestFinalSubtitleReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.GetLatestFinalSubtitleReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.GetLatestFinalSubtitleReq} GetLatestFinalSubtitleReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetLatestFinalSubtitleReq.decodeDelimited = function decodeDelimited(
      reader
    ) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetLatestFinalSubtitleReq message.
     * @function verify
     * @memberof live.GetLatestFinalSubtitleReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetLatestFinalSubtitleReq.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.base != null && message.hasOwnProperty('base')) {
        let error = $root.base.Base.verify(message.base);
        if (error) return 'base.' + error;
      }
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      ) {
        let error = $root.live.TerminalInfo.verify(message.terminalInfo);
        if (error) return 'terminalInfo.' + error;
      }
      if (message.language != null && message.hasOwnProperty('language'))
        if (!$util.isString(message.language))
          return 'language: string expected';
      if (message.isSpoken != null && message.hasOwnProperty('isSpoken'))
        if (typeof message.isSpoken !== 'boolean')
          return 'isSpoken: boolean expected';
      return null;
    };

    /**
     * Creates a GetLatestFinalSubtitleReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.GetLatestFinalSubtitleReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.GetLatestFinalSubtitleReq} GetLatestFinalSubtitleReq
     */
    GetLatestFinalSubtitleReq.fromObject = function fromObject(object) {
      if (object instanceof $root.live.GetLatestFinalSubtitleReq) return object;
      let message = new $root.live.GetLatestFinalSubtitleReq();
      if (object.base != null) {
        if (typeof object.base !== 'object')
          throw TypeError(
            '.live.GetLatestFinalSubtitleReq.base: object expected'
          );
        message.base = $root.base.Base.fromObject(object.base);
      }
      if (object.terminalInfo != null) {
        if (typeof object.terminalInfo !== 'object')
          throw TypeError(
            '.live.GetLatestFinalSubtitleReq.terminalInfo: object expected'
          );
        message.terminalInfo = $root.live.TerminalInfo.fromObject(
          object.terminalInfo
        );
      }
      if (object.language != null) message.language = String(object.language);
      if (object.isSpoken != null) message.isSpoken = Boolean(object.isSpoken);
      return message;
    };

    /**
     * Creates a plain object from a GetLatestFinalSubtitleReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.GetLatestFinalSubtitleReq
     * @static
     * @param {live.GetLatestFinalSubtitleReq} message GetLatestFinalSubtitleReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetLatestFinalSubtitleReq.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.base = null;
        object.terminalInfo = null;
        object.language = '';
        object.isSpoken = false;
      }
      if (message.base != null && message.hasOwnProperty('base'))
        object.base = $root.base.Base.toObject(message.base, options);
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      )
        object.terminalInfo = $root.live.TerminalInfo.toObject(
          message.terminalInfo,
          options
        );
      if (message.language != null && message.hasOwnProperty('language'))
        object.language = message.language;
      if (message.isSpoken != null && message.hasOwnProperty('isSpoken'))
        object.isSpoken = message.isSpoken;
      return object;
    };

    /**
     * Converts this GetLatestFinalSubtitleReq to JSON.
     * @function toJSON
     * @memberof live.GetLatestFinalSubtitleReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetLatestFinalSubtitleReq.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetLatestFinalSubtitleReq;
  })();

  live.GetLatestFinalSubtitleResp = (function () {
    /**
     * Properties of a GetLatestFinalSubtitleResp.
     * @memberof live
     * @interface IGetLatestFinalSubtitleResp
     * @property {base.IBaseResp|null} [baseResp] GetLatestFinalSubtitleResp baseResp
     * @property {live.IFinalSubtitle|null} [finalSubtitle] GetLatestFinalSubtitleResp finalSubtitle
     */

    /**
     * Constructs a new GetLatestFinalSubtitleResp.
     * @memberof live
     * @classdesc Represents a GetLatestFinalSubtitleResp.
     * @implements IGetLatestFinalSubtitleResp
     * @constructor
     * @param {live.IGetLatestFinalSubtitleResp=} [properties] Properties to set
     */
    function GetLatestFinalSubtitleResp(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetLatestFinalSubtitleResp baseResp.
     * @member {base.IBaseResp|null|undefined} baseResp
     * @memberof live.GetLatestFinalSubtitleResp
     * @instance
     */
    GetLatestFinalSubtitleResp.prototype.baseResp = null;

    /**
     * GetLatestFinalSubtitleResp finalSubtitle.
     * @member {live.IFinalSubtitle|null|undefined} finalSubtitle
     * @memberof live.GetLatestFinalSubtitleResp
     * @instance
     */
    GetLatestFinalSubtitleResp.prototype.finalSubtitle = null;

    /**
     * Creates a new GetLatestFinalSubtitleResp instance using the specified properties.
     * @function create
     * @memberof live.GetLatestFinalSubtitleResp
     * @static
     * @param {live.IGetLatestFinalSubtitleResp=} [properties] Properties to set
     * @returns {live.GetLatestFinalSubtitleResp} GetLatestFinalSubtitleResp instance
     */
    GetLatestFinalSubtitleResp.create = function create(properties) {
      return new GetLatestFinalSubtitleResp(properties);
    };

    /**
     * Encodes the specified GetLatestFinalSubtitleResp message. Does not implicitly {@link live.GetLatestFinalSubtitleResp.verify|verify} messages.
     * @function encode
     * @memberof live.GetLatestFinalSubtitleResp
     * @static
     * @param {live.IGetLatestFinalSubtitleResp} message GetLatestFinalSubtitleResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetLatestFinalSubtitleResp.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.baseResp != null &&
        Object.hasOwnProperty.call(message, 'baseResp')
      )
        $root.base.BaseResp.encode(
          message.baseResp,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.finalSubtitle != null &&
        Object.hasOwnProperty.call(message, 'finalSubtitle')
      )
        $root.live.FinalSubtitle.encode(
          message.finalSubtitle,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified GetLatestFinalSubtitleResp message, length delimited. Does not implicitly {@link live.GetLatestFinalSubtitleResp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.GetLatestFinalSubtitleResp
     * @static
     * @param {live.IGetLatestFinalSubtitleResp} message GetLatestFinalSubtitleResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetLatestFinalSubtitleResp.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetLatestFinalSubtitleResp message from the specified reader or buffer.
     * @function decode
     * @memberof live.GetLatestFinalSubtitleResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.GetLatestFinalSubtitleResp} GetLatestFinalSubtitleResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetLatestFinalSubtitleResp.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.GetLatestFinalSubtitleResp();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.baseResp = $root.base.BaseResp.decode(
              reader,
              reader.uint32()
            );
            break;
          case 2:
            message.finalSubtitle = $root.live.FinalSubtitle.decode(
              reader,
              reader.uint32()
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a GetLatestFinalSubtitleResp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.GetLatestFinalSubtitleResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.GetLatestFinalSubtitleResp} GetLatestFinalSubtitleResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetLatestFinalSubtitleResp.decodeDelimited = function decodeDelimited(
      reader
    ) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetLatestFinalSubtitleResp message.
     * @function verify
     * @memberof live.GetLatestFinalSubtitleResp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetLatestFinalSubtitleResp.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.baseResp != null && message.hasOwnProperty('baseResp')) {
        let error = $root.base.BaseResp.verify(message.baseResp);
        if (error) return 'baseResp.' + error;
      }
      if (
        message.finalSubtitle != null &&
        message.hasOwnProperty('finalSubtitle')
      ) {
        let error = $root.live.FinalSubtitle.verify(message.finalSubtitle);
        if (error) return 'finalSubtitle.' + error;
      }
      return null;
    };

    /**
     * Creates a GetLatestFinalSubtitleResp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.GetLatestFinalSubtitleResp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.GetLatestFinalSubtitleResp} GetLatestFinalSubtitleResp
     */
    GetLatestFinalSubtitleResp.fromObject = function fromObject(object) {
      if (object instanceof $root.live.GetLatestFinalSubtitleResp)
        return object;
      let message = new $root.live.GetLatestFinalSubtitleResp();
      if (object.baseResp != null) {
        if (typeof object.baseResp !== 'object')
          throw TypeError(
            '.live.GetLatestFinalSubtitleResp.baseResp: object expected'
          );
        message.baseResp = $root.base.BaseResp.fromObject(object.baseResp);
      }
      if (object.finalSubtitle != null) {
        if (typeof object.finalSubtitle !== 'object')
          throw TypeError(
            '.live.GetLatestFinalSubtitleResp.finalSubtitle: object expected'
          );
        message.finalSubtitle = $root.live.FinalSubtitle.fromObject(
          object.finalSubtitle
        );
      }
      return message;
    };

    /**
     * Creates a plain object from a GetLatestFinalSubtitleResp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.GetLatestFinalSubtitleResp
     * @static
     * @param {live.GetLatestFinalSubtitleResp} message GetLatestFinalSubtitleResp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetLatestFinalSubtitleResp.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.baseResp = null;
        object.finalSubtitle = null;
      }
      if (message.baseResp != null && message.hasOwnProperty('baseResp'))
        object.baseResp = $root.base.BaseResp.toObject(
          message.baseResp,
          options
        );
      if (
        message.finalSubtitle != null &&
        message.hasOwnProperty('finalSubtitle')
      )
        object.finalSubtitle = $root.live.FinalSubtitle.toObject(
          message.finalSubtitle,
          options
        );
      return object;
    };

    /**
     * Converts this GetLatestFinalSubtitleResp to JSON.
     * @function toJSON
     * @memberof live.GetLatestFinalSubtitleResp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetLatestFinalSubtitleResp.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetLatestFinalSubtitleResp;
  })();

  live.GetFinalSubtitlesReq = (function () {
    /**
     * Properties of a GetFinalSubtitlesReq.
     * @memberof live
     * @interface IGetFinalSubtitlesReq
     * @property {base.IBase|null} [base] GetFinalSubtitlesReq base
     * @property {live.ITerminalInfo|null} [terminalInfo] GetFinalSubtitlesReq terminalInfo
     * @property {Array.<number>|null} [keyList] GetFinalSubtitlesReq keyList
     * @property {string|null} [language] GetFinalSubtitlesReq language
     * @property {boolean|null} [isSpoken] GetFinalSubtitlesReq isSpoken
     */

    /**
     * Constructs a new GetFinalSubtitlesReq.
     * @memberof live
     * @classdesc Represents a GetFinalSubtitlesReq.
     * @implements IGetFinalSubtitlesReq
     * @constructor
     * @param {live.IGetFinalSubtitlesReq=} [properties] Properties to set
     */
    function GetFinalSubtitlesReq(properties) {
      this.keyList = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetFinalSubtitlesReq base.
     * @member {base.IBase|null|undefined} base
     * @memberof live.GetFinalSubtitlesReq
     * @instance
     */
    GetFinalSubtitlesReq.prototype.base = null;

    /**
     * GetFinalSubtitlesReq terminalInfo.
     * @member {live.ITerminalInfo|null|undefined} terminalInfo
     * @memberof live.GetFinalSubtitlesReq
     * @instance
     */
    GetFinalSubtitlesReq.prototype.terminalInfo = null;

    /**
     * GetFinalSubtitlesReq keyList.
     * @member {Array.<number>} keyList
     * @memberof live.GetFinalSubtitlesReq
     * @instance
     */
    GetFinalSubtitlesReq.prototype.keyList = $util.emptyArray;

    /**
     * GetFinalSubtitlesReq language.
     * @member {string} language
     * @memberof live.GetFinalSubtitlesReq
     * @instance
     */
    GetFinalSubtitlesReq.prototype.language = '';

    /**
     * GetFinalSubtitlesReq isSpoken.
     * @member {boolean} isSpoken
     * @memberof live.GetFinalSubtitlesReq
     * @instance
     */
    GetFinalSubtitlesReq.prototype.isSpoken = false;

    /**
     * Creates a new GetFinalSubtitlesReq instance using the specified properties.
     * @function create
     * @memberof live.GetFinalSubtitlesReq
     * @static
     * @param {live.IGetFinalSubtitlesReq=} [properties] Properties to set
     * @returns {live.GetFinalSubtitlesReq} GetFinalSubtitlesReq instance
     */
    GetFinalSubtitlesReq.create = function create(properties) {
      return new GetFinalSubtitlesReq(properties);
    };

    /**
     * Encodes the specified GetFinalSubtitlesReq message. Does not implicitly {@link live.GetFinalSubtitlesReq.verify|verify} messages.
     * @function encode
     * @memberof live.GetFinalSubtitlesReq
     * @static
     * @param {live.IGetFinalSubtitlesReq} message GetFinalSubtitlesReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetFinalSubtitlesReq.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.base != null && Object.hasOwnProperty.call(message, 'base'))
        $root.base.Base.encode(
          message.base,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.terminalInfo != null &&
        Object.hasOwnProperty.call(message, 'terminalInfo')
      )
        $root.live.TerminalInfo.encode(
          message.terminalInfo,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      if (message.keyList != null && message.keyList.length) {
        writer.uint32(/* id 3, wireType 2 =*/ 26).fork();
        for (let i = 0; i < message.keyList.length; ++i)
          writer.int32(message.keyList[i]);
        writer.ldelim();
      }
      if (
        message.language != null &&
        Object.hasOwnProperty.call(message, 'language')
      )
        writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.language);
      if (
        message.isSpoken != null &&
        Object.hasOwnProperty.call(message, 'isSpoken')
      )
        writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.isSpoken);
      return writer;
    };

    /**
     * Encodes the specified GetFinalSubtitlesReq message, length delimited. Does not implicitly {@link live.GetFinalSubtitlesReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.GetFinalSubtitlesReq
     * @static
     * @param {live.IGetFinalSubtitlesReq} message GetFinalSubtitlesReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetFinalSubtitlesReq.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetFinalSubtitlesReq message from the specified reader or buffer.
     * @function decode
     * @memberof live.GetFinalSubtitlesReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.GetFinalSubtitlesReq} GetFinalSubtitlesReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetFinalSubtitlesReq.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.GetFinalSubtitlesReq();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.base = $root.base.Base.decode(reader, reader.uint32());
            break;
          case 2:
            message.terminalInfo = $root.live.TerminalInfo.decode(
              reader,
              reader.uint32()
            );
            break;
          case 3:
            if (!(message.keyList && message.keyList.length))
              message.keyList = [];
            if ((tag & 7) === 2) {
              let end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) message.keyList.push(reader.int32());
            } else message.keyList.push(reader.int32());
            break;
          case 4:
            message.language = reader.string();
            break;
          case 5:
            message.isSpoken = reader.bool();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a GetFinalSubtitlesReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.GetFinalSubtitlesReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.GetFinalSubtitlesReq} GetFinalSubtitlesReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetFinalSubtitlesReq.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetFinalSubtitlesReq message.
     * @function verify
     * @memberof live.GetFinalSubtitlesReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetFinalSubtitlesReq.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.base != null && message.hasOwnProperty('base')) {
        let error = $root.base.Base.verify(message.base);
        if (error) return 'base.' + error;
      }
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      ) {
        let error = $root.live.TerminalInfo.verify(message.terminalInfo);
        if (error) return 'terminalInfo.' + error;
      }
      if (message.keyList != null && message.hasOwnProperty('keyList')) {
        if (!Array.isArray(message.keyList)) return 'keyList: array expected';
        for (let i = 0; i < message.keyList.length; ++i)
          if (!$util.isInteger(message.keyList[i]))
            return 'keyList: integer[] expected';
      }
      if (message.language != null && message.hasOwnProperty('language'))
        if (!$util.isString(message.language))
          return 'language: string expected';
      if (message.isSpoken != null && message.hasOwnProperty('isSpoken'))
        if (typeof message.isSpoken !== 'boolean')
          return 'isSpoken: boolean expected';
      return null;
    };

    /**
     * Creates a GetFinalSubtitlesReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.GetFinalSubtitlesReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.GetFinalSubtitlesReq} GetFinalSubtitlesReq
     */
    GetFinalSubtitlesReq.fromObject = function fromObject(object) {
      if (object instanceof $root.live.GetFinalSubtitlesReq) return object;
      let message = new $root.live.GetFinalSubtitlesReq();
      if (object.base != null) {
        if (typeof object.base !== 'object')
          throw TypeError('.live.GetFinalSubtitlesReq.base: object expected');
        message.base = $root.base.Base.fromObject(object.base);
      }
      if (object.terminalInfo != null) {
        if (typeof object.terminalInfo !== 'object')
          throw TypeError(
            '.live.GetFinalSubtitlesReq.terminalInfo: object expected'
          );
        message.terminalInfo = $root.live.TerminalInfo.fromObject(
          object.terminalInfo
        );
      }
      if (object.keyList) {
        if (!Array.isArray(object.keyList))
          throw TypeError('.live.GetFinalSubtitlesReq.keyList: array expected');
        message.keyList = [];
        for (let i = 0; i < object.keyList.length; ++i)
          message.keyList[i] = object.keyList[i] | 0;
      }
      if (object.language != null) message.language = String(object.language);
      if (object.isSpoken != null) message.isSpoken = Boolean(object.isSpoken);
      return message;
    };

    /**
     * Creates a plain object from a GetFinalSubtitlesReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.GetFinalSubtitlesReq
     * @static
     * @param {live.GetFinalSubtitlesReq} message GetFinalSubtitlesReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetFinalSubtitlesReq.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.keyList = [];
      if (options.defaults) {
        object.base = null;
        object.terminalInfo = null;
        object.language = '';
        object.isSpoken = false;
      }
      if (message.base != null && message.hasOwnProperty('base'))
        object.base = $root.base.Base.toObject(message.base, options);
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      )
        object.terminalInfo = $root.live.TerminalInfo.toObject(
          message.terminalInfo,
          options
        );
      if (message.keyList && message.keyList.length) {
        object.keyList = [];
        for (let j = 0; j < message.keyList.length; ++j)
          object.keyList[j] = message.keyList[j];
      }
      if (message.language != null && message.hasOwnProperty('language'))
        object.language = message.language;
      if (message.isSpoken != null && message.hasOwnProperty('isSpoken'))
        object.isSpoken = message.isSpoken;
      return object;
    };

    /**
     * Converts this GetFinalSubtitlesReq to JSON.
     * @function toJSON
     * @memberof live.GetFinalSubtitlesReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetFinalSubtitlesReq.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetFinalSubtitlesReq;
  })();

  live.GetFinalSubtitlesResp = (function () {
    /**
     * Properties of a GetFinalSubtitlesResp.
     * @memberof live
     * @interface IGetFinalSubtitlesResp
     * @property {base.IBaseResp|null} [baseResp] GetFinalSubtitlesResp baseResp
     * @property {Array.<live.IFinalSubtitle>|null} [finalSubtitleList] GetFinalSubtitlesResp finalSubtitleList
     */

    /**
     * Constructs a new GetFinalSubtitlesResp.
     * @memberof live
     * @classdesc Represents a GetFinalSubtitlesResp.
     * @implements IGetFinalSubtitlesResp
     * @constructor
     * @param {live.IGetFinalSubtitlesResp=} [properties] Properties to set
     */
    function GetFinalSubtitlesResp(properties) {
      this.finalSubtitleList = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetFinalSubtitlesResp baseResp.
     * @member {base.IBaseResp|null|undefined} baseResp
     * @memberof live.GetFinalSubtitlesResp
     * @instance
     */
    GetFinalSubtitlesResp.prototype.baseResp = null;

    /**
     * GetFinalSubtitlesResp finalSubtitleList.
     * @member {Array.<live.IFinalSubtitle>} finalSubtitleList
     * @memberof live.GetFinalSubtitlesResp
     * @instance
     */
    GetFinalSubtitlesResp.prototype.finalSubtitleList = $util.emptyArray;

    /**
     * Creates a new GetFinalSubtitlesResp instance using the specified properties.
     * @function create
     * @memberof live.GetFinalSubtitlesResp
     * @static
     * @param {live.IGetFinalSubtitlesResp=} [properties] Properties to set
     * @returns {live.GetFinalSubtitlesResp} GetFinalSubtitlesResp instance
     */
    GetFinalSubtitlesResp.create = function create(properties) {
      return new GetFinalSubtitlesResp(properties);
    };

    /**
     * Encodes the specified GetFinalSubtitlesResp message. Does not implicitly {@link live.GetFinalSubtitlesResp.verify|verify} messages.
     * @function encode
     * @memberof live.GetFinalSubtitlesResp
     * @static
     * @param {live.IGetFinalSubtitlesResp} message GetFinalSubtitlesResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetFinalSubtitlesResp.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.baseResp != null &&
        Object.hasOwnProperty.call(message, 'baseResp')
      )
        $root.base.BaseResp.encode(
          message.baseResp,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (message.finalSubtitleList != null && message.finalSubtitleList.length)
        for (let i = 0; i < message.finalSubtitleList.length; ++i)
          $root.live.FinalSubtitle.encode(
            message.finalSubtitleList[i],
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified GetFinalSubtitlesResp message, length delimited. Does not implicitly {@link live.GetFinalSubtitlesResp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.GetFinalSubtitlesResp
     * @static
     * @param {live.IGetFinalSubtitlesResp} message GetFinalSubtitlesResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetFinalSubtitlesResp.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetFinalSubtitlesResp message from the specified reader or buffer.
     * @function decode
     * @memberof live.GetFinalSubtitlesResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.GetFinalSubtitlesResp} GetFinalSubtitlesResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetFinalSubtitlesResp.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.GetFinalSubtitlesResp();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.baseResp = $root.base.BaseResp.decode(
              reader,
              reader.uint32()
            );
            break;
          case 2:
            if (
              !(message.finalSubtitleList && message.finalSubtitleList.length)
            )
              message.finalSubtitleList = [];
            message.finalSubtitleList.push(
              $root.live.FinalSubtitle.decode(reader, reader.uint32())
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a GetFinalSubtitlesResp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.GetFinalSubtitlesResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.GetFinalSubtitlesResp} GetFinalSubtitlesResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetFinalSubtitlesResp.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetFinalSubtitlesResp message.
     * @function verify
     * @memberof live.GetFinalSubtitlesResp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetFinalSubtitlesResp.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.baseResp != null && message.hasOwnProperty('baseResp')) {
        let error = $root.base.BaseResp.verify(message.baseResp);
        if (error) return 'baseResp.' + error;
      }
      if (
        message.finalSubtitleList != null &&
        message.hasOwnProperty('finalSubtitleList')
      ) {
        if (!Array.isArray(message.finalSubtitleList))
          return 'finalSubtitleList: array expected';
        for (let i = 0; i < message.finalSubtitleList.length; ++i) {
          let error = $root.live.FinalSubtitle.verify(
            message.finalSubtitleList[i]
          );
          if (error) return 'finalSubtitleList.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a GetFinalSubtitlesResp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.GetFinalSubtitlesResp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.GetFinalSubtitlesResp} GetFinalSubtitlesResp
     */
    GetFinalSubtitlesResp.fromObject = function fromObject(object) {
      if (object instanceof $root.live.GetFinalSubtitlesResp) return object;
      let message = new $root.live.GetFinalSubtitlesResp();
      if (object.baseResp != null) {
        if (typeof object.baseResp !== 'object')
          throw TypeError(
            '.live.GetFinalSubtitlesResp.baseResp: object expected'
          );
        message.baseResp = $root.base.BaseResp.fromObject(object.baseResp);
      }
      if (object.finalSubtitleList) {
        if (!Array.isArray(object.finalSubtitleList))
          throw TypeError(
            '.live.GetFinalSubtitlesResp.finalSubtitleList: array expected'
          );
        message.finalSubtitleList = [];
        for (let i = 0; i < object.finalSubtitleList.length; ++i) {
          if (typeof object.finalSubtitleList[i] !== 'object')
            throw TypeError(
              '.live.GetFinalSubtitlesResp.finalSubtitleList: object expected'
            );
          message.finalSubtitleList[i] = $root.live.FinalSubtitle.fromObject(
            object.finalSubtitleList[i]
          );
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a GetFinalSubtitlesResp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.GetFinalSubtitlesResp
     * @static
     * @param {live.GetFinalSubtitlesResp} message GetFinalSubtitlesResp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetFinalSubtitlesResp.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.finalSubtitleList = [];
      if (options.defaults) object.baseResp = null;
      if (message.baseResp != null && message.hasOwnProperty('baseResp'))
        object.baseResp = $root.base.BaseResp.toObject(
          message.baseResp,
          options
        );
      if (message.finalSubtitleList && message.finalSubtitleList.length) {
        object.finalSubtitleList = [];
        for (let j = 0; j < message.finalSubtitleList.length; ++j)
          object.finalSubtitleList[j] = $root.live.FinalSubtitle.toObject(
            message.finalSubtitleList[j],
            options
          );
      }
      return object;
    };

    /**
     * Converts this GetFinalSubtitlesResp to JSON.
     * @function toJSON
     * @memberof live.GetFinalSubtitlesResp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetFinalSubtitlesResp.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetFinalSubtitlesResp;
  })();

  live.UpdateFinalSubtitleReq = (function () {
    /**
     * Properties of an UpdateFinalSubtitleReq.
     * @memberof live
     * @interface IUpdateFinalSubtitleReq
     * @property {base.IBase|null} [base] UpdateFinalSubtitleReq base
     * @property {live.ITerminalInfo|null} [terminalInfo] UpdateFinalSubtitleReq terminalInfo
     * @property {live.IFinalSubtitle|null} [finalSubtitle] UpdateFinalSubtitleReq finalSubtitle
     */

    /**
     * Constructs a new UpdateFinalSubtitleReq.
     * @memberof live
     * @classdesc Represents an UpdateFinalSubtitleReq.
     * @implements IUpdateFinalSubtitleReq
     * @constructor
     * @param {live.IUpdateFinalSubtitleReq=} [properties] Properties to set
     */
    function UpdateFinalSubtitleReq(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateFinalSubtitleReq base.
     * @member {base.IBase|null|undefined} base
     * @memberof live.UpdateFinalSubtitleReq
     * @instance
     */
    UpdateFinalSubtitleReq.prototype.base = null;

    /**
     * UpdateFinalSubtitleReq terminalInfo.
     * @member {live.ITerminalInfo|null|undefined} terminalInfo
     * @memberof live.UpdateFinalSubtitleReq
     * @instance
     */
    UpdateFinalSubtitleReq.prototype.terminalInfo = null;

    /**
     * UpdateFinalSubtitleReq finalSubtitle.
     * @member {live.IFinalSubtitle|null|undefined} finalSubtitle
     * @memberof live.UpdateFinalSubtitleReq
     * @instance
     */
    UpdateFinalSubtitleReq.prototype.finalSubtitle = null;

    /**
     * Creates a new UpdateFinalSubtitleReq instance using the specified properties.
     * @function create
     * @memberof live.UpdateFinalSubtitleReq
     * @static
     * @param {live.IUpdateFinalSubtitleReq=} [properties] Properties to set
     * @returns {live.UpdateFinalSubtitleReq} UpdateFinalSubtitleReq instance
     */
    UpdateFinalSubtitleReq.create = function create(properties) {
      return new UpdateFinalSubtitleReq(properties);
    };

    /**
     * Encodes the specified UpdateFinalSubtitleReq message. Does not implicitly {@link live.UpdateFinalSubtitleReq.verify|verify} messages.
     * @function encode
     * @memberof live.UpdateFinalSubtitleReq
     * @static
     * @param {live.IUpdateFinalSubtitleReq} message UpdateFinalSubtitleReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateFinalSubtitleReq.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.base != null && Object.hasOwnProperty.call(message, 'base'))
        $root.base.Base.encode(
          message.base,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.terminalInfo != null &&
        Object.hasOwnProperty.call(message, 'terminalInfo')
      )
        $root.live.TerminalInfo.encode(
          message.terminalInfo,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      if (
        message.finalSubtitle != null &&
        Object.hasOwnProperty.call(message, 'finalSubtitle')
      )
        $root.live.FinalSubtitle.encode(
          message.finalSubtitle,
          writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified UpdateFinalSubtitleReq message, length delimited. Does not implicitly {@link live.UpdateFinalSubtitleReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.UpdateFinalSubtitleReq
     * @static
     * @param {live.IUpdateFinalSubtitleReq} message UpdateFinalSubtitleReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateFinalSubtitleReq.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateFinalSubtitleReq message from the specified reader or buffer.
     * @function decode
     * @memberof live.UpdateFinalSubtitleReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.UpdateFinalSubtitleReq} UpdateFinalSubtitleReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateFinalSubtitleReq.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.UpdateFinalSubtitleReq();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.base = $root.base.Base.decode(reader, reader.uint32());
            break;
          case 2:
            message.terminalInfo = $root.live.TerminalInfo.decode(
              reader,
              reader.uint32()
            );
            break;
          case 3:
            message.finalSubtitle = $root.live.FinalSubtitle.decode(
              reader,
              reader.uint32()
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an UpdateFinalSubtitleReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.UpdateFinalSubtitleReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.UpdateFinalSubtitleReq} UpdateFinalSubtitleReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateFinalSubtitleReq.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateFinalSubtitleReq message.
     * @function verify
     * @memberof live.UpdateFinalSubtitleReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateFinalSubtitleReq.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.base != null && message.hasOwnProperty('base')) {
        let error = $root.base.Base.verify(message.base);
        if (error) return 'base.' + error;
      }
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      ) {
        let error = $root.live.TerminalInfo.verify(message.terminalInfo);
        if (error) return 'terminalInfo.' + error;
      }
      if (
        message.finalSubtitle != null &&
        message.hasOwnProperty('finalSubtitle')
      ) {
        let error = $root.live.FinalSubtitle.verify(message.finalSubtitle);
        if (error) return 'finalSubtitle.' + error;
      }
      return null;
    };

    /**
     * Creates an UpdateFinalSubtitleReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.UpdateFinalSubtitleReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.UpdateFinalSubtitleReq} UpdateFinalSubtitleReq
     */
    UpdateFinalSubtitleReq.fromObject = function fromObject(object) {
      if (object instanceof $root.live.UpdateFinalSubtitleReq) return object;
      let message = new $root.live.UpdateFinalSubtitleReq();
      if (object.base != null) {
        if (typeof object.base !== 'object')
          throw TypeError('.live.UpdateFinalSubtitleReq.base: object expected');
        message.base = $root.base.Base.fromObject(object.base);
      }
      if (object.terminalInfo != null) {
        if (typeof object.terminalInfo !== 'object')
          throw TypeError(
            '.live.UpdateFinalSubtitleReq.terminalInfo: object expected'
          );
        message.terminalInfo = $root.live.TerminalInfo.fromObject(
          object.terminalInfo
        );
      }
      if (object.finalSubtitle != null) {
        if (typeof object.finalSubtitle !== 'object')
          throw TypeError(
            '.live.UpdateFinalSubtitleReq.finalSubtitle: object expected'
          );
        message.finalSubtitle = $root.live.FinalSubtitle.fromObject(
          object.finalSubtitle
        );
      }
      return message;
    };

    /**
     * Creates a plain object from an UpdateFinalSubtitleReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.UpdateFinalSubtitleReq
     * @static
     * @param {live.UpdateFinalSubtitleReq} message UpdateFinalSubtitleReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateFinalSubtitleReq.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.base = null;
        object.terminalInfo = null;
        object.finalSubtitle = null;
      }
      if (message.base != null && message.hasOwnProperty('base'))
        object.base = $root.base.Base.toObject(message.base, options);
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      )
        object.terminalInfo = $root.live.TerminalInfo.toObject(
          message.terminalInfo,
          options
        );
      if (
        message.finalSubtitle != null &&
        message.hasOwnProperty('finalSubtitle')
      )
        object.finalSubtitle = $root.live.FinalSubtitle.toObject(
          message.finalSubtitle,
          options
        );
      return object;
    };

    /**
     * Converts this UpdateFinalSubtitleReq to JSON.
     * @function toJSON
     * @memberof live.UpdateFinalSubtitleReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateFinalSubtitleReq.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UpdateFinalSubtitleReq;
  })();

  live.UpdateFinalSubtitleResp = (function () {
    /**
     * Properties of an UpdateFinalSubtitleResp.
     * @memberof live
     * @interface IUpdateFinalSubtitleResp
     * @property {base.IBaseResp|null} [baseResp] UpdateFinalSubtitleResp baseResp
     */

    /**
     * Constructs a new UpdateFinalSubtitleResp.
     * @memberof live
     * @classdesc Represents an UpdateFinalSubtitleResp.
     * @implements IUpdateFinalSubtitleResp
     * @constructor
     * @param {live.IUpdateFinalSubtitleResp=} [properties] Properties to set
     */
    function UpdateFinalSubtitleResp(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateFinalSubtitleResp baseResp.
     * @member {base.IBaseResp|null|undefined} baseResp
     * @memberof live.UpdateFinalSubtitleResp
     * @instance
     */
    UpdateFinalSubtitleResp.prototype.baseResp = null;

    /**
     * Creates a new UpdateFinalSubtitleResp instance using the specified properties.
     * @function create
     * @memberof live.UpdateFinalSubtitleResp
     * @static
     * @param {live.IUpdateFinalSubtitleResp=} [properties] Properties to set
     * @returns {live.UpdateFinalSubtitleResp} UpdateFinalSubtitleResp instance
     */
    UpdateFinalSubtitleResp.create = function create(properties) {
      return new UpdateFinalSubtitleResp(properties);
    };

    /**
     * Encodes the specified UpdateFinalSubtitleResp message. Does not implicitly {@link live.UpdateFinalSubtitleResp.verify|verify} messages.
     * @function encode
     * @memberof live.UpdateFinalSubtitleResp
     * @static
     * @param {live.IUpdateFinalSubtitleResp} message UpdateFinalSubtitleResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateFinalSubtitleResp.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.baseResp != null &&
        Object.hasOwnProperty.call(message, 'baseResp')
      )
        $root.base.BaseResp.encode(
          message.baseResp,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified UpdateFinalSubtitleResp message, length delimited. Does not implicitly {@link live.UpdateFinalSubtitleResp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.UpdateFinalSubtitleResp
     * @static
     * @param {live.IUpdateFinalSubtitleResp} message UpdateFinalSubtitleResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateFinalSubtitleResp.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateFinalSubtitleResp message from the specified reader or buffer.
     * @function decode
     * @memberof live.UpdateFinalSubtitleResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.UpdateFinalSubtitleResp} UpdateFinalSubtitleResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateFinalSubtitleResp.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.UpdateFinalSubtitleResp();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.baseResp = $root.base.BaseResp.decode(
              reader,
              reader.uint32()
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an UpdateFinalSubtitleResp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.UpdateFinalSubtitleResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.UpdateFinalSubtitleResp} UpdateFinalSubtitleResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateFinalSubtitleResp.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateFinalSubtitleResp message.
     * @function verify
     * @memberof live.UpdateFinalSubtitleResp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateFinalSubtitleResp.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.baseResp != null && message.hasOwnProperty('baseResp')) {
        let error = $root.base.BaseResp.verify(message.baseResp);
        if (error) return 'baseResp.' + error;
      }
      return null;
    };

    /**
     * Creates an UpdateFinalSubtitleResp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.UpdateFinalSubtitleResp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.UpdateFinalSubtitleResp} UpdateFinalSubtitleResp
     */
    UpdateFinalSubtitleResp.fromObject = function fromObject(object) {
      if (object instanceof $root.live.UpdateFinalSubtitleResp) return object;
      let message = new $root.live.UpdateFinalSubtitleResp();
      if (object.baseResp != null) {
        if (typeof object.baseResp !== 'object')
          throw TypeError(
            '.live.UpdateFinalSubtitleResp.baseResp: object expected'
          );
        message.baseResp = $root.base.BaseResp.fromObject(object.baseResp);
      }
      return message;
    };

    /**
     * Creates a plain object from an UpdateFinalSubtitleResp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.UpdateFinalSubtitleResp
     * @static
     * @param {live.UpdateFinalSubtitleResp} message UpdateFinalSubtitleResp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateFinalSubtitleResp.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.baseResp = null;
      if (message.baseResp != null && message.hasOwnProperty('baseResp'))
        object.baseResp = $root.base.BaseResp.toObject(
          message.baseResp,
          options
        );
      return object;
    };

    /**
     * Converts this UpdateFinalSubtitleResp to JSON.
     * @function toJSON
     * @memberof live.UpdateFinalSubtitleResp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateFinalSubtitleResp.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UpdateFinalSubtitleResp;
  })();

  live.Minutes = (function () {
    /**
     * Properties of a Minutes.
     * @memberof live
     * @interface IMinutes
     * @property {Array.<live.IFinalSubtitle>|null} [subtitles] Minutes subtitles
     */

    /**
     * Constructs a new Minutes.
     * @memberof live
     * @classdesc Represents a Minutes.
     * @implements IMinutes
     * @constructor
     * @param {live.IMinutes=} [properties] Properties to set
     */
    function Minutes(properties) {
      this.subtitles = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Minutes subtitles.
     * @member {Array.<live.IFinalSubtitle>} subtitles
     * @memberof live.Minutes
     * @instance
     */
    Minutes.prototype.subtitles = $util.emptyArray;

    /**
     * Creates a new Minutes instance using the specified properties.
     * @function create
     * @memberof live.Minutes
     * @static
     * @param {live.IMinutes=} [properties] Properties to set
     * @returns {live.Minutes} Minutes instance
     */
    Minutes.create = function create(properties) {
      return new Minutes(properties);
    };

    /**
     * Encodes the specified Minutes message. Does not implicitly {@link live.Minutes.verify|verify} messages.
     * @function encode
     * @memberof live.Minutes
     * @static
     * @param {live.IMinutes} message Minutes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Minutes.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.subtitles != null && message.subtitles.length)
        for (let i = 0; i < message.subtitles.length; ++i)
          $root.live.FinalSubtitle.encode(
            message.subtitles[i],
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified Minutes message, length delimited. Does not implicitly {@link live.Minutes.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.Minutes
     * @static
     * @param {live.IMinutes} message Minutes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Minutes.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Minutes message from the specified reader or buffer.
     * @function decode
     * @memberof live.Minutes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.Minutes} Minutes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Minutes.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.Minutes();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            if (!(message.subtitles && message.subtitles.length))
              message.subtitles = [];
            message.subtitles.push(
              $root.live.FinalSubtitle.decode(reader, reader.uint32())
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Minutes message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.Minutes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.Minutes} Minutes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Minutes.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Minutes message.
     * @function verify
     * @memberof live.Minutes
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Minutes.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.subtitles != null && message.hasOwnProperty('subtitles')) {
        if (!Array.isArray(message.subtitles))
          return 'subtitles: array expected';
        for (let i = 0; i < message.subtitles.length; ++i) {
          let error = $root.live.FinalSubtitle.verify(message.subtitles[i]);
          if (error) return 'subtitles.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a Minutes message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.Minutes
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.Minutes} Minutes
     */
    Minutes.fromObject = function fromObject(object) {
      if (object instanceof $root.live.Minutes) return object;
      let message = new $root.live.Minutes();
      if (object.subtitles) {
        if (!Array.isArray(object.subtitles))
          throw TypeError('.live.Minutes.subtitles: array expected');
        message.subtitles = [];
        for (let i = 0; i < object.subtitles.length; ++i) {
          if (typeof object.subtitles[i] !== 'object')
            throw TypeError('.live.Minutes.subtitles: object expected');
          message.subtitles[i] = $root.live.FinalSubtitle.fromObject(
            object.subtitles[i]
          );
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a Minutes message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.Minutes
     * @static
     * @param {live.Minutes} message Minutes
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Minutes.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.subtitles = [];
      if (message.subtitles && message.subtitles.length) {
        object.subtitles = [];
        for (let j = 0; j < message.subtitles.length; ++j)
          object.subtitles[j] = $root.live.FinalSubtitle.toObject(
            message.subtitles[j],
            options
          );
      }
      return object;
    };

    /**
     * Converts this Minutes to JSON.
     * @function toJSON
     * @memberof live.Minutes
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Minutes.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Minutes;
  })();

  /**
   * MinuteFormat enum.
   * @name live.MinuteFormat
   * @enum {number}
   * @property {number} UNSPECIFIED_FORMAT=0 UNSPECIFIED_FORMAT value
   * @property {number} RAW=1 RAW value
   * @property {number} PLAIN_TEXT=2 PLAIN_TEXT value
   */
  live.MinuteFormat = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UNSPECIFIED_FORMAT')] = 0;
    values[(valuesById[1] = 'RAW')] = 1;
    values[(valuesById[2] = 'PLAIN_TEXT')] = 2;
    return values;
  })();

  /**
   * MinuteType enum.
   * @name live.MinuteType
   * @enum {number}
   * @property {number} UNSPECIFIED_TYPE=0 UNSPECIFIED_TYPE value
   * @property {number} UNMODIFIED_TRANSCRIPTS=1 UNMODIFIED_TRANSCRIPTS value
   * @property {number} MANUAL_EDIT_TRANSCRIPTS=2 MANUAL_EDIT_TRANSCRIPTS value
   * @property {number} MANUAL_EDIT_TRANSLATIONS=4 MANUAL_EDIT_TRANSLATIONS value
   */
  live.MinuteType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UNSPECIFIED_TYPE')] = 0;
    values[(valuesById[1] = 'UNMODIFIED_TRANSCRIPTS')] = 1;
    values[(valuesById[2] = 'MANUAL_EDIT_TRANSCRIPTS')] = 2;
    values[(valuesById[4] = 'MANUAL_EDIT_TRANSLATIONS')] = 4;
    return values;
  })();

  live.OrganizeMinutesReq = (function () {
    /**
     * Properties of an OrganizeMinutesReq.
     * @memberof live
     * @interface IOrganizeMinutesReq
     * @property {base.IBase|null} [base] OrganizeMinutesReq base
     * @property {live.ITerminalInfo|null} [terminalInfo] OrganizeMinutesReq terminalInfo
     * @property {string|null} [name] OrganizeMinutesReq name
     * @property {string|null} [language] OrganizeMinutesReq language
     */

    /**
     * Constructs a new OrganizeMinutesReq.
     * @memberof live
     * @classdesc Represents an OrganizeMinutesReq.
     * @implements IOrganizeMinutesReq
     * @constructor
     * @param {live.IOrganizeMinutesReq=} [properties] Properties to set
     */
    function OrganizeMinutesReq(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * OrganizeMinutesReq base.
     * @member {base.IBase|null|undefined} base
     * @memberof live.OrganizeMinutesReq
     * @instance
     */
    OrganizeMinutesReq.prototype.base = null;

    /**
     * OrganizeMinutesReq terminalInfo.
     * @member {live.ITerminalInfo|null|undefined} terminalInfo
     * @memberof live.OrganizeMinutesReq
     * @instance
     */
    OrganizeMinutesReq.prototype.terminalInfo = null;

    /**
     * OrganizeMinutesReq name.
     * @member {string} name
     * @memberof live.OrganizeMinutesReq
     * @instance
     */
    OrganizeMinutesReq.prototype.name = '';

    /**
     * OrganizeMinutesReq language.
     * @member {string} language
     * @memberof live.OrganizeMinutesReq
     * @instance
     */
    OrganizeMinutesReq.prototype.language = '';

    /**
     * Creates a new OrganizeMinutesReq instance using the specified properties.
     * @function create
     * @memberof live.OrganizeMinutesReq
     * @static
     * @param {live.IOrganizeMinutesReq=} [properties] Properties to set
     * @returns {live.OrganizeMinutesReq} OrganizeMinutesReq instance
     */
    OrganizeMinutesReq.create = function create(properties) {
      return new OrganizeMinutesReq(properties);
    };

    /**
     * Encodes the specified OrganizeMinutesReq message. Does not implicitly {@link live.OrganizeMinutesReq.verify|verify} messages.
     * @function encode
     * @memberof live.OrganizeMinutesReq
     * @static
     * @param {live.IOrganizeMinutesReq} message OrganizeMinutesReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrganizeMinutesReq.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.base != null && Object.hasOwnProperty.call(message, 'base'))
        $root.base.Base.encode(
          message.base,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.terminalInfo != null &&
        Object.hasOwnProperty.call(message, 'terminalInfo')
      )
        $root.live.TerminalInfo.encode(
          message.terminalInfo,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      if (message.name != null && Object.hasOwnProperty.call(message, 'name'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.name);
      if (
        message.language != null &&
        Object.hasOwnProperty.call(message, 'language')
      )
        writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.language);
      return writer;
    };

    /**
     * Encodes the specified OrganizeMinutesReq message, length delimited. Does not implicitly {@link live.OrganizeMinutesReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.OrganizeMinutesReq
     * @static
     * @param {live.IOrganizeMinutesReq} message OrganizeMinutesReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrganizeMinutesReq.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OrganizeMinutesReq message from the specified reader or buffer.
     * @function decode
     * @memberof live.OrganizeMinutesReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.OrganizeMinutesReq} OrganizeMinutesReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrganizeMinutesReq.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.OrganizeMinutesReq();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.base = $root.base.Base.decode(reader, reader.uint32());
            break;
          case 2:
            message.terminalInfo = $root.live.TerminalInfo.decode(
              reader,
              reader.uint32()
            );
            break;
          case 3:
            message.name = reader.string();
            break;
          case 5:
            message.language = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an OrganizeMinutesReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.OrganizeMinutesReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.OrganizeMinutesReq} OrganizeMinutesReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrganizeMinutesReq.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OrganizeMinutesReq message.
     * @function verify
     * @memberof live.OrganizeMinutesReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OrganizeMinutesReq.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.base != null && message.hasOwnProperty('base')) {
        let error = $root.base.Base.verify(message.base);
        if (error) return 'base.' + error;
      }
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      ) {
        let error = $root.live.TerminalInfo.verify(message.terminalInfo);
        if (error) return 'terminalInfo.' + error;
      }
      if (message.name != null && message.hasOwnProperty('name'))
        if (!$util.isString(message.name)) return 'name: string expected';
      if (message.language != null && message.hasOwnProperty('language'))
        if (!$util.isString(message.language))
          return 'language: string expected';
      return null;
    };

    /**
     * Creates an OrganizeMinutesReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.OrganizeMinutesReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.OrganizeMinutesReq} OrganizeMinutesReq
     */
    OrganizeMinutesReq.fromObject = function fromObject(object) {
      if (object instanceof $root.live.OrganizeMinutesReq) return object;
      let message = new $root.live.OrganizeMinutesReq();
      if (object.base != null) {
        if (typeof object.base !== 'object')
          throw TypeError('.live.OrganizeMinutesReq.base: object expected');
        message.base = $root.base.Base.fromObject(object.base);
      }
      if (object.terminalInfo != null) {
        if (typeof object.terminalInfo !== 'object')
          throw TypeError(
            '.live.OrganizeMinutesReq.terminalInfo: object expected'
          );
        message.terminalInfo = $root.live.TerminalInfo.fromObject(
          object.terminalInfo
        );
      }
      if (object.name != null) message.name = String(object.name);
      if (object.language != null) message.language = String(object.language);
      return message;
    };

    /**
     * Creates a plain object from an OrganizeMinutesReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.OrganizeMinutesReq
     * @static
     * @param {live.OrganizeMinutesReq} message OrganizeMinutesReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OrganizeMinutesReq.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.base = null;
        object.terminalInfo = null;
        object.name = '';
        object.language = '';
      }
      if (message.base != null && message.hasOwnProperty('base'))
        object.base = $root.base.Base.toObject(message.base, options);
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      )
        object.terminalInfo = $root.live.TerminalInfo.toObject(
          message.terminalInfo,
          options
        );
      if (message.name != null && message.hasOwnProperty('name'))
        object.name = message.name;
      if (message.language != null && message.hasOwnProperty('language'))
        object.language = message.language;
      return object;
    };

    /**
     * Converts this OrganizeMinutesReq to JSON.
     * @function toJSON
     * @memberof live.OrganizeMinutesReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OrganizeMinutesReq.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OrganizeMinutesReq;
  })();

  live.OrganizeMinutesResp = (function () {
    /**
     * Properties of an OrganizeMinutesResp.
     * @memberof live
     * @interface IOrganizeMinutesResp
     * @property {base.IBaseResp|null} [baseResp] OrganizeMinutesResp baseResp
     */

    /**
     * Constructs a new OrganizeMinutesResp.
     * @memberof live
     * @classdesc Represents an OrganizeMinutesResp.
     * @implements IOrganizeMinutesResp
     * @constructor
     * @param {live.IOrganizeMinutesResp=} [properties] Properties to set
     */
    function OrganizeMinutesResp(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * OrganizeMinutesResp baseResp.
     * @member {base.IBaseResp|null|undefined} baseResp
     * @memberof live.OrganizeMinutesResp
     * @instance
     */
    OrganizeMinutesResp.prototype.baseResp = null;

    /**
     * Creates a new OrganizeMinutesResp instance using the specified properties.
     * @function create
     * @memberof live.OrganizeMinutesResp
     * @static
     * @param {live.IOrganizeMinutesResp=} [properties] Properties to set
     * @returns {live.OrganizeMinutesResp} OrganizeMinutesResp instance
     */
    OrganizeMinutesResp.create = function create(properties) {
      return new OrganizeMinutesResp(properties);
    };

    /**
     * Encodes the specified OrganizeMinutesResp message. Does not implicitly {@link live.OrganizeMinutesResp.verify|verify} messages.
     * @function encode
     * @memberof live.OrganizeMinutesResp
     * @static
     * @param {live.IOrganizeMinutesResp} message OrganizeMinutesResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrganizeMinutesResp.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.baseResp != null &&
        Object.hasOwnProperty.call(message, 'baseResp')
      )
        $root.base.BaseResp.encode(
          message.baseResp,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified OrganizeMinutesResp message, length delimited. Does not implicitly {@link live.OrganizeMinutesResp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.OrganizeMinutesResp
     * @static
     * @param {live.IOrganizeMinutesResp} message OrganizeMinutesResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrganizeMinutesResp.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OrganizeMinutesResp message from the specified reader or buffer.
     * @function decode
     * @memberof live.OrganizeMinutesResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.OrganizeMinutesResp} OrganizeMinutesResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrganizeMinutesResp.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.OrganizeMinutesResp();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.baseResp = $root.base.BaseResp.decode(
              reader,
              reader.uint32()
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an OrganizeMinutesResp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.OrganizeMinutesResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.OrganizeMinutesResp} OrganizeMinutesResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrganizeMinutesResp.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OrganizeMinutesResp message.
     * @function verify
     * @memberof live.OrganizeMinutesResp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OrganizeMinutesResp.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.baseResp != null && message.hasOwnProperty('baseResp')) {
        let error = $root.base.BaseResp.verify(message.baseResp);
        if (error) return 'baseResp.' + error;
      }
      return null;
    };

    /**
     * Creates an OrganizeMinutesResp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.OrganizeMinutesResp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.OrganizeMinutesResp} OrganizeMinutesResp
     */
    OrganizeMinutesResp.fromObject = function fromObject(object) {
      if (object instanceof $root.live.OrganizeMinutesResp) return object;
      let message = new $root.live.OrganizeMinutesResp();
      if (object.baseResp != null) {
        if (typeof object.baseResp !== 'object')
          throw TypeError(
            '.live.OrganizeMinutesResp.baseResp: object expected'
          );
        message.baseResp = $root.base.BaseResp.fromObject(object.baseResp);
      }
      return message;
    };

    /**
     * Creates a plain object from an OrganizeMinutesResp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.OrganizeMinutesResp
     * @static
     * @param {live.OrganizeMinutesResp} message OrganizeMinutesResp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OrganizeMinutesResp.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.baseResp = null;
      if (message.baseResp != null && message.hasOwnProperty('baseResp'))
        object.baseResp = $root.base.BaseResp.toObject(
          message.baseResp,
          options
        );
      return object;
    };

    /**
     * Converts this OrganizeMinutesResp to JSON.
     * @function toJSON
     * @memberof live.OrganizeMinutesResp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OrganizeMinutesResp.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OrganizeMinutesResp;
  })();

  live.DownloadMinutesReq = (function () {
    /**
     * Properties of a DownloadMinutesReq.
     * @memberof live
     * @interface IDownloadMinutesReq
     * @property {base.IBase|null} [base] DownloadMinutesReq base
     * @property {live.ITerminalInfo|null} [terminalInfo] DownloadMinutesReq terminalInfo
     */

    /**
     * Constructs a new DownloadMinutesReq.
     * @memberof live
     * @classdesc Represents a DownloadMinutesReq.
     * @implements IDownloadMinutesReq
     * @constructor
     * @param {live.IDownloadMinutesReq=} [properties] Properties to set
     */
    function DownloadMinutesReq(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * DownloadMinutesReq base.
     * @member {base.IBase|null|undefined} base
     * @memberof live.DownloadMinutesReq
     * @instance
     */
    DownloadMinutesReq.prototype.base = null;

    /**
     * DownloadMinutesReq terminalInfo.
     * @member {live.ITerminalInfo|null|undefined} terminalInfo
     * @memberof live.DownloadMinutesReq
     * @instance
     */
    DownloadMinutesReq.prototype.terminalInfo = null;

    /**
     * Creates a new DownloadMinutesReq instance using the specified properties.
     * @function create
     * @memberof live.DownloadMinutesReq
     * @static
     * @param {live.IDownloadMinutesReq=} [properties] Properties to set
     * @returns {live.DownloadMinutesReq} DownloadMinutesReq instance
     */
    DownloadMinutesReq.create = function create(properties) {
      return new DownloadMinutesReq(properties);
    };

    /**
     * Encodes the specified DownloadMinutesReq message. Does not implicitly {@link live.DownloadMinutesReq.verify|verify} messages.
     * @function encode
     * @memberof live.DownloadMinutesReq
     * @static
     * @param {live.IDownloadMinutesReq} message DownloadMinutesReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DownloadMinutesReq.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.base != null && Object.hasOwnProperty.call(message, 'base'))
        $root.base.Base.encode(
          message.base,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.terminalInfo != null &&
        Object.hasOwnProperty.call(message, 'terminalInfo')
      )
        $root.live.TerminalInfo.encode(
          message.terminalInfo,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified DownloadMinutesReq message, length delimited. Does not implicitly {@link live.DownloadMinutesReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.DownloadMinutesReq
     * @static
     * @param {live.IDownloadMinutesReq} message DownloadMinutesReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DownloadMinutesReq.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DownloadMinutesReq message from the specified reader or buffer.
     * @function decode
     * @memberof live.DownloadMinutesReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.DownloadMinutesReq} DownloadMinutesReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DownloadMinutesReq.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.DownloadMinutesReq();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.base = $root.base.Base.decode(reader, reader.uint32());
            break;
          case 2:
            message.terminalInfo = $root.live.TerminalInfo.decode(
              reader,
              reader.uint32()
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a DownloadMinutesReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.DownloadMinutesReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.DownloadMinutesReq} DownloadMinutesReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DownloadMinutesReq.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DownloadMinutesReq message.
     * @function verify
     * @memberof live.DownloadMinutesReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DownloadMinutesReq.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.base != null && message.hasOwnProperty('base')) {
        let error = $root.base.Base.verify(message.base);
        if (error) return 'base.' + error;
      }
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      ) {
        let error = $root.live.TerminalInfo.verify(message.terminalInfo);
        if (error) return 'terminalInfo.' + error;
      }
      return null;
    };

    /**
     * Creates a DownloadMinutesReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.DownloadMinutesReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.DownloadMinutesReq} DownloadMinutesReq
     */
    DownloadMinutesReq.fromObject = function fromObject(object) {
      if (object instanceof $root.live.DownloadMinutesReq) return object;
      let message = new $root.live.DownloadMinutesReq();
      if (object.base != null) {
        if (typeof object.base !== 'object')
          throw TypeError('.live.DownloadMinutesReq.base: object expected');
        message.base = $root.base.Base.fromObject(object.base);
      }
      if (object.terminalInfo != null) {
        if (typeof object.terminalInfo !== 'object')
          throw TypeError(
            '.live.DownloadMinutesReq.terminalInfo: object expected'
          );
        message.terminalInfo = $root.live.TerminalInfo.fromObject(
          object.terminalInfo
        );
      }
      return message;
    };

    /**
     * Creates a plain object from a DownloadMinutesReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.DownloadMinutesReq
     * @static
     * @param {live.DownloadMinutesReq} message DownloadMinutesReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DownloadMinutesReq.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.base = null;
        object.terminalInfo = null;
      }
      if (message.base != null && message.hasOwnProperty('base'))
        object.base = $root.base.Base.toObject(message.base, options);
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      )
        object.terminalInfo = $root.live.TerminalInfo.toObject(
          message.terminalInfo,
          options
        );
      return object;
    };

    /**
     * Converts this DownloadMinutesReq to JSON.
     * @function toJSON
     * @memberof live.DownloadMinutesReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DownloadMinutesReq.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DownloadMinutesReq;
  })();

  live.DownloadMinutesResp = (function () {
    /**
     * Properties of a DownloadMinutesResp.
     * @memberof live
     * @interface IDownloadMinutesResp
     * @property {base.IBaseResp|null} [baseResp] DownloadMinutesResp baseResp
     * @property {Array.<base.IMapEntry>|null} [minutes] DownloadMinutesResp minutes
     */

    /**
     * Constructs a new DownloadMinutesResp.
     * @memberof live
     * @classdesc Represents a DownloadMinutesResp.
     * @implements IDownloadMinutesResp
     * @constructor
     * @param {live.IDownloadMinutesResp=} [properties] Properties to set
     */
    function DownloadMinutesResp(properties) {
      this.minutes = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * DownloadMinutesResp baseResp.
     * @member {base.IBaseResp|null|undefined} baseResp
     * @memberof live.DownloadMinutesResp
     * @instance
     */
    DownloadMinutesResp.prototype.baseResp = null;

    /**
     * DownloadMinutesResp minutes.
     * @member {Array.<base.IMapEntry>} minutes
     * @memberof live.DownloadMinutesResp
     * @instance
     */
    DownloadMinutesResp.prototype.minutes = $util.emptyArray;

    /**
     * Creates a new DownloadMinutesResp instance using the specified properties.
     * @function create
     * @memberof live.DownloadMinutesResp
     * @static
     * @param {live.IDownloadMinutesResp=} [properties] Properties to set
     * @returns {live.DownloadMinutesResp} DownloadMinutesResp instance
     */
    DownloadMinutesResp.create = function create(properties) {
      return new DownloadMinutesResp(properties);
    };

    /**
     * Encodes the specified DownloadMinutesResp message. Does not implicitly {@link live.DownloadMinutesResp.verify|verify} messages.
     * @function encode
     * @memberof live.DownloadMinutesResp
     * @static
     * @param {live.IDownloadMinutesResp} message DownloadMinutesResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DownloadMinutesResp.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.baseResp != null &&
        Object.hasOwnProperty.call(message, 'baseResp')
      )
        $root.base.BaseResp.encode(
          message.baseResp,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (message.minutes != null && message.minutes.length)
        for (let i = 0; i < message.minutes.length; ++i)
          $root.base.MapEntry.encode(
            message.minutes[i],
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified DownloadMinutesResp message, length delimited. Does not implicitly {@link live.DownloadMinutesResp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.DownloadMinutesResp
     * @static
     * @param {live.IDownloadMinutesResp} message DownloadMinutesResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DownloadMinutesResp.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DownloadMinutesResp message from the specified reader or buffer.
     * @function decode
     * @memberof live.DownloadMinutesResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.DownloadMinutesResp} DownloadMinutesResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DownloadMinutesResp.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.DownloadMinutesResp();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.baseResp = $root.base.BaseResp.decode(
              reader,
              reader.uint32()
            );
            break;
          case 2:
            if (!(message.minutes && message.minutes.length))
              message.minutes = [];
            message.minutes.push(
              $root.base.MapEntry.decode(reader, reader.uint32())
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a DownloadMinutesResp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.DownloadMinutesResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.DownloadMinutesResp} DownloadMinutesResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DownloadMinutesResp.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DownloadMinutesResp message.
     * @function verify
     * @memberof live.DownloadMinutesResp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DownloadMinutesResp.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.baseResp != null && message.hasOwnProperty('baseResp')) {
        let error = $root.base.BaseResp.verify(message.baseResp);
        if (error) return 'baseResp.' + error;
      }
      if (message.minutes != null && message.hasOwnProperty('minutes')) {
        if (!Array.isArray(message.minutes)) return 'minutes: array expected';
        for (let i = 0; i < message.minutes.length; ++i) {
          let error = $root.base.MapEntry.verify(message.minutes[i]);
          if (error) return 'minutes.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a DownloadMinutesResp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.DownloadMinutesResp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.DownloadMinutesResp} DownloadMinutesResp
     */
    DownloadMinutesResp.fromObject = function fromObject(object) {
      if (object instanceof $root.live.DownloadMinutesResp) return object;
      let message = new $root.live.DownloadMinutesResp();
      if (object.baseResp != null) {
        if (typeof object.baseResp !== 'object')
          throw TypeError(
            '.live.DownloadMinutesResp.baseResp: object expected'
          );
        message.baseResp = $root.base.BaseResp.fromObject(object.baseResp);
      }
      if (object.minutes) {
        if (!Array.isArray(object.minutes))
          throw TypeError('.live.DownloadMinutesResp.minutes: array expected');
        message.minutes = [];
        for (let i = 0; i < object.minutes.length; ++i) {
          if (typeof object.minutes[i] !== 'object')
            throw TypeError(
              '.live.DownloadMinutesResp.minutes: object expected'
            );
          message.minutes[i] = $root.base.MapEntry.fromObject(
            object.minutes[i]
          );
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a DownloadMinutesResp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.DownloadMinutesResp
     * @static
     * @param {live.DownloadMinutesResp} message DownloadMinutesResp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DownloadMinutesResp.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.minutes = [];
      if (options.defaults) object.baseResp = null;
      if (message.baseResp != null && message.hasOwnProperty('baseResp'))
        object.baseResp = $root.base.BaseResp.toObject(
          message.baseResp,
          options
        );
      if (message.minutes && message.minutes.length) {
        object.minutes = [];
        for (let j = 0; j < message.minutes.length; ++j)
          object.minutes[j] = $root.base.MapEntry.toObject(
            message.minutes[j],
            options
          );
      }
      return object;
    };

    /**
     * Converts this DownloadMinutesResp to JSON.
     * @function toJSON
     * @memberof live.DownloadMinutesResp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DownloadMinutesResp.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DownloadMinutesResp;
  })();

  live.CreateRoomReq = (function () {
    /**
     * Properties of a CreateRoomReq.
     * @memberof live
     * @interface ICreateRoomReq
     * @property {base.IBase|null} [base] CreateRoomReq base
     * @property {live.ITerminalInfo|null} [terminalInfo] CreateRoomReq terminalInfo
     * @property {live.IConferenceInfo|null} [conferenceInfo] CreateRoomReq conferenceInfo
     * @property {Long|null} [unixTimestamps] CreateRoomReq unixTimestamps
     */

    /**
     * Constructs a new CreateRoomReq.
     * @memberof live
     * @classdesc Represents a CreateRoomReq.
     * @implements ICreateRoomReq
     * @constructor
     * @param {live.ICreateRoomReq=} [properties] Properties to set
     */
    function CreateRoomReq(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * CreateRoomReq base.
     * @member {base.IBase|null|undefined} base
     * @memberof live.CreateRoomReq
     * @instance
     */
    CreateRoomReq.prototype.base = null;

    /**
     * CreateRoomReq terminalInfo.
     * @member {live.ITerminalInfo|null|undefined} terminalInfo
     * @memberof live.CreateRoomReq
     * @instance
     */
    CreateRoomReq.prototype.terminalInfo = null;

    /**
     * CreateRoomReq conferenceInfo.
     * @member {live.IConferenceInfo|null|undefined} conferenceInfo
     * @memberof live.CreateRoomReq
     * @instance
     */
    CreateRoomReq.prototype.conferenceInfo = null;

    /**
     * CreateRoomReq unixTimestamps.
     * @member {Long} unixTimestamps
     * @memberof live.CreateRoomReq
     * @instance
     */
    CreateRoomReq.prototype.unixTimestamps = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * Creates a new CreateRoomReq instance using the specified properties.
     * @function create
     * @memberof live.CreateRoomReq
     * @static
     * @param {live.ICreateRoomReq=} [properties] Properties to set
     * @returns {live.CreateRoomReq} CreateRoomReq instance
     */
    CreateRoomReq.create = function create(properties) {
      return new CreateRoomReq(properties);
    };

    /**
     * Encodes the specified CreateRoomReq message. Does not implicitly {@link live.CreateRoomReq.verify|verify} messages.
     * @function encode
     * @memberof live.CreateRoomReq
     * @static
     * @param {live.ICreateRoomReq} message CreateRoomReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateRoomReq.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.base != null && Object.hasOwnProperty.call(message, 'base'))
        $root.base.Base.encode(
          message.base,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.terminalInfo != null &&
        Object.hasOwnProperty.call(message, 'terminalInfo')
      )
        $root.live.TerminalInfo.encode(
          message.terminalInfo,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      if (
        message.conferenceInfo != null &&
        Object.hasOwnProperty.call(message, 'conferenceInfo')
      )
        $root.live.ConferenceInfo.encode(
          message.conferenceInfo,
          writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
        ).ldelim();
      if (
        message.unixTimestamps != null &&
        Object.hasOwnProperty.call(message, 'unixTimestamps')
      )
        writer.uint32(/* id 4, wireType 0 =*/ 32).int64(message.unixTimestamps);
      return writer;
    };

    /**
     * Encodes the specified CreateRoomReq message, length delimited. Does not implicitly {@link live.CreateRoomReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.CreateRoomReq
     * @static
     * @param {live.ICreateRoomReq} message CreateRoomReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateRoomReq.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CreateRoomReq message from the specified reader or buffer.
     * @function decode
     * @memberof live.CreateRoomReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.CreateRoomReq} CreateRoomReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateRoomReq.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.CreateRoomReq();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.base = $root.base.Base.decode(reader, reader.uint32());
            break;
          case 2:
            message.terminalInfo = $root.live.TerminalInfo.decode(
              reader,
              reader.uint32()
            );
            break;
          case 3:
            message.conferenceInfo = $root.live.ConferenceInfo.decode(
              reader,
              reader.uint32()
            );
            break;
          case 4:
            message.unixTimestamps = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a CreateRoomReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.CreateRoomReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.CreateRoomReq} CreateRoomReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateRoomReq.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CreateRoomReq message.
     * @function verify
     * @memberof live.CreateRoomReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CreateRoomReq.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.base != null && message.hasOwnProperty('base')) {
        let error = $root.base.Base.verify(message.base);
        if (error) return 'base.' + error;
      }
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      ) {
        let error = $root.live.TerminalInfo.verify(message.terminalInfo);
        if (error) return 'terminalInfo.' + error;
      }
      if (
        message.conferenceInfo != null &&
        message.hasOwnProperty('conferenceInfo')
      ) {
        let error = $root.live.ConferenceInfo.verify(message.conferenceInfo);
        if (error) return 'conferenceInfo.' + error;
      }
      if (
        message.unixTimestamps != null &&
        message.hasOwnProperty('unixTimestamps')
      )
        if (
          !$util.isInteger(message.unixTimestamps) &&
          !(
            message.unixTimestamps &&
            $util.isInteger(message.unixTimestamps.low) &&
            $util.isInteger(message.unixTimestamps.high)
          )
        )
          return 'unixTimestamps: integer|Long expected';
      return null;
    };

    /**
     * Creates a CreateRoomReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.CreateRoomReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.CreateRoomReq} CreateRoomReq
     */
    CreateRoomReq.fromObject = function fromObject(object) {
      if (object instanceof $root.live.CreateRoomReq) return object;
      let message = new $root.live.CreateRoomReq();
      if (object.base != null) {
        if (typeof object.base !== 'object')
          throw TypeError('.live.CreateRoomReq.base: object expected');
        message.base = $root.base.Base.fromObject(object.base);
      }
      if (object.terminalInfo != null) {
        if (typeof object.terminalInfo !== 'object')
          throw TypeError('.live.CreateRoomReq.terminalInfo: object expected');
        message.terminalInfo = $root.live.TerminalInfo.fromObject(
          object.terminalInfo
        );
      }
      if (object.conferenceInfo != null) {
        if (typeof object.conferenceInfo !== 'object')
          throw TypeError(
            '.live.CreateRoomReq.conferenceInfo: object expected'
          );
        message.conferenceInfo = $root.live.ConferenceInfo.fromObject(
          object.conferenceInfo
        );
      }
      if (object.unixTimestamps != null)
        if ($util.Long)
          (message.unixTimestamps = $util.Long.fromValue(
            object.unixTimestamps
          )).unsigned = false;
        else if (typeof object.unixTimestamps === 'string')
          message.unixTimestamps = parseInt(object.unixTimestamps, 10);
        else if (typeof object.unixTimestamps === 'number')
          message.unixTimestamps = object.unixTimestamps;
        else if (typeof object.unixTimestamps === 'object')
          message.unixTimestamps = new $util.LongBits(
            object.unixTimestamps.low >>> 0,
            object.unixTimestamps.high >>> 0
          ).toNumber();
      return message;
    };

    /**
     * Creates a plain object from a CreateRoomReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.CreateRoomReq
     * @static
     * @param {live.CreateRoomReq} message CreateRoomReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CreateRoomReq.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.base = null;
        object.terminalInfo = null;
        object.conferenceInfo = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.unixTimestamps =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.unixTimestamps = options.longs === String ? '0' : 0;
      }
      if (message.base != null && message.hasOwnProperty('base'))
        object.base = $root.base.Base.toObject(message.base, options);
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      )
        object.terminalInfo = $root.live.TerminalInfo.toObject(
          message.terminalInfo,
          options
        );
      if (
        message.conferenceInfo != null &&
        message.hasOwnProperty('conferenceInfo')
      )
        object.conferenceInfo = $root.live.ConferenceInfo.toObject(
          message.conferenceInfo,
          options
        );
      if (
        message.unixTimestamps != null &&
        message.hasOwnProperty('unixTimestamps')
      )
        if (typeof message.unixTimestamps === 'number')
          object.unixTimestamps =
            options.longs === String
              ? String(message.unixTimestamps)
              : message.unixTimestamps;
        else
          object.unixTimestamps =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.unixTimestamps)
              : options.longs === Number
              ? new $util.LongBits(
                  message.unixTimestamps.low >>> 0,
                  message.unixTimestamps.high >>> 0
                ).toNumber()
              : message.unixTimestamps;
      return object;
    };

    /**
     * Converts this CreateRoomReq to JSON.
     * @function toJSON
     * @memberof live.CreateRoomReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CreateRoomReq.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CreateRoomReq;
  })();

  live.CreateRoomResp = (function () {
    /**
     * Properties of a CreateRoomResp.
     * @memberof live
     * @interface ICreateRoomResp
     * @property {base.IBaseResp|null} [baseResp] CreateRoomResp baseResp
     * @property {live.ITerminalInfo|null} [terminalInfo] CreateRoomResp terminalInfo
     */

    /**
     * Constructs a new CreateRoomResp.
     * @memberof live
     * @classdesc Represents a CreateRoomResp.
     * @implements ICreateRoomResp
     * @constructor
     * @param {live.ICreateRoomResp=} [properties] Properties to set
     */
    function CreateRoomResp(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * CreateRoomResp baseResp.
     * @member {base.IBaseResp|null|undefined} baseResp
     * @memberof live.CreateRoomResp
     * @instance
     */
    CreateRoomResp.prototype.baseResp = null;

    /**
     * CreateRoomResp terminalInfo.
     * @member {live.ITerminalInfo|null|undefined} terminalInfo
     * @memberof live.CreateRoomResp
     * @instance
     */
    CreateRoomResp.prototype.terminalInfo = null;

    /**
     * Creates a new CreateRoomResp instance using the specified properties.
     * @function create
     * @memberof live.CreateRoomResp
     * @static
     * @param {live.ICreateRoomResp=} [properties] Properties to set
     * @returns {live.CreateRoomResp} CreateRoomResp instance
     */
    CreateRoomResp.create = function create(properties) {
      return new CreateRoomResp(properties);
    };

    /**
     * Encodes the specified CreateRoomResp message. Does not implicitly {@link live.CreateRoomResp.verify|verify} messages.
     * @function encode
     * @memberof live.CreateRoomResp
     * @static
     * @param {live.ICreateRoomResp} message CreateRoomResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateRoomResp.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.baseResp != null &&
        Object.hasOwnProperty.call(message, 'baseResp')
      )
        $root.base.BaseResp.encode(
          message.baseResp,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.terminalInfo != null &&
        Object.hasOwnProperty.call(message, 'terminalInfo')
      )
        $root.live.TerminalInfo.encode(
          message.terminalInfo,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified CreateRoomResp message, length delimited. Does not implicitly {@link live.CreateRoomResp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.CreateRoomResp
     * @static
     * @param {live.ICreateRoomResp} message CreateRoomResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateRoomResp.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CreateRoomResp message from the specified reader or buffer.
     * @function decode
     * @memberof live.CreateRoomResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.CreateRoomResp} CreateRoomResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateRoomResp.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.CreateRoomResp();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.baseResp = $root.base.BaseResp.decode(
              reader,
              reader.uint32()
            );
            break;
          case 2:
            message.terminalInfo = $root.live.TerminalInfo.decode(
              reader,
              reader.uint32()
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a CreateRoomResp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.CreateRoomResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.CreateRoomResp} CreateRoomResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateRoomResp.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CreateRoomResp message.
     * @function verify
     * @memberof live.CreateRoomResp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CreateRoomResp.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.baseResp != null && message.hasOwnProperty('baseResp')) {
        let error = $root.base.BaseResp.verify(message.baseResp);
        if (error) return 'baseResp.' + error;
      }
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      ) {
        let error = $root.live.TerminalInfo.verify(message.terminalInfo);
        if (error) return 'terminalInfo.' + error;
      }
      return null;
    };

    /**
     * Creates a CreateRoomResp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.CreateRoomResp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.CreateRoomResp} CreateRoomResp
     */
    CreateRoomResp.fromObject = function fromObject(object) {
      if (object instanceof $root.live.CreateRoomResp) return object;
      let message = new $root.live.CreateRoomResp();
      if (object.baseResp != null) {
        if (typeof object.baseResp !== 'object')
          throw TypeError('.live.CreateRoomResp.baseResp: object expected');
        message.baseResp = $root.base.BaseResp.fromObject(object.baseResp);
      }
      if (object.terminalInfo != null) {
        if (typeof object.terminalInfo !== 'object')
          throw TypeError('.live.CreateRoomResp.terminalInfo: object expected');
        message.terminalInfo = $root.live.TerminalInfo.fromObject(
          object.terminalInfo
        );
      }
      return message;
    };

    /**
     * Creates a plain object from a CreateRoomResp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.CreateRoomResp
     * @static
     * @param {live.CreateRoomResp} message CreateRoomResp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CreateRoomResp.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.baseResp = null;
        object.terminalInfo = null;
      }
      if (message.baseResp != null && message.hasOwnProperty('baseResp'))
        object.baseResp = $root.base.BaseResp.toObject(
          message.baseResp,
          options
        );
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      )
        object.terminalInfo = $root.live.TerminalInfo.toObject(
          message.terminalInfo,
          options
        );
      return object;
    };

    /**
     * Converts this CreateRoomResp to JSON.
     * @function toJSON
     * @memberof live.CreateRoomResp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CreateRoomResp.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CreateRoomResp;
  })();

  live.StartRoomReq = (function () {
    /**
     * Properties of a StartRoomReq.
     * @memberof live
     * @interface IStartRoomReq
     * @property {base.IBase|null} [base] StartRoomReq base
     * @property {live.ITerminalInfo|null} [terminalInfo] StartRoomReq terminalInfo
     * @property {Long|null} [unixTimestamps] StartRoomReq unixTimestamps
     */

    /**
     * Constructs a new StartRoomReq.
     * @memberof live
     * @classdesc Represents a StartRoomReq.
     * @implements IStartRoomReq
     * @constructor
     * @param {live.IStartRoomReq=} [properties] Properties to set
     */
    function StartRoomReq(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * StartRoomReq base.
     * @member {base.IBase|null|undefined} base
     * @memberof live.StartRoomReq
     * @instance
     */
    StartRoomReq.prototype.base = null;

    /**
     * StartRoomReq terminalInfo.
     * @member {live.ITerminalInfo|null|undefined} terminalInfo
     * @memberof live.StartRoomReq
     * @instance
     */
    StartRoomReq.prototype.terminalInfo = null;

    /**
     * StartRoomReq unixTimestamps.
     * @member {Long} unixTimestamps
     * @memberof live.StartRoomReq
     * @instance
     */
    StartRoomReq.prototype.unixTimestamps = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * Creates a new StartRoomReq instance using the specified properties.
     * @function create
     * @memberof live.StartRoomReq
     * @static
     * @param {live.IStartRoomReq=} [properties] Properties to set
     * @returns {live.StartRoomReq} StartRoomReq instance
     */
    StartRoomReq.create = function create(properties) {
      return new StartRoomReq(properties);
    };

    /**
     * Encodes the specified StartRoomReq message. Does not implicitly {@link live.StartRoomReq.verify|verify} messages.
     * @function encode
     * @memberof live.StartRoomReq
     * @static
     * @param {live.IStartRoomReq} message StartRoomReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StartRoomReq.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.base != null && Object.hasOwnProperty.call(message, 'base'))
        $root.base.Base.encode(
          message.base,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.terminalInfo != null &&
        Object.hasOwnProperty.call(message, 'terminalInfo')
      )
        $root.live.TerminalInfo.encode(
          message.terminalInfo,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      if (
        message.unixTimestamps != null &&
        Object.hasOwnProperty.call(message, 'unixTimestamps')
      )
        writer.uint32(/* id 3, wireType 0 =*/ 24).int64(message.unixTimestamps);
      return writer;
    };

    /**
     * Encodes the specified StartRoomReq message, length delimited. Does not implicitly {@link live.StartRoomReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.StartRoomReq
     * @static
     * @param {live.IStartRoomReq} message StartRoomReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StartRoomReq.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a StartRoomReq message from the specified reader or buffer.
     * @function decode
     * @memberof live.StartRoomReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.StartRoomReq} StartRoomReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StartRoomReq.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.StartRoomReq();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.base = $root.base.Base.decode(reader, reader.uint32());
            break;
          case 2:
            message.terminalInfo = $root.live.TerminalInfo.decode(
              reader,
              reader.uint32()
            );
            break;
          case 3:
            message.unixTimestamps = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a StartRoomReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.StartRoomReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.StartRoomReq} StartRoomReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StartRoomReq.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a StartRoomReq message.
     * @function verify
     * @memberof live.StartRoomReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    StartRoomReq.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.base != null && message.hasOwnProperty('base')) {
        let error = $root.base.Base.verify(message.base);
        if (error) return 'base.' + error;
      }
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      ) {
        let error = $root.live.TerminalInfo.verify(message.terminalInfo);
        if (error) return 'terminalInfo.' + error;
      }
      if (
        message.unixTimestamps != null &&
        message.hasOwnProperty('unixTimestamps')
      )
        if (
          !$util.isInteger(message.unixTimestamps) &&
          !(
            message.unixTimestamps &&
            $util.isInteger(message.unixTimestamps.low) &&
            $util.isInteger(message.unixTimestamps.high)
          )
        )
          return 'unixTimestamps: integer|Long expected';
      return null;
    };

    /**
     * Creates a StartRoomReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.StartRoomReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.StartRoomReq} StartRoomReq
     */
    StartRoomReq.fromObject = function fromObject(object) {
      if (object instanceof $root.live.StartRoomReq) return object;
      let message = new $root.live.StartRoomReq();
      if (object.base != null) {
        if (typeof object.base !== 'object')
          throw TypeError('.live.StartRoomReq.base: object expected');
        message.base = $root.base.Base.fromObject(object.base);
      }
      if (object.terminalInfo != null) {
        if (typeof object.terminalInfo !== 'object')
          throw TypeError('.live.StartRoomReq.terminalInfo: object expected');
        message.terminalInfo = $root.live.TerminalInfo.fromObject(
          object.terminalInfo
        );
      }
      if (object.unixTimestamps != null)
        if ($util.Long)
          (message.unixTimestamps = $util.Long.fromValue(
            object.unixTimestamps
          )).unsigned = false;
        else if (typeof object.unixTimestamps === 'string')
          message.unixTimestamps = parseInt(object.unixTimestamps, 10);
        else if (typeof object.unixTimestamps === 'number')
          message.unixTimestamps = object.unixTimestamps;
        else if (typeof object.unixTimestamps === 'object')
          message.unixTimestamps = new $util.LongBits(
            object.unixTimestamps.low >>> 0,
            object.unixTimestamps.high >>> 0
          ).toNumber();
      return message;
    };

    /**
     * Creates a plain object from a StartRoomReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.StartRoomReq
     * @static
     * @param {live.StartRoomReq} message StartRoomReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StartRoomReq.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.base = null;
        object.terminalInfo = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.unixTimestamps =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.unixTimestamps = options.longs === String ? '0' : 0;
      }
      if (message.base != null && message.hasOwnProperty('base'))
        object.base = $root.base.Base.toObject(message.base, options);
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      )
        object.terminalInfo = $root.live.TerminalInfo.toObject(
          message.terminalInfo,
          options
        );
      if (
        message.unixTimestamps != null &&
        message.hasOwnProperty('unixTimestamps')
      )
        if (typeof message.unixTimestamps === 'number')
          object.unixTimestamps =
            options.longs === String
              ? String(message.unixTimestamps)
              : message.unixTimestamps;
        else
          object.unixTimestamps =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.unixTimestamps)
              : options.longs === Number
              ? new $util.LongBits(
                  message.unixTimestamps.low >>> 0,
                  message.unixTimestamps.high >>> 0
                ).toNumber()
              : message.unixTimestamps;
      return object;
    };

    /**
     * Converts this StartRoomReq to JSON.
     * @function toJSON
     * @memberof live.StartRoomReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StartRoomReq.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StartRoomReq;
  })();

  live.StartRoomResp = (function () {
    /**
     * Properties of a StartRoomResp.
     * @memberof live
     * @interface IStartRoomResp
     * @property {base.IBaseResp|null} [baseResp] StartRoomResp baseResp
     * @property {live.ITerminalInfo|null} [terminalInfo] StartRoomResp terminalInfo
     */

    /**
     * Constructs a new StartRoomResp.
     * @memberof live
     * @classdesc Represents a StartRoomResp.
     * @implements IStartRoomResp
     * @constructor
     * @param {live.IStartRoomResp=} [properties] Properties to set
     */
    function StartRoomResp(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * StartRoomResp baseResp.
     * @member {base.IBaseResp|null|undefined} baseResp
     * @memberof live.StartRoomResp
     * @instance
     */
    StartRoomResp.prototype.baseResp = null;

    /**
     * StartRoomResp terminalInfo.
     * @member {live.ITerminalInfo|null|undefined} terminalInfo
     * @memberof live.StartRoomResp
     * @instance
     */
    StartRoomResp.prototype.terminalInfo = null;

    /**
     * Creates a new StartRoomResp instance using the specified properties.
     * @function create
     * @memberof live.StartRoomResp
     * @static
     * @param {live.IStartRoomResp=} [properties] Properties to set
     * @returns {live.StartRoomResp} StartRoomResp instance
     */
    StartRoomResp.create = function create(properties) {
      return new StartRoomResp(properties);
    };

    /**
     * Encodes the specified StartRoomResp message. Does not implicitly {@link live.StartRoomResp.verify|verify} messages.
     * @function encode
     * @memberof live.StartRoomResp
     * @static
     * @param {live.IStartRoomResp} message StartRoomResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StartRoomResp.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.baseResp != null &&
        Object.hasOwnProperty.call(message, 'baseResp')
      )
        $root.base.BaseResp.encode(
          message.baseResp,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.terminalInfo != null &&
        Object.hasOwnProperty.call(message, 'terminalInfo')
      )
        $root.live.TerminalInfo.encode(
          message.terminalInfo,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified StartRoomResp message, length delimited. Does not implicitly {@link live.StartRoomResp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.StartRoomResp
     * @static
     * @param {live.IStartRoomResp} message StartRoomResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StartRoomResp.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a StartRoomResp message from the specified reader or buffer.
     * @function decode
     * @memberof live.StartRoomResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.StartRoomResp} StartRoomResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StartRoomResp.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.StartRoomResp();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.baseResp = $root.base.BaseResp.decode(
              reader,
              reader.uint32()
            );
            break;
          case 2:
            message.terminalInfo = $root.live.TerminalInfo.decode(
              reader,
              reader.uint32()
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a StartRoomResp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.StartRoomResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.StartRoomResp} StartRoomResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StartRoomResp.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a StartRoomResp message.
     * @function verify
     * @memberof live.StartRoomResp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    StartRoomResp.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.baseResp != null && message.hasOwnProperty('baseResp')) {
        let error = $root.base.BaseResp.verify(message.baseResp);
        if (error) return 'baseResp.' + error;
      }
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      ) {
        let error = $root.live.TerminalInfo.verify(message.terminalInfo);
        if (error) return 'terminalInfo.' + error;
      }
      return null;
    };

    /**
     * Creates a StartRoomResp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.StartRoomResp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.StartRoomResp} StartRoomResp
     */
    StartRoomResp.fromObject = function fromObject(object) {
      if (object instanceof $root.live.StartRoomResp) return object;
      let message = new $root.live.StartRoomResp();
      if (object.baseResp != null) {
        if (typeof object.baseResp !== 'object')
          throw TypeError('.live.StartRoomResp.baseResp: object expected');
        message.baseResp = $root.base.BaseResp.fromObject(object.baseResp);
      }
      if (object.terminalInfo != null) {
        if (typeof object.terminalInfo !== 'object')
          throw TypeError('.live.StartRoomResp.terminalInfo: object expected');
        message.terminalInfo = $root.live.TerminalInfo.fromObject(
          object.terminalInfo
        );
      }
      return message;
    };

    /**
     * Creates a plain object from a StartRoomResp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.StartRoomResp
     * @static
     * @param {live.StartRoomResp} message StartRoomResp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StartRoomResp.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.baseResp = null;
        object.terminalInfo = null;
      }
      if (message.baseResp != null && message.hasOwnProperty('baseResp'))
        object.baseResp = $root.base.BaseResp.toObject(
          message.baseResp,
          options
        );
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      )
        object.terminalInfo = $root.live.TerminalInfo.toObject(
          message.terminalInfo,
          options
        );
      return object;
    };

    /**
     * Converts this StartRoomResp to JSON.
     * @function toJSON
     * @memberof live.StartRoomResp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StartRoomResp.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return StartRoomResp;
  })();

  live.DeleteRoomReq = (function () {
    /**
     * Properties of a DeleteRoomReq.
     * @memberof live
     * @interface IDeleteRoomReq
     * @property {base.IBase|null} [base] DeleteRoomReq base
     * @property {live.ITerminalInfo|null} [terminalInfo] DeleteRoomReq terminalInfo
     */

    /**
     * Constructs a new DeleteRoomReq.
     * @memberof live
     * @classdesc Represents a DeleteRoomReq.
     * @implements IDeleteRoomReq
     * @constructor
     * @param {live.IDeleteRoomReq=} [properties] Properties to set
     */
    function DeleteRoomReq(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeleteRoomReq base.
     * @member {base.IBase|null|undefined} base
     * @memberof live.DeleteRoomReq
     * @instance
     */
    DeleteRoomReq.prototype.base = null;

    /**
     * DeleteRoomReq terminalInfo.
     * @member {live.ITerminalInfo|null|undefined} terminalInfo
     * @memberof live.DeleteRoomReq
     * @instance
     */
    DeleteRoomReq.prototype.terminalInfo = null;

    /**
     * Creates a new DeleteRoomReq instance using the specified properties.
     * @function create
     * @memberof live.DeleteRoomReq
     * @static
     * @param {live.IDeleteRoomReq=} [properties] Properties to set
     * @returns {live.DeleteRoomReq} DeleteRoomReq instance
     */
    DeleteRoomReq.create = function create(properties) {
      return new DeleteRoomReq(properties);
    };

    /**
     * Encodes the specified DeleteRoomReq message. Does not implicitly {@link live.DeleteRoomReq.verify|verify} messages.
     * @function encode
     * @memberof live.DeleteRoomReq
     * @static
     * @param {live.IDeleteRoomReq} message DeleteRoomReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeleteRoomReq.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.base != null && Object.hasOwnProperty.call(message, 'base'))
        $root.base.Base.encode(
          message.base,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.terminalInfo != null &&
        Object.hasOwnProperty.call(message, 'terminalInfo')
      )
        $root.live.TerminalInfo.encode(
          message.terminalInfo,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified DeleteRoomReq message, length delimited. Does not implicitly {@link live.DeleteRoomReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.DeleteRoomReq
     * @static
     * @param {live.IDeleteRoomReq} message DeleteRoomReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeleteRoomReq.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeleteRoomReq message from the specified reader or buffer.
     * @function decode
     * @memberof live.DeleteRoomReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.DeleteRoomReq} DeleteRoomReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeleteRoomReq.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.DeleteRoomReq();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.base = $root.base.Base.decode(reader, reader.uint32());
            break;
          case 2:
            message.terminalInfo = $root.live.TerminalInfo.decode(
              reader,
              reader.uint32()
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a DeleteRoomReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.DeleteRoomReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.DeleteRoomReq} DeleteRoomReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeleteRoomReq.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeleteRoomReq message.
     * @function verify
     * @memberof live.DeleteRoomReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeleteRoomReq.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.base != null && message.hasOwnProperty('base')) {
        let error = $root.base.Base.verify(message.base);
        if (error) return 'base.' + error;
      }
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      ) {
        let error = $root.live.TerminalInfo.verify(message.terminalInfo);
        if (error) return 'terminalInfo.' + error;
      }
      return null;
    };

    /**
     * Creates a DeleteRoomReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.DeleteRoomReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.DeleteRoomReq} DeleteRoomReq
     */
    DeleteRoomReq.fromObject = function fromObject(object) {
      if (object instanceof $root.live.DeleteRoomReq) return object;
      let message = new $root.live.DeleteRoomReq();
      if (object.base != null) {
        if (typeof object.base !== 'object')
          throw TypeError('.live.DeleteRoomReq.base: object expected');
        message.base = $root.base.Base.fromObject(object.base);
      }
      if (object.terminalInfo != null) {
        if (typeof object.terminalInfo !== 'object')
          throw TypeError('.live.DeleteRoomReq.terminalInfo: object expected');
        message.terminalInfo = $root.live.TerminalInfo.fromObject(
          object.terminalInfo
        );
      }
      return message;
    };

    /**
     * Creates a plain object from a DeleteRoomReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.DeleteRoomReq
     * @static
     * @param {live.DeleteRoomReq} message DeleteRoomReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeleteRoomReq.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.base = null;
        object.terminalInfo = null;
      }
      if (message.base != null && message.hasOwnProperty('base'))
        object.base = $root.base.Base.toObject(message.base, options);
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      )
        object.terminalInfo = $root.live.TerminalInfo.toObject(
          message.terminalInfo,
          options
        );
      return object;
    };

    /**
     * Converts this DeleteRoomReq to JSON.
     * @function toJSON
     * @memberof live.DeleteRoomReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeleteRoomReq.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeleteRoomReq;
  })();

  live.DeleteRoomResp = (function () {
    /**
     * Properties of a DeleteRoomResp.
     * @memberof live
     * @interface IDeleteRoomResp
     * @property {base.IBaseResp|null} [baseResp] DeleteRoomResp baseResp
     */

    /**
     * Constructs a new DeleteRoomResp.
     * @memberof live
     * @classdesc Represents a DeleteRoomResp.
     * @implements IDeleteRoomResp
     * @constructor
     * @param {live.IDeleteRoomResp=} [properties] Properties to set
     */
    function DeleteRoomResp(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeleteRoomResp baseResp.
     * @member {base.IBaseResp|null|undefined} baseResp
     * @memberof live.DeleteRoomResp
     * @instance
     */
    DeleteRoomResp.prototype.baseResp = null;

    /**
     * Creates a new DeleteRoomResp instance using the specified properties.
     * @function create
     * @memberof live.DeleteRoomResp
     * @static
     * @param {live.IDeleteRoomResp=} [properties] Properties to set
     * @returns {live.DeleteRoomResp} DeleteRoomResp instance
     */
    DeleteRoomResp.create = function create(properties) {
      return new DeleteRoomResp(properties);
    };

    /**
     * Encodes the specified DeleteRoomResp message. Does not implicitly {@link live.DeleteRoomResp.verify|verify} messages.
     * @function encode
     * @memberof live.DeleteRoomResp
     * @static
     * @param {live.IDeleteRoomResp} message DeleteRoomResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeleteRoomResp.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.baseResp != null &&
        Object.hasOwnProperty.call(message, 'baseResp')
      )
        $root.base.BaseResp.encode(
          message.baseResp,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified DeleteRoomResp message, length delimited. Does not implicitly {@link live.DeleteRoomResp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.DeleteRoomResp
     * @static
     * @param {live.IDeleteRoomResp} message DeleteRoomResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeleteRoomResp.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeleteRoomResp message from the specified reader or buffer.
     * @function decode
     * @memberof live.DeleteRoomResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.DeleteRoomResp} DeleteRoomResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeleteRoomResp.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.DeleteRoomResp();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.baseResp = $root.base.BaseResp.decode(
              reader,
              reader.uint32()
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a DeleteRoomResp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.DeleteRoomResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.DeleteRoomResp} DeleteRoomResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeleteRoomResp.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeleteRoomResp message.
     * @function verify
     * @memberof live.DeleteRoomResp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeleteRoomResp.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.baseResp != null && message.hasOwnProperty('baseResp')) {
        let error = $root.base.BaseResp.verify(message.baseResp);
        if (error) return 'baseResp.' + error;
      }
      return null;
    };

    /**
     * Creates a DeleteRoomResp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.DeleteRoomResp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.DeleteRoomResp} DeleteRoomResp
     */
    DeleteRoomResp.fromObject = function fromObject(object) {
      if (object instanceof $root.live.DeleteRoomResp) return object;
      let message = new $root.live.DeleteRoomResp();
      if (object.baseResp != null) {
        if (typeof object.baseResp !== 'object')
          throw TypeError('.live.DeleteRoomResp.baseResp: object expected');
        message.baseResp = $root.base.BaseResp.fromObject(object.baseResp);
      }
      return message;
    };

    /**
     * Creates a plain object from a DeleteRoomResp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.DeleteRoomResp
     * @static
     * @param {live.DeleteRoomResp} message DeleteRoomResp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeleteRoomResp.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.baseResp = null;
      if (message.baseResp != null && message.hasOwnProperty('baseResp'))
        object.baseResp = $root.base.BaseResp.toObject(
          message.baseResp,
          options
        );
      return object;
    };

    /**
     * Converts this DeleteRoomResp to JSON.
     * @function toJSON
     * @memberof live.DeleteRoomResp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeleteRoomResp.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DeleteRoomResp;
  })();

  live.GetTokenInfoReq = (function () {
    /**
     * Properties of a GetTokenInfoReq.
     * @memberof live
     * @interface IGetTokenInfoReq
     * @property {base.IBase|null} [base] GetTokenInfoReq base
     * @property {live.ITerminalInfo|null} [terminalInfo] GetTokenInfoReq terminalInfo
     * @property {string|null} [token] GetTokenInfoReq token
     */

    /**
     * Constructs a new GetTokenInfoReq.
     * @memberof live
     * @classdesc Represents a GetTokenInfoReq.
     * @implements IGetTokenInfoReq
     * @constructor
     * @param {live.IGetTokenInfoReq=} [properties] Properties to set
     */
    function GetTokenInfoReq(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetTokenInfoReq base.
     * @member {base.IBase|null|undefined} base
     * @memberof live.GetTokenInfoReq
     * @instance
     */
    GetTokenInfoReq.prototype.base = null;

    /**
     * GetTokenInfoReq terminalInfo.
     * @member {live.ITerminalInfo|null|undefined} terminalInfo
     * @memberof live.GetTokenInfoReq
     * @instance
     */
    GetTokenInfoReq.prototype.terminalInfo = null;

    /**
     * GetTokenInfoReq token.
     * @member {string} token
     * @memberof live.GetTokenInfoReq
     * @instance
     */
    GetTokenInfoReq.prototype.token = '';

    /**
     * Creates a new GetTokenInfoReq instance using the specified properties.
     * @function create
     * @memberof live.GetTokenInfoReq
     * @static
     * @param {live.IGetTokenInfoReq=} [properties] Properties to set
     * @returns {live.GetTokenInfoReq} GetTokenInfoReq instance
     */
    GetTokenInfoReq.create = function create(properties) {
      return new GetTokenInfoReq(properties);
    };

    /**
     * Encodes the specified GetTokenInfoReq message. Does not implicitly {@link live.GetTokenInfoReq.verify|verify} messages.
     * @function encode
     * @memberof live.GetTokenInfoReq
     * @static
     * @param {live.IGetTokenInfoReq} message GetTokenInfoReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetTokenInfoReq.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.base != null && Object.hasOwnProperty.call(message, 'base'))
        $root.base.Base.encode(
          message.base,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.terminalInfo != null &&
        Object.hasOwnProperty.call(message, 'terminalInfo')
      )
        $root.live.TerminalInfo.encode(
          message.terminalInfo,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      if (message.token != null && Object.hasOwnProperty.call(message, 'token'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.token);
      return writer;
    };

    /**
     * Encodes the specified GetTokenInfoReq message, length delimited. Does not implicitly {@link live.GetTokenInfoReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.GetTokenInfoReq
     * @static
     * @param {live.IGetTokenInfoReq} message GetTokenInfoReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetTokenInfoReq.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetTokenInfoReq message from the specified reader or buffer.
     * @function decode
     * @memberof live.GetTokenInfoReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.GetTokenInfoReq} GetTokenInfoReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetTokenInfoReq.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.GetTokenInfoReq();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.base = $root.base.Base.decode(reader, reader.uint32());
            break;
          case 2:
            message.terminalInfo = $root.live.TerminalInfo.decode(
              reader,
              reader.uint32()
            );
            break;
          case 3:
            message.token = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a GetTokenInfoReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.GetTokenInfoReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.GetTokenInfoReq} GetTokenInfoReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetTokenInfoReq.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetTokenInfoReq message.
     * @function verify
     * @memberof live.GetTokenInfoReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetTokenInfoReq.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.base != null && message.hasOwnProperty('base')) {
        let error = $root.base.Base.verify(message.base);
        if (error) return 'base.' + error;
      }
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      ) {
        let error = $root.live.TerminalInfo.verify(message.terminalInfo);
        if (error) return 'terminalInfo.' + error;
      }
      if (message.token != null && message.hasOwnProperty('token'))
        if (!$util.isString(message.token)) return 'token: string expected';
      return null;
    };

    /**
     * Creates a GetTokenInfoReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.GetTokenInfoReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.GetTokenInfoReq} GetTokenInfoReq
     */
    GetTokenInfoReq.fromObject = function fromObject(object) {
      if (object instanceof $root.live.GetTokenInfoReq) return object;
      let message = new $root.live.GetTokenInfoReq();
      if (object.base != null) {
        if (typeof object.base !== 'object')
          throw TypeError('.live.GetTokenInfoReq.base: object expected');
        message.base = $root.base.Base.fromObject(object.base);
      }
      if (object.terminalInfo != null) {
        if (typeof object.terminalInfo !== 'object')
          throw TypeError(
            '.live.GetTokenInfoReq.terminalInfo: object expected'
          );
        message.terminalInfo = $root.live.TerminalInfo.fromObject(
          object.terminalInfo
        );
      }
      if (object.token != null) message.token = String(object.token);
      return message;
    };

    /**
     * Creates a plain object from a GetTokenInfoReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.GetTokenInfoReq
     * @static
     * @param {live.GetTokenInfoReq} message GetTokenInfoReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetTokenInfoReq.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.base = null;
        object.terminalInfo = null;
        object.token = '';
      }
      if (message.base != null && message.hasOwnProperty('base'))
        object.base = $root.base.Base.toObject(message.base, options);
      if (
        message.terminalInfo != null &&
        message.hasOwnProperty('terminalInfo')
      )
        object.terminalInfo = $root.live.TerminalInfo.toObject(
          message.terminalInfo,
          options
        );
      if (message.token != null && message.hasOwnProperty('token'))
        object.token = message.token;
      return object;
    };

    /**
     * Converts this GetTokenInfoReq to JSON.
     * @function toJSON
     * @memberof live.GetTokenInfoReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetTokenInfoReq.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetTokenInfoReq;
  })();

  live.GetTokenInfoResp = (function () {
    /**
     * Properties of a GetTokenInfoResp.
     * @memberof live
     * @interface IGetTokenInfoResp
     * @property {base.IBaseResp|null} [baseResp] GetTokenInfoResp baseResp
     * @property {Long|null} [quota] GetTokenInfoResp quota
     * @property {live.GetTokenInfoResp.TokenGroup|null} [group] GetTokenInfoResp group
     * @property {boolean|null} [isValid] GetTokenInfoResp isValid
     * @property {Array.<base.IMapEntry>|null} [extra] GetTokenInfoResp extra
     */

    /**
     * Constructs a new GetTokenInfoResp.
     * @memberof live
     * @classdesc Represents a GetTokenInfoResp.
     * @implements IGetTokenInfoResp
     * @constructor
     * @param {live.IGetTokenInfoResp=} [properties] Properties to set
     */
    function GetTokenInfoResp(properties) {
      this.extra = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetTokenInfoResp baseResp.
     * @member {base.IBaseResp|null|undefined} baseResp
     * @memberof live.GetTokenInfoResp
     * @instance
     */
    GetTokenInfoResp.prototype.baseResp = null;

    /**
     * GetTokenInfoResp quota.
     * @member {Long} quota
     * @memberof live.GetTokenInfoResp
     * @instance
     */
    GetTokenInfoResp.prototype.quota = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * GetTokenInfoResp group.
     * @member {live.GetTokenInfoResp.TokenGroup} group
     * @memberof live.GetTokenInfoResp
     * @instance
     */
    GetTokenInfoResp.prototype.group = 0;

    /**
     * GetTokenInfoResp isValid.
     * @member {boolean} isValid
     * @memberof live.GetTokenInfoResp
     * @instance
     */
    GetTokenInfoResp.prototype.isValid = false;

    /**
     * GetTokenInfoResp extra.
     * @member {Array.<base.IMapEntry>} extra
     * @memberof live.GetTokenInfoResp
     * @instance
     */
    GetTokenInfoResp.prototype.extra = $util.emptyArray;

    /**
     * Creates a new GetTokenInfoResp instance using the specified properties.
     * @function create
     * @memberof live.GetTokenInfoResp
     * @static
     * @param {live.IGetTokenInfoResp=} [properties] Properties to set
     * @returns {live.GetTokenInfoResp} GetTokenInfoResp instance
     */
    GetTokenInfoResp.create = function create(properties) {
      return new GetTokenInfoResp(properties);
    };

    /**
     * Encodes the specified GetTokenInfoResp message. Does not implicitly {@link live.GetTokenInfoResp.verify|verify} messages.
     * @function encode
     * @memberof live.GetTokenInfoResp
     * @static
     * @param {live.IGetTokenInfoResp} message GetTokenInfoResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetTokenInfoResp.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.baseResp != null &&
        Object.hasOwnProperty.call(message, 'baseResp')
      )
        $root.base.BaseResp.encode(
          message.baseResp,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (message.quota != null && Object.hasOwnProperty.call(message, 'quota'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.quota);
      if (message.group != null && Object.hasOwnProperty.call(message, 'group'))
        writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.group);
      if (
        message.isValid != null &&
        Object.hasOwnProperty.call(message, 'isValid')
      )
        writer.uint32(/* id 4, wireType 0 =*/ 32).bool(message.isValid);
      if (message.extra != null && message.extra.length)
        for (let i = 0; i < message.extra.length; ++i)
          $root.base.MapEntry.encode(
            message.extra[i],
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified GetTokenInfoResp message, length delimited. Does not implicitly {@link live.GetTokenInfoResp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.GetTokenInfoResp
     * @static
     * @param {live.IGetTokenInfoResp} message GetTokenInfoResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetTokenInfoResp.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetTokenInfoResp message from the specified reader or buffer.
     * @function decode
     * @memberof live.GetTokenInfoResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.GetTokenInfoResp} GetTokenInfoResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetTokenInfoResp.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.GetTokenInfoResp();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.baseResp = $root.base.BaseResp.decode(
              reader,
              reader.uint32()
            );
            break;
          case 2:
            message.quota = reader.int64();
            break;
          case 3:
            message.group = reader.int32();
            break;
          case 4:
            message.isValid = reader.bool();
            break;
          case 5:
            if (!(message.extra && message.extra.length)) message.extra = [];
            message.extra.push(
              $root.base.MapEntry.decode(reader, reader.uint32())
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a GetTokenInfoResp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.GetTokenInfoResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.GetTokenInfoResp} GetTokenInfoResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetTokenInfoResp.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetTokenInfoResp message.
     * @function verify
     * @memberof live.GetTokenInfoResp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetTokenInfoResp.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.baseResp != null && message.hasOwnProperty('baseResp')) {
        let error = $root.base.BaseResp.verify(message.baseResp);
        if (error) return 'baseResp.' + error;
      }
      if (message.quota != null && message.hasOwnProperty('quota'))
        if (
          !$util.isInteger(message.quota) &&
          !(
            message.quota &&
            $util.isInteger(message.quota.low) &&
            $util.isInteger(message.quota.high)
          )
        )
          return 'quota: integer|Long expected';
      if (message.group != null && message.hasOwnProperty('group'))
        switch (message.group) {
          default:
            return 'group: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.isValid != null && message.hasOwnProperty('isValid'))
        if (typeof message.isValid !== 'boolean')
          return 'isValid: boolean expected';
      if (message.extra != null && message.hasOwnProperty('extra')) {
        if (!Array.isArray(message.extra)) return 'extra: array expected';
        for (let i = 0; i < message.extra.length; ++i) {
          let error = $root.base.MapEntry.verify(message.extra[i]);
          if (error) return 'extra.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a GetTokenInfoResp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.GetTokenInfoResp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.GetTokenInfoResp} GetTokenInfoResp
     */
    GetTokenInfoResp.fromObject = function fromObject(object) {
      if (object instanceof $root.live.GetTokenInfoResp) return object;
      let message = new $root.live.GetTokenInfoResp();
      if (object.baseResp != null) {
        if (typeof object.baseResp !== 'object')
          throw TypeError('.live.GetTokenInfoResp.baseResp: object expected');
        message.baseResp = $root.base.BaseResp.fromObject(object.baseResp);
      }
      if (object.quota != null)
        if ($util.Long)
          (message.quota = $util.Long.fromValue(object.quota)).unsigned = false;
        else if (typeof object.quota === 'string')
          message.quota = parseInt(object.quota, 10);
        else if (typeof object.quota === 'number') message.quota = object.quota;
        else if (typeof object.quota === 'object')
          message.quota = new $util.LongBits(
            object.quota.low >>> 0,
            object.quota.high >>> 0
          ).toNumber();
      switch (object.group) {
        case 'SUPER':
        case 0:
          message.group = 0;
          break;
        case 'GREY':
        case 1:
          message.group = 1;
          break;
        case 'NORMAL':
        case 2:
          message.group = 2;
          break;
        case 'TEMPORARY':
        case 3:
          message.group = 3;
          break;
      }
      if (object.isValid != null) message.isValid = Boolean(object.isValid);
      if (object.extra) {
        if (!Array.isArray(object.extra))
          throw TypeError('.live.GetTokenInfoResp.extra: array expected');
        message.extra = [];
        for (let i = 0; i < object.extra.length; ++i) {
          if (typeof object.extra[i] !== 'object')
            throw TypeError('.live.GetTokenInfoResp.extra: object expected');
          message.extra[i] = $root.base.MapEntry.fromObject(object.extra[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a GetTokenInfoResp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.GetTokenInfoResp
     * @static
     * @param {live.GetTokenInfoResp} message GetTokenInfoResp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetTokenInfoResp.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.extra = [];
      if (options.defaults) {
        object.baseResp = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.quota =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.quota = options.longs === String ? '0' : 0;
        object.group = options.enums === String ? 'SUPER' : 0;
        object.isValid = false;
      }
      if (message.baseResp != null && message.hasOwnProperty('baseResp'))
        object.baseResp = $root.base.BaseResp.toObject(
          message.baseResp,
          options
        );
      if (message.quota != null && message.hasOwnProperty('quota'))
        if (typeof message.quota === 'number')
          object.quota =
            options.longs === String ? String(message.quota) : message.quota;
        else
          object.quota =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.quota)
              : options.longs === Number
              ? new $util.LongBits(
                  message.quota.low >>> 0,
                  message.quota.high >>> 0
                ).toNumber()
              : message.quota;
      if (message.group != null && message.hasOwnProperty('group'))
        object.group =
          options.enums === String
            ? $root.live.GetTokenInfoResp.TokenGroup[message.group]
            : message.group;
      if (message.isValid != null && message.hasOwnProperty('isValid'))
        object.isValid = message.isValid;
      if (message.extra && message.extra.length) {
        object.extra = [];
        for (let j = 0; j < message.extra.length; ++j)
          object.extra[j] = $root.base.MapEntry.toObject(
            message.extra[j],
            options
          );
      }
      return object;
    };

    /**
     * Converts this GetTokenInfoResp to JSON.
     * @function toJSON
     * @memberof live.GetTokenInfoResp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetTokenInfoResp.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * TokenGroup enum.
     * @name live.GetTokenInfoResp.TokenGroup
     * @enum {number}
     * @property {number} SUPER=0 SUPER value
     * @property {number} GREY=1 GREY value
     * @property {number} NORMAL=2 NORMAL value
     * @property {number} TEMPORARY=3 TEMPORARY value
     */
    GetTokenInfoResp.TokenGroup = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'SUPER')] = 0;
      values[(valuesById[1] = 'GREY')] = 1;
      values[(valuesById[2] = 'NORMAL')] = 2;
      values[(valuesById[3] = 'TEMPORARY')] = 3;
      return values;
    })();

    return GetTokenInfoResp;
  })();

  live.VersionInfo = (function () {
    /**
     * Properties of a VersionInfo.
     * @memberof live
     * @interface IVersionInfo
     * @property {string|null} [address] VersionInfo address
     * @property {Array.<string>|null} [versions] VersionInfo versions
     * @property {live.VersionInfo.Status|null} [status] VersionInfo status
     * @property {string|null} [currentTime] VersionInfo currentTime
     * @property {string|null} [stopServingTime] VersionInfo stopServingTime
     * @property {Array.<base.IMapEntry>|null} [extraInfo] VersionInfo extraInfo
     */

    /**
     * Constructs a new VersionInfo.
     * @memberof live
     * @classdesc Represents a VersionInfo.
     * @implements IVersionInfo
     * @constructor
     * @param {live.IVersionInfo=} [properties] Properties to set
     */
    function VersionInfo(properties) {
      this.versions = [];
      this.extraInfo = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * VersionInfo address.
     * @member {string} address
     * @memberof live.VersionInfo
     * @instance
     */
    VersionInfo.prototype.address = '';

    /**
     * VersionInfo versions.
     * @member {Array.<string>} versions
     * @memberof live.VersionInfo
     * @instance
     */
    VersionInfo.prototype.versions = $util.emptyArray;

    /**
     * VersionInfo status.
     * @member {live.VersionInfo.Status} status
     * @memberof live.VersionInfo
     * @instance
     */
    VersionInfo.prototype.status = 0;

    /**
     * VersionInfo currentTime.
     * @member {string} currentTime
     * @memberof live.VersionInfo
     * @instance
     */
    VersionInfo.prototype.currentTime = '';

    /**
     * VersionInfo stopServingTime.
     * @member {string} stopServingTime
     * @memberof live.VersionInfo
     * @instance
     */
    VersionInfo.prototype.stopServingTime = '';

    /**
     * VersionInfo extraInfo.
     * @member {Array.<base.IMapEntry>} extraInfo
     * @memberof live.VersionInfo
     * @instance
     */
    VersionInfo.prototype.extraInfo = $util.emptyArray;

    /**
     * Creates a new VersionInfo instance using the specified properties.
     * @function create
     * @memberof live.VersionInfo
     * @static
     * @param {live.IVersionInfo=} [properties] Properties to set
     * @returns {live.VersionInfo} VersionInfo instance
     */
    VersionInfo.create = function create(properties) {
      return new VersionInfo(properties);
    };

    /**
     * Encodes the specified VersionInfo message. Does not implicitly {@link live.VersionInfo.verify|verify} messages.
     * @function encode
     * @memberof live.VersionInfo
     * @static
     * @param {live.IVersionInfo} message VersionInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    VersionInfo.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.address != null &&
        Object.hasOwnProperty.call(message, 'address')
      )
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.address);
      if (message.versions != null && message.versions.length)
        for (let i = 0; i < message.versions.length; ++i)
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.versions[i]);
      if (
        message.status != null &&
        Object.hasOwnProperty.call(message, 'status')
      )
        writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.status);
      if (
        message.currentTime != null &&
        Object.hasOwnProperty.call(message, 'currentTime')
      )
        writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.currentTime);
      if (
        message.stopServingTime != null &&
        Object.hasOwnProperty.call(message, 'stopServingTime')
      )
        writer
          .uint32(/* id 5, wireType 2 =*/ 42)
          .string(message.stopServingTime);
      if (message.extraInfo != null && message.extraInfo.length)
        for (let i = 0; i < message.extraInfo.length; ++i)
          $root.base.MapEntry.encode(
            message.extraInfo[i],
            writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified VersionInfo message, length delimited. Does not implicitly {@link live.VersionInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.VersionInfo
     * @static
     * @param {live.IVersionInfo} message VersionInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    VersionInfo.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a VersionInfo message from the specified reader or buffer.
     * @function decode
     * @memberof live.VersionInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.VersionInfo} VersionInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    VersionInfo.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.VersionInfo();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.address = reader.string();
            break;
          case 2:
            if (!(message.versions && message.versions.length))
              message.versions = [];
            message.versions.push(reader.string());
            break;
          case 3:
            message.status = reader.int32();
            break;
          case 4:
            message.currentTime = reader.string();
            break;
          case 5:
            message.stopServingTime = reader.string();
            break;
          case 6:
            if (!(message.extraInfo && message.extraInfo.length))
              message.extraInfo = [];
            message.extraInfo.push(
              $root.base.MapEntry.decode(reader, reader.uint32())
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a VersionInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.VersionInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.VersionInfo} VersionInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    VersionInfo.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a VersionInfo message.
     * @function verify
     * @memberof live.VersionInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    VersionInfo.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.address != null && message.hasOwnProperty('address'))
        if (!$util.isString(message.address)) return 'address: string expected';
      if (message.versions != null && message.hasOwnProperty('versions')) {
        if (!Array.isArray(message.versions)) return 'versions: array expected';
        for (let i = 0; i < message.versions.length; ++i)
          if (!$util.isString(message.versions[i]))
            return 'versions: string[] expected';
      }
      if (message.status != null && message.hasOwnProperty('status'))
        switch (message.status) {
          default:
            return 'status: enum value expected';
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.currentTime != null && message.hasOwnProperty('currentTime'))
        if (!$util.isString(message.currentTime))
          return 'currentTime: string expected';
      if (
        message.stopServingTime != null &&
        message.hasOwnProperty('stopServingTime')
      )
        if (!$util.isString(message.stopServingTime))
          return 'stopServingTime: string expected';
      if (message.extraInfo != null && message.hasOwnProperty('extraInfo')) {
        if (!Array.isArray(message.extraInfo))
          return 'extraInfo: array expected';
        for (let i = 0; i < message.extraInfo.length; ++i) {
          let error = $root.base.MapEntry.verify(message.extraInfo[i]);
          if (error) return 'extraInfo.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a VersionInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.VersionInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.VersionInfo} VersionInfo
     */
    VersionInfo.fromObject = function fromObject(object) {
      if (object instanceof $root.live.VersionInfo) return object;
      let message = new $root.live.VersionInfo();
      if (object.address != null) message.address = String(object.address);
      if (object.versions) {
        if (!Array.isArray(object.versions))
          throw TypeError('.live.VersionInfo.versions: array expected');
        message.versions = [];
        for (let i = 0; i < object.versions.length; ++i)
          message.versions[i] = String(object.versions[i]);
      }
      switch (object.status) {
        case 'UNSPECIFIED':
        case 0:
          message.status = 0;
          break;
        case 'AVAILABLE':
        case 1:
          message.status = 1;
          break;
        case 'READY_TO_STOP_SERVING':
        case 2:
          message.status = 2;
          break;
      }
      if (object.currentTime != null)
        message.currentTime = String(object.currentTime);
      if (object.stopServingTime != null)
        message.stopServingTime = String(object.stopServingTime);
      if (object.extraInfo) {
        if (!Array.isArray(object.extraInfo))
          throw TypeError('.live.VersionInfo.extraInfo: array expected');
        message.extraInfo = [];
        for (let i = 0; i < object.extraInfo.length; ++i) {
          if (typeof object.extraInfo[i] !== 'object')
            throw TypeError('.live.VersionInfo.extraInfo: object expected');
          message.extraInfo[i] = $root.base.MapEntry.fromObject(
            object.extraInfo[i]
          );
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a VersionInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.VersionInfo
     * @static
     * @param {live.VersionInfo} message VersionInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    VersionInfo.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.versions = [];
        object.extraInfo = [];
      }
      if (options.defaults) {
        object.address = '';
        object.status = options.enums === String ? 'UNSPECIFIED' : 0;
        object.currentTime = '';
        object.stopServingTime = '';
      }
      if (message.address != null && message.hasOwnProperty('address'))
        object.address = message.address;
      if (message.versions && message.versions.length) {
        object.versions = [];
        for (let j = 0; j < message.versions.length; ++j)
          object.versions[j] = message.versions[j];
      }
      if (message.status != null && message.hasOwnProperty('status'))
        object.status =
          options.enums === String
            ? $root.live.VersionInfo.Status[message.status]
            : message.status;
      if (message.currentTime != null && message.hasOwnProperty('currentTime'))
        object.currentTime = message.currentTime;
      if (
        message.stopServingTime != null &&
        message.hasOwnProperty('stopServingTime')
      )
        object.stopServingTime = message.stopServingTime;
      if (message.extraInfo && message.extraInfo.length) {
        object.extraInfo = [];
        for (let j = 0; j < message.extraInfo.length; ++j)
          object.extraInfo[j] = $root.base.MapEntry.toObject(
            message.extraInfo[j],
            options
          );
      }
      return object;
    };

    /**
     * Converts this VersionInfo to JSON.
     * @function toJSON
     * @memberof live.VersionInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    VersionInfo.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Status enum.
     * @name live.VersionInfo.Status
     * @enum {number}
     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
     * @property {number} AVAILABLE=1 AVAILABLE value
     * @property {number} READY_TO_STOP_SERVING=2 READY_TO_STOP_SERVING value
     */
    VersionInfo.Status = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'UNSPECIFIED')] = 0;
      values[(valuesById[1] = 'AVAILABLE')] = 1;
      values[(valuesById[2] = 'READY_TO_STOP_SERVING')] = 2;
      return values;
    })();

    return VersionInfo;
  })();

  live.GetVersionInfoReq = (function () {
    /**
     * Properties of a GetVersionInfoReq.
     * @memberof live
     * @interface IGetVersionInfoReq
     * @property {base.IBase|null} [base] GetVersionInfoReq base
     */

    /**
     * Constructs a new GetVersionInfoReq.
     * @memberof live
     * @classdesc Represents a GetVersionInfoReq.
     * @implements IGetVersionInfoReq
     * @constructor
     * @param {live.IGetVersionInfoReq=} [properties] Properties to set
     */
    function GetVersionInfoReq(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetVersionInfoReq base.
     * @member {base.IBase|null|undefined} base
     * @memberof live.GetVersionInfoReq
     * @instance
     */
    GetVersionInfoReq.prototype.base = null;

    /**
     * Creates a new GetVersionInfoReq instance using the specified properties.
     * @function create
     * @memberof live.GetVersionInfoReq
     * @static
     * @param {live.IGetVersionInfoReq=} [properties] Properties to set
     * @returns {live.GetVersionInfoReq} GetVersionInfoReq instance
     */
    GetVersionInfoReq.create = function create(properties) {
      return new GetVersionInfoReq(properties);
    };

    /**
     * Encodes the specified GetVersionInfoReq message. Does not implicitly {@link live.GetVersionInfoReq.verify|verify} messages.
     * @function encode
     * @memberof live.GetVersionInfoReq
     * @static
     * @param {live.IGetVersionInfoReq} message GetVersionInfoReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetVersionInfoReq.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.base != null && Object.hasOwnProperty.call(message, 'base'))
        $root.base.Base.encode(
          message.base,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified GetVersionInfoReq message, length delimited. Does not implicitly {@link live.GetVersionInfoReq.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.GetVersionInfoReq
     * @static
     * @param {live.IGetVersionInfoReq} message GetVersionInfoReq message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetVersionInfoReq.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetVersionInfoReq message from the specified reader or buffer.
     * @function decode
     * @memberof live.GetVersionInfoReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.GetVersionInfoReq} GetVersionInfoReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetVersionInfoReq.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.GetVersionInfoReq();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.base = $root.base.Base.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a GetVersionInfoReq message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.GetVersionInfoReq
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.GetVersionInfoReq} GetVersionInfoReq
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetVersionInfoReq.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetVersionInfoReq message.
     * @function verify
     * @memberof live.GetVersionInfoReq
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetVersionInfoReq.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.base != null && message.hasOwnProperty('base')) {
        let error = $root.base.Base.verify(message.base);
        if (error) return 'base.' + error;
      }
      return null;
    };

    /**
     * Creates a GetVersionInfoReq message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.GetVersionInfoReq
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.GetVersionInfoReq} GetVersionInfoReq
     */
    GetVersionInfoReq.fromObject = function fromObject(object) {
      if (object instanceof $root.live.GetVersionInfoReq) return object;
      let message = new $root.live.GetVersionInfoReq();
      if (object.base != null) {
        if (typeof object.base !== 'object')
          throw TypeError('.live.GetVersionInfoReq.base: object expected');
        message.base = $root.base.Base.fromObject(object.base);
      }
      return message;
    };

    /**
     * Creates a plain object from a GetVersionInfoReq message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.GetVersionInfoReq
     * @static
     * @param {live.GetVersionInfoReq} message GetVersionInfoReq
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetVersionInfoReq.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.base = null;
      if (message.base != null && message.hasOwnProperty('base'))
        object.base = $root.base.Base.toObject(message.base, options);
      return object;
    };

    /**
     * Converts this GetVersionInfoReq to JSON.
     * @function toJSON
     * @memberof live.GetVersionInfoReq
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetVersionInfoReq.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetVersionInfoReq;
  })();

  live.GetVersionInfoResp = (function () {
    /**
     * Properties of a GetVersionInfoResp.
     * @memberof live
     * @interface IGetVersionInfoResp
     * @property {base.IBaseResp|null} [baseResp] GetVersionInfoResp baseResp
     * @property {Array.<live.IVersionInfo>|null} [versions] GetVersionInfoResp versions
     * @property {Array.<base.IMapEntry>|null} [extra] GetVersionInfoResp extra
     */

    /**
     * Constructs a new GetVersionInfoResp.
     * @memberof live
     * @classdesc Represents a GetVersionInfoResp.
     * @implements IGetVersionInfoResp
     * @constructor
     * @param {live.IGetVersionInfoResp=} [properties] Properties to set
     */
    function GetVersionInfoResp(properties) {
      this.versions = [];
      this.extra = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetVersionInfoResp baseResp.
     * @member {base.IBaseResp|null|undefined} baseResp
     * @memberof live.GetVersionInfoResp
     * @instance
     */
    GetVersionInfoResp.prototype.baseResp = null;

    /**
     * GetVersionInfoResp versions.
     * @member {Array.<live.IVersionInfo>} versions
     * @memberof live.GetVersionInfoResp
     * @instance
     */
    GetVersionInfoResp.prototype.versions = $util.emptyArray;

    /**
     * GetVersionInfoResp extra.
     * @member {Array.<base.IMapEntry>} extra
     * @memberof live.GetVersionInfoResp
     * @instance
     */
    GetVersionInfoResp.prototype.extra = $util.emptyArray;

    /**
     * Creates a new GetVersionInfoResp instance using the specified properties.
     * @function create
     * @memberof live.GetVersionInfoResp
     * @static
     * @param {live.IGetVersionInfoResp=} [properties] Properties to set
     * @returns {live.GetVersionInfoResp} GetVersionInfoResp instance
     */
    GetVersionInfoResp.create = function create(properties) {
      return new GetVersionInfoResp(properties);
    };

    /**
     * Encodes the specified GetVersionInfoResp message. Does not implicitly {@link live.GetVersionInfoResp.verify|verify} messages.
     * @function encode
     * @memberof live.GetVersionInfoResp
     * @static
     * @param {live.IGetVersionInfoResp} message GetVersionInfoResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetVersionInfoResp.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.baseResp != null &&
        Object.hasOwnProperty.call(message, 'baseResp')
      )
        $root.base.BaseResp.encode(
          message.baseResp,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (message.versions != null && message.versions.length)
        for (let i = 0; i < message.versions.length; ++i)
          $root.live.VersionInfo.encode(
            message.versions[i],
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
      if (message.extra != null && message.extra.length)
        for (let i = 0; i < message.extra.length; ++i)
          $root.base.MapEntry.encode(
            message.extra[i],
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified GetVersionInfoResp message, length delimited. Does not implicitly {@link live.GetVersionInfoResp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof live.GetVersionInfoResp
     * @static
     * @param {live.IGetVersionInfoResp} message GetVersionInfoResp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetVersionInfoResp.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetVersionInfoResp message from the specified reader or buffer.
     * @function decode
     * @memberof live.GetVersionInfoResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {live.GetVersionInfoResp} GetVersionInfoResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetVersionInfoResp.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.live.GetVersionInfoResp();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.baseResp = $root.base.BaseResp.decode(
              reader,
              reader.uint32()
            );
            break;
          case 2:
            if (!(message.versions && message.versions.length))
              message.versions = [];
            message.versions.push(
              $root.live.VersionInfo.decode(reader, reader.uint32())
            );
            break;
          case 5:
            if (!(message.extra && message.extra.length)) message.extra = [];
            message.extra.push(
              $root.base.MapEntry.decode(reader, reader.uint32())
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a GetVersionInfoResp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof live.GetVersionInfoResp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {live.GetVersionInfoResp} GetVersionInfoResp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetVersionInfoResp.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetVersionInfoResp message.
     * @function verify
     * @memberof live.GetVersionInfoResp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetVersionInfoResp.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.baseResp != null && message.hasOwnProperty('baseResp')) {
        let error = $root.base.BaseResp.verify(message.baseResp);
        if (error) return 'baseResp.' + error;
      }
      if (message.versions != null && message.hasOwnProperty('versions')) {
        if (!Array.isArray(message.versions)) return 'versions: array expected';
        for (let i = 0; i < message.versions.length; ++i) {
          let error = $root.live.VersionInfo.verify(message.versions[i]);
          if (error) return 'versions.' + error;
        }
      }
      if (message.extra != null && message.hasOwnProperty('extra')) {
        if (!Array.isArray(message.extra)) return 'extra: array expected';
        for (let i = 0; i < message.extra.length; ++i) {
          let error = $root.base.MapEntry.verify(message.extra[i]);
          if (error) return 'extra.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a GetVersionInfoResp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof live.GetVersionInfoResp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {live.GetVersionInfoResp} GetVersionInfoResp
     */
    GetVersionInfoResp.fromObject = function fromObject(object) {
      if (object instanceof $root.live.GetVersionInfoResp) return object;
      let message = new $root.live.GetVersionInfoResp();
      if (object.baseResp != null) {
        if (typeof object.baseResp !== 'object')
          throw TypeError('.live.GetVersionInfoResp.baseResp: object expected');
        message.baseResp = $root.base.BaseResp.fromObject(object.baseResp);
      }
      if (object.versions) {
        if (!Array.isArray(object.versions))
          throw TypeError('.live.GetVersionInfoResp.versions: array expected');
        message.versions = [];
        for (let i = 0; i < object.versions.length; ++i) {
          if (typeof object.versions[i] !== 'object')
            throw TypeError(
              '.live.GetVersionInfoResp.versions: object expected'
            );
          message.versions[i] = $root.live.VersionInfo.fromObject(
            object.versions[i]
          );
        }
      }
      if (object.extra) {
        if (!Array.isArray(object.extra))
          throw TypeError('.live.GetVersionInfoResp.extra: array expected');
        message.extra = [];
        for (let i = 0; i < object.extra.length; ++i) {
          if (typeof object.extra[i] !== 'object')
            throw TypeError('.live.GetVersionInfoResp.extra: object expected');
          message.extra[i] = $root.base.MapEntry.fromObject(object.extra[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a GetVersionInfoResp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof live.GetVersionInfoResp
     * @static
     * @param {live.GetVersionInfoResp} message GetVersionInfoResp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetVersionInfoResp.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.versions = [];
        object.extra = [];
      }
      if (options.defaults) object.baseResp = null;
      if (message.baseResp != null && message.hasOwnProperty('baseResp'))
        object.baseResp = $root.base.BaseResp.toObject(
          message.baseResp,
          options
        );
      if (message.versions && message.versions.length) {
        object.versions = [];
        for (let j = 0; j < message.versions.length; ++j)
          object.versions[j] = $root.live.VersionInfo.toObject(
            message.versions[j],
            options
          );
      }
      if (message.extra && message.extra.length) {
        object.extra = [];
        for (let j = 0; j < message.extra.length; ++j)
          object.extra[j] = $root.base.MapEntry.toObject(
            message.extra[j],
            options
          );
      }
      return object;
    };

    /**
     * Converts this GetVersionInfoResp to JSON.
     * @function toJSON
     * @memberof live.GetVersionInfoResp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetVersionInfoResp.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetVersionInfoResp;
  })();

  live.LiveService = (function () {
    /**
     * Constructs a new LiveService service.
     * @memberof live
     * @classdesc Represents a LiveService
     * @extends $protobuf.rpc.Service
     * @constructor
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     */
    function LiveService(rpcImpl, requestDelimited, responseDelimited) {
      $protobuf.rpc.Service.call(
        this,
        rpcImpl,
        requestDelimited,
        responseDelimited
      );
    }

    (LiveService.prototype = Object.create(
      $protobuf.rpc.Service.prototype
    )).constructor = LiveService;

    /**
     * Creates new LiveService service using the specified rpc implementation.
     * @function create
     * @memberof live.LiveService
     * @static
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     * @returns {LiveService} RPC service. Useful where requests and/or responses are streamed.
     */
    LiveService.create = function create(
      rpcImpl,
      requestDelimited,
      responseDelimited
    ) {
      return new this(rpcImpl, requestDelimited, responseDelimited);
    };

    /**
     * Callback as used by {@link live.LiveService#getLatestFinalSubtitle}.
     * @memberof live.LiveService
     * @typedef GetLatestFinalSubtitleCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {live.GetLatestFinalSubtitleResp} [response] GetLatestFinalSubtitleResp
     */

    /**
     * Calls GetLatestFinalSubtitle.
     * @function getLatestFinalSubtitle
     * @memberof live.LiveService
     * @instance
     * @param {live.IGetLatestFinalSubtitleReq} request GetLatestFinalSubtitleReq message or plain object
     * @param {live.LiveService.GetLatestFinalSubtitleCallback} callback Node-style callback called with the error, if any, and GetLatestFinalSubtitleResp
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (LiveService.prototype.getLatestFinalSubtitle = function getLatestFinalSubtitle(
        request,
        callback
      ) {
        return this.rpcCall(
          getLatestFinalSubtitle,
          $root.live.GetLatestFinalSubtitleReq,
          $root.live.GetLatestFinalSubtitleResp,
          request,
          callback
        );
      }),
      'name',
      { value: 'GetLatestFinalSubtitle' }
    );

    /**
     * Calls GetLatestFinalSubtitle.
     * @function getLatestFinalSubtitle
     * @memberof live.LiveService
     * @instance
     * @param {live.IGetLatestFinalSubtitleReq} request GetLatestFinalSubtitleReq message or plain object
     * @returns {Promise<live.GetLatestFinalSubtitleResp>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link live.LiveService#getFinalSubtitles}.
     * @memberof live.LiveService
     * @typedef GetFinalSubtitlesCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {live.GetFinalSubtitlesResp} [response] GetFinalSubtitlesResp
     */

    /**
     * Calls GetFinalSubtitles.
     * @function getFinalSubtitles
     * @memberof live.LiveService
     * @instance
     * @param {live.IGetFinalSubtitlesReq} request GetFinalSubtitlesReq message or plain object
     * @param {live.LiveService.GetFinalSubtitlesCallback} callback Node-style callback called with the error, if any, and GetFinalSubtitlesResp
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (LiveService.prototype.getFinalSubtitles = function getFinalSubtitles(
        request,
        callback
      ) {
        return this.rpcCall(
          getFinalSubtitles,
          $root.live.GetFinalSubtitlesReq,
          $root.live.GetFinalSubtitlesResp,
          request,
          callback
        );
      }),
      'name',
      { value: 'GetFinalSubtitles' }
    );

    /**
     * Calls GetFinalSubtitles.
     * @function getFinalSubtitles
     * @memberof live.LiveService
     * @instance
     * @param {live.IGetFinalSubtitlesReq} request GetFinalSubtitlesReq message or plain object
     * @returns {Promise<live.GetFinalSubtitlesResp>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link live.LiveService#updateFinalSubtitle}.
     * @memberof live.LiveService
     * @typedef UpdateFinalSubtitleCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {live.UpdateFinalSubtitleResp} [response] UpdateFinalSubtitleResp
     */

    /**
     * Calls UpdateFinalSubtitle.
     * @function updateFinalSubtitle
     * @memberof live.LiveService
     * @instance
     * @param {live.IUpdateFinalSubtitleReq} request UpdateFinalSubtitleReq message or plain object
     * @param {live.LiveService.UpdateFinalSubtitleCallback} callback Node-style callback called with the error, if any, and UpdateFinalSubtitleResp
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (LiveService.prototype.updateFinalSubtitle = function updateFinalSubtitle(
        request,
        callback
      ) {
        return this.rpcCall(
          updateFinalSubtitle,
          $root.live.UpdateFinalSubtitleReq,
          $root.live.UpdateFinalSubtitleResp,
          request,
          callback
        );
      }),
      'name',
      { value: 'UpdateFinalSubtitle' }
    );

    /**
     * Calls UpdateFinalSubtitle.
     * @function updateFinalSubtitle
     * @memberof live.LiveService
     * @instance
     * @param {live.IUpdateFinalSubtitleReq} request UpdateFinalSubtitleReq message or plain object
     * @returns {Promise<live.UpdateFinalSubtitleResp>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link live.LiveService#organizeMinutes}.
     * @memberof live.LiveService
     * @typedef OrganizeMinutesCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {live.OrganizeMinutesResp} [response] OrganizeMinutesResp
     */

    /**
     * Calls OrganizeMinutes.
     * @function organizeMinutes
     * @memberof live.LiveService
     * @instance
     * @param {live.IOrganizeMinutesReq} request OrganizeMinutesReq message or plain object
     * @param {live.LiveService.OrganizeMinutesCallback} callback Node-style callback called with the error, if any, and OrganizeMinutesResp
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (LiveService.prototype.organizeMinutes = function organizeMinutes(
        request,
        callback
      ) {
        return this.rpcCall(
          organizeMinutes,
          $root.live.OrganizeMinutesReq,
          $root.live.OrganizeMinutesResp,
          request,
          callback
        );
      }),
      'name',
      { value: 'OrganizeMinutes' }
    );

    /**
     * Calls OrganizeMinutes.
     * @function organizeMinutes
     * @memberof live.LiveService
     * @instance
     * @param {live.IOrganizeMinutesReq} request OrganizeMinutesReq message or plain object
     * @returns {Promise<live.OrganizeMinutesResp>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link live.LiveService#downloadMinutes}.
     * @memberof live.LiveService
     * @typedef DownloadMinutesCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {live.DownloadMinutesResp} [response] DownloadMinutesResp
     */

    /**
     * Calls DownloadMinutes.
     * @function downloadMinutes
     * @memberof live.LiveService
     * @instance
     * @param {live.IDownloadMinutesReq} request DownloadMinutesReq message or plain object
     * @param {live.LiveService.DownloadMinutesCallback} callback Node-style callback called with the error, if any, and DownloadMinutesResp
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (LiveService.prototype.downloadMinutes = function downloadMinutes(
        request,
        callback
      ) {
        return this.rpcCall(
          downloadMinutes,
          $root.live.DownloadMinutesReq,
          $root.live.DownloadMinutesResp,
          request,
          callback
        );
      }),
      'name',
      { value: 'DownloadMinutes' }
    );

    /**
     * Calls DownloadMinutes.
     * @function downloadMinutes
     * @memberof live.LiveService
     * @instance
     * @param {live.IDownloadMinutesReq} request DownloadMinutesReq message or plain object
     * @returns {Promise<live.DownloadMinutesResp>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link live.LiveService#deleteRoom}.
     * @memberof live.LiveService
     * @typedef DeleteRoomCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {live.DeleteRoomResp} [response] DeleteRoomResp
     */

    /**
     * Calls DeleteRoom.
     * @function deleteRoom
     * @memberof live.LiveService
     * @instance
     * @param {live.IDeleteRoomReq} request DeleteRoomReq message or plain object
     * @param {live.LiveService.DeleteRoomCallback} callback Node-style callback called with the error, if any, and DeleteRoomResp
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (LiveService.prototype.deleteRoom = function deleteRoom(
        request,
        callback
      ) {
        return this.rpcCall(
          deleteRoom,
          $root.live.DeleteRoomReq,
          $root.live.DeleteRoomResp,
          request,
          callback
        );
      }),
      'name',
      { value: 'DeleteRoom' }
    );

    /**
     * Calls DeleteRoom.
     * @function deleteRoom
     * @memberof live.LiveService
     * @instance
     * @param {live.IDeleteRoomReq} request DeleteRoomReq message or plain object
     * @returns {Promise<live.DeleteRoomResp>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link live.LiveService#createRoom}.
     * @memberof live.LiveService
     * @typedef CreateRoomCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {live.CreateRoomResp} [response] CreateRoomResp
     */

    /**
     * Calls CreateRoom.
     * @function createRoom
     * @memberof live.LiveService
     * @instance
     * @param {live.ICreateRoomReq} request CreateRoomReq message or plain object
     * @param {live.LiveService.CreateRoomCallback} callback Node-style callback called with the error, if any, and CreateRoomResp
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (LiveService.prototype.createRoom = function createRoom(
        request,
        callback
      ) {
        return this.rpcCall(
          createRoom,
          $root.live.CreateRoomReq,
          $root.live.CreateRoomResp,
          request,
          callback
        );
      }),
      'name',
      { value: 'CreateRoom' }
    );

    /**
     * Calls CreateRoom.
     * @function createRoom
     * @memberof live.LiveService
     * @instance
     * @param {live.ICreateRoomReq} request CreateRoomReq message or plain object
     * @returns {Promise<live.CreateRoomResp>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link live.LiveService#startRoom}.
     * @memberof live.LiveService
     * @typedef StartRoomCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {live.StartRoomResp} [response] StartRoomResp
     */

    /**
     * Calls StartRoom.
     * @function startRoom
     * @memberof live.LiveService
     * @instance
     * @param {live.IStartRoomReq} request StartRoomReq message or plain object
     * @param {live.LiveService.StartRoomCallback} callback Node-style callback called with the error, if any, and StartRoomResp
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (LiveService.prototype.startRoom = function startRoom(request, callback) {
        return this.rpcCall(
          startRoom,
          $root.live.StartRoomReq,
          $root.live.StartRoomResp,
          request,
          callback
        );
      }),
      'name',
      { value: 'StartRoom' }
    );

    /**
     * Calls StartRoom.
     * @function startRoom
     * @memberof live.LiveService
     * @instance
     * @param {live.IStartRoomReq} request StartRoomReq message or plain object
     * @returns {Promise<live.StartRoomResp>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link live.LiveService#getTokenInfo}.
     * @memberof live.LiveService
     * @typedef GetTokenInfoCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {live.GetTokenInfoResp} [response] GetTokenInfoResp
     */

    /**
     * Calls GetTokenInfo.
     * @function getTokenInfo
     * @memberof live.LiveService
     * @instance
     * @param {live.IGetTokenInfoReq} request GetTokenInfoReq message or plain object
     * @param {live.LiveService.GetTokenInfoCallback} callback Node-style callback called with the error, if any, and GetTokenInfoResp
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (LiveService.prototype.getTokenInfo = function getTokenInfo(
        request,
        callback
      ) {
        return this.rpcCall(
          getTokenInfo,
          $root.live.GetTokenInfoReq,
          $root.live.GetTokenInfoResp,
          request,
          callback
        );
      }),
      'name',
      { value: 'GetTokenInfo' }
    );

    /**
     * Calls GetTokenInfo.
     * @function getTokenInfo
     * @memberof live.LiveService
     * @instance
     * @param {live.IGetTokenInfoReq} request GetTokenInfoReq message or plain object
     * @returns {Promise<live.GetTokenInfoResp>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link live.LiveService#getVersionInfo}.
     * @memberof live.LiveService
     * @typedef GetVersionInfoCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {live.GetVersionInfoResp} [response] GetVersionInfoResp
     */

    /**
     * Calls GetVersionInfo.
     * @function getVersionInfo
     * @memberof live.LiveService
     * @instance
     * @param {live.IGetVersionInfoReq} request GetVersionInfoReq message or plain object
     * @param {live.LiveService.GetVersionInfoCallback} callback Node-style callback called with the error, if any, and GetVersionInfoResp
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (LiveService.prototype.getVersionInfo = function getVersionInfo(
        request,
        callback
      ) {
        return this.rpcCall(
          getVersionInfo,
          $root.live.GetVersionInfoReq,
          $root.live.GetVersionInfoResp,
          request,
          callback
        );
      }),
      'name',
      { value: 'GetVersionInfo' }
    );

    /**
     * Calls GetVersionInfo.
     * @function getVersionInfo
     * @memberof live.LiveService
     * @instance
     * @param {live.IGetVersionInfoReq} request GetVersionInfoReq message or plain object
     * @returns {Promise<live.GetVersionInfoResp>} Promise
     * @variation 2
     */

    return LiveService;
  })();

  return live;
})());

export const si = ($root.si = (() => {
  /**
   * Namespace si.
   * @exports si
   * @namespace
   */
  const si = {};

  si.SpeechInputsMessage = (function () {
    /**
     * Properties of a SpeechInputsMessage.
     * @memberof si
     * @interface ISpeechInputsMessage
     * @property {si.SpeechInputsMessage.SpeechEventType|null} [eventType] SpeechInputsMessage eventType
     * @property {si.ISimultaneousInterpretationConfiguration|null} [configuration] SpeechInputsMessage configuration
     * @property {si.IAudioPacket|null} [audio] SpeechInputsMessage audio
     * @property {Array.<base.IMapEntry>|null} [entry] SpeechInputsMessage entry
     */

    /**
     * Constructs a new SpeechInputsMessage.
     * @memberof si
     * @classdesc Represents a SpeechInputsMessage.
     * @implements ISpeechInputsMessage
     * @constructor
     * @param {si.ISpeechInputsMessage=} [properties] Properties to set
     */
    function SpeechInputsMessage(properties) {
      this.entry = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SpeechInputsMessage eventType.
     * @member {si.SpeechInputsMessage.SpeechEventType} eventType
     * @memberof si.SpeechInputsMessage
     * @instance
     */
    SpeechInputsMessage.prototype.eventType = 0;

    /**
     * SpeechInputsMessage configuration.
     * @member {si.ISimultaneousInterpretationConfiguration|null|undefined} configuration
     * @memberof si.SpeechInputsMessage
     * @instance
     */
    SpeechInputsMessage.prototype.configuration = null;

    /**
     * SpeechInputsMessage audio.
     * @member {si.IAudioPacket|null|undefined} audio
     * @memberof si.SpeechInputsMessage
     * @instance
     */
    SpeechInputsMessage.prototype.audio = null;

    /**
     * SpeechInputsMessage entry.
     * @member {Array.<base.IMapEntry>} entry
     * @memberof si.SpeechInputsMessage
     * @instance
     */
    SpeechInputsMessage.prototype.entry = $util.emptyArray;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * SpeechInputsMessage inputs.
     * @member {"configuration"|"audio"|undefined} inputs
     * @memberof si.SpeechInputsMessage
     * @instance
     */
    Object.defineProperty(SpeechInputsMessage.prototype, 'inputs', {
      get: $util.oneOfGetter(($oneOfFields = ['configuration', 'audio'])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new SpeechInputsMessage instance using the specified properties.
     * @function create
     * @memberof si.SpeechInputsMessage
     * @static
     * @param {si.ISpeechInputsMessage=} [properties] Properties to set
     * @returns {si.SpeechInputsMessage} SpeechInputsMessage instance
     */
    SpeechInputsMessage.create = function create(properties) {
      return new SpeechInputsMessage(properties);
    };

    /**
     * Encodes the specified SpeechInputsMessage message. Does not implicitly {@link si.SpeechInputsMessage.verify|verify} messages.
     * @function encode
     * @memberof si.SpeechInputsMessage
     * @static
     * @param {si.ISpeechInputsMessage} message SpeechInputsMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpeechInputsMessage.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.eventType != null &&
        Object.hasOwnProperty.call(message, 'eventType')
      )
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.eventType);
      if (
        message.configuration != null &&
        Object.hasOwnProperty.call(message, 'configuration')
      )
        $root.si.SimultaneousInterpretationConfiguration.encode(
          message.configuration,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      if (message.entry != null && message.entry.length)
        for (let i = 0; i < message.entry.length; ++i)
          $root.base.MapEntry.encode(
            message.entry[i],
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
      if (message.audio != null && Object.hasOwnProperty.call(message, 'audio'))
        $root.si.AudioPacket.encode(
          message.audio,
          writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified SpeechInputsMessage message, length delimited. Does not implicitly {@link si.SpeechInputsMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.SpeechInputsMessage
     * @static
     * @param {si.ISpeechInputsMessage} message SpeechInputsMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpeechInputsMessage.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SpeechInputsMessage message from the specified reader or buffer.
     * @function decode
     * @memberof si.SpeechInputsMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.SpeechInputsMessage} SpeechInputsMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpeechInputsMessage.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.SpeechInputsMessage();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.eventType = reader.int32();
            break;
          case 2:
            message.configuration = $root.si.SimultaneousInterpretationConfiguration.decode(
              reader,
              reader.uint32()
            );
            break;
          case 8:
            message.audio = $root.si.AudioPacket.decode(
              reader,
              reader.uint32()
            );
            break;
          case 3:
            if (!(message.entry && message.entry.length)) message.entry = [];
            message.entry.push(
              $root.base.MapEntry.decode(reader, reader.uint32())
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SpeechInputsMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.SpeechInputsMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.SpeechInputsMessage} SpeechInputsMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpeechInputsMessage.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SpeechInputsMessage message.
     * @function verify
     * @memberof si.SpeechInputsMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SpeechInputsMessage.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      let properties = {};
      if (message.eventType != null && message.hasOwnProperty('eventType'))
        switch (message.eventType) {
          default:
            return 'eventType: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (
        message.configuration != null &&
        message.hasOwnProperty('configuration')
      ) {
        properties.inputs = 1;
        {
          let error = $root.si.SimultaneousInterpretationConfiguration.verify(
            message.configuration
          );
          if (error) return 'configuration.' + error;
        }
      }
      if (message.audio != null && message.hasOwnProperty('audio')) {
        if (properties.inputs === 1) return 'inputs: multiple values';
        properties.inputs = 1;
        {
          let error = $root.si.AudioPacket.verify(message.audio);
          if (error) return 'audio.' + error;
        }
      }
      if (message.entry != null && message.hasOwnProperty('entry')) {
        if (!Array.isArray(message.entry)) return 'entry: array expected';
        for (let i = 0; i < message.entry.length; ++i) {
          let error = $root.base.MapEntry.verify(message.entry[i]);
          if (error) return 'entry.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a SpeechInputsMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.SpeechInputsMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.SpeechInputsMessage} SpeechInputsMessage
     */
    SpeechInputsMessage.fromObject = function fromObject(object) {
      if (object instanceof $root.si.SpeechInputsMessage) return object;
      let message = new $root.si.SpeechInputsMessage();
      switch (object.eventType) {
        case 'UNSPECIFIED':
        case 0:
          message.eventType = 0;
          break;
        case 'CONFIGURATION':
        case 1:
          message.eventType = 1;
          break;
        case 'AUDIO':
        case 2:
          message.eventType = 2;
          break;
        case 'PING':
        case 3:
          message.eventType = 3;
          break;
      }
      if (object.configuration != null) {
        if (typeof object.configuration !== 'object')
          throw TypeError(
            '.si.SpeechInputsMessage.configuration: object expected'
          );
        message.configuration = $root.si.SimultaneousInterpretationConfiguration.fromObject(
          object.configuration
        );
      }
      if (object.audio != null) {
        if (typeof object.audio !== 'object')
          throw TypeError('.si.SpeechInputsMessage.audio: object expected');
        message.audio = $root.si.AudioPacket.fromObject(object.audio);
      }
      if (object.entry) {
        if (!Array.isArray(object.entry))
          throw TypeError('.si.SpeechInputsMessage.entry: array expected');
        message.entry = [];
        for (let i = 0; i < object.entry.length; ++i) {
          if (typeof object.entry[i] !== 'object')
            throw TypeError('.si.SpeechInputsMessage.entry: object expected');
          message.entry[i] = $root.base.MapEntry.fromObject(object.entry[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a SpeechInputsMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.SpeechInputsMessage
     * @static
     * @param {si.SpeechInputsMessage} message SpeechInputsMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SpeechInputsMessage.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.entry = [];
      if (options.defaults)
        object.eventType = options.enums === String ? 'UNSPECIFIED' : 0;
      if (message.eventType != null && message.hasOwnProperty('eventType'))
        object.eventType =
          options.enums === String
            ? $root.si.SpeechInputsMessage.SpeechEventType[message.eventType]
            : message.eventType;
      if (
        message.configuration != null &&
        message.hasOwnProperty('configuration')
      ) {
        object.configuration = $root.si.SimultaneousInterpretationConfiguration.toObject(
          message.configuration,
          options
        );
        if (options.oneofs) object.inputs = 'configuration';
      }
      if (message.entry && message.entry.length) {
        object.entry = [];
        for (let j = 0; j < message.entry.length; ++j)
          object.entry[j] = $root.base.MapEntry.toObject(
            message.entry[j],
            options
          );
      }
      if (message.audio != null && message.hasOwnProperty('audio')) {
        object.audio = $root.si.AudioPacket.toObject(message.audio, options);
        if (options.oneofs) object.inputs = 'audio';
      }
      return object;
    };

    /**
     * Converts this SpeechInputsMessage to JSON.
     * @function toJSON
     * @memberof si.SpeechInputsMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SpeechInputsMessage.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * SpeechEventType enum.
     * @name si.SpeechInputsMessage.SpeechEventType
     * @enum {number}
     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
     * @property {number} CONFIGURATION=1 CONFIGURATION value
     * @property {number} AUDIO=2 AUDIO value
     * @property {number} PING=3 PING value
     */
    SpeechInputsMessage.SpeechEventType = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'UNSPECIFIED')] = 0;
      values[(valuesById[1] = 'CONFIGURATION')] = 1;
      values[(valuesById[2] = 'AUDIO')] = 2;
      values[(valuesById[3] = 'PING')] = 3;
      return values;
    })();

    return SpeechInputsMessage;
  })();

  si.SpeechOutputsMessage = (function () {
    /**
     * Properties of a SpeechOutputsMessage.
     * @memberof si
     * @interface ISpeechOutputsMessage
     * @property {base.IBaseResp|null} [baseResp] SpeechOutputsMessage baseResp
     * @property {string|null} [taskId] SpeechOutputsMessage taskId
     * @property {Array.<base.IMapEntry>|null} [entry] SpeechOutputsMessage entry
     */

    /**
     * Constructs a new SpeechOutputsMessage.
     * @memberof si
     * @classdesc Represents a SpeechOutputsMessage.
     * @implements ISpeechOutputsMessage
     * @constructor
     * @param {si.ISpeechOutputsMessage=} [properties] Properties to set
     */
    function SpeechOutputsMessage(properties) {
      this.entry = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SpeechOutputsMessage baseResp.
     * @member {base.IBaseResp|null|undefined} baseResp
     * @memberof si.SpeechOutputsMessage
     * @instance
     */
    SpeechOutputsMessage.prototype.baseResp = null;

    /**
     * SpeechOutputsMessage taskId.
     * @member {string} taskId
     * @memberof si.SpeechOutputsMessage
     * @instance
     */
    SpeechOutputsMessage.prototype.taskId = '';

    /**
     * SpeechOutputsMessage entry.
     * @member {Array.<base.IMapEntry>} entry
     * @memberof si.SpeechOutputsMessage
     * @instance
     */
    SpeechOutputsMessage.prototype.entry = $util.emptyArray;

    /**
     * Creates a new SpeechOutputsMessage instance using the specified properties.
     * @function create
     * @memberof si.SpeechOutputsMessage
     * @static
     * @param {si.ISpeechOutputsMessage=} [properties] Properties to set
     * @returns {si.SpeechOutputsMessage} SpeechOutputsMessage instance
     */
    SpeechOutputsMessage.create = function create(properties) {
      return new SpeechOutputsMessage(properties);
    };

    /**
     * Encodes the specified SpeechOutputsMessage message. Does not implicitly {@link si.SpeechOutputsMessage.verify|verify} messages.
     * @function encode
     * @memberof si.SpeechOutputsMessage
     * @static
     * @param {si.ISpeechOutputsMessage} message SpeechOutputsMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpeechOutputsMessage.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.baseResp != null &&
        Object.hasOwnProperty.call(message, 'baseResp')
      )
        $root.base.BaseResp.encode(
          message.baseResp,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.taskId != null &&
        Object.hasOwnProperty.call(message, 'taskId')
      )
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.taskId);
      if (message.entry != null && message.entry.length)
        for (let i = 0; i < message.entry.length; ++i)
          $root.base.MapEntry.encode(
            message.entry[i],
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified SpeechOutputsMessage message, length delimited. Does not implicitly {@link si.SpeechOutputsMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.SpeechOutputsMessage
     * @static
     * @param {si.ISpeechOutputsMessage} message SpeechOutputsMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpeechOutputsMessage.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SpeechOutputsMessage message from the specified reader or buffer.
     * @function decode
     * @memberof si.SpeechOutputsMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.SpeechOutputsMessage} SpeechOutputsMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpeechOutputsMessage.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.SpeechOutputsMessage();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.baseResp = $root.base.BaseResp.decode(
              reader,
              reader.uint32()
            );
            break;
          case 2:
            message.taskId = reader.string();
            break;
          case 3:
            if (!(message.entry && message.entry.length)) message.entry = [];
            message.entry.push(
              $root.base.MapEntry.decode(reader, reader.uint32())
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SpeechOutputsMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.SpeechOutputsMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.SpeechOutputsMessage} SpeechOutputsMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpeechOutputsMessage.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SpeechOutputsMessage message.
     * @function verify
     * @memberof si.SpeechOutputsMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SpeechOutputsMessage.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.baseResp != null && message.hasOwnProperty('baseResp')) {
        let error = $root.base.BaseResp.verify(message.baseResp);
        if (error) return 'baseResp.' + error;
      }
      if (message.taskId != null && message.hasOwnProperty('taskId'))
        if (!$util.isString(message.taskId)) return 'taskId: string expected';
      if (message.entry != null && message.hasOwnProperty('entry')) {
        if (!Array.isArray(message.entry)) return 'entry: array expected';
        for (let i = 0; i < message.entry.length; ++i) {
          let error = $root.base.MapEntry.verify(message.entry[i]);
          if (error) return 'entry.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a SpeechOutputsMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.SpeechOutputsMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.SpeechOutputsMessage} SpeechOutputsMessage
     */
    SpeechOutputsMessage.fromObject = function fromObject(object) {
      if (object instanceof $root.si.SpeechOutputsMessage) return object;
      let message = new $root.si.SpeechOutputsMessage();
      if (object.baseResp != null) {
        if (typeof object.baseResp !== 'object')
          throw TypeError('.si.SpeechOutputsMessage.baseResp: object expected');
        message.baseResp = $root.base.BaseResp.fromObject(object.baseResp);
      }
      if (object.taskId != null) message.taskId = String(object.taskId);
      if (object.entry) {
        if (!Array.isArray(object.entry))
          throw TypeError('.si.SpeechOutputsMessage.entry: array expected');
        message.entry = [];
        for (let i = 0; i < object.entry.length; ++i) {
          if (typeof object.entry[i] !== 'object')
            throw TypeError('.si.SpeechOutputsMessage.entry: object expected');
          message.entry[i] = $root.base.MapEntry.fromObject(object.entry[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a SpeechOutputsMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.SpeechOutputsMessage
     * @static
     * @param {si.SpeechOutputsMessage} message SpeechOutputsMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SpeechOutputsMessage.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.entry = [];
      if (options.defaults) {
        object.baseResp = null;
        object.taskId = '';
      }
      if (message.baseResp != null && message.hasOwnProperty('baseResp'))
        object.baseResp = $root.base.BaseResp.toObject(
          message.baseResp,
          options
        );
      if (message.taskId != null && message.hasOwnProperty('taskId'))
        object.taskId = message.taskId;
      if (message.entry && message.entry.length) {
        object.entry = [];
        for (let j = 0; j < message.entry.length; ++j)
          object.entry[j] = $root.base.MapEntry.toObject(
            message.entry[j],
            options
          );
      }
      return object;
    };

    /**
     * Converts this SpeechOutputsMessage to JSON.
     * @function toJSON
     * @memberof si.SpeechOutputsMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SpeechOutputsMessage.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SpeechOutputsMessage;
  })();

  si.AudioPacket = (function () {
    /**
     * Properties of an AudioPacket.
     * @memberof si
     * @interface IAudioPacket
     * @property {Long|null} [sequence] AudioPacket sequence
     * @property {Uint8Array|null} [binary] AudioPacket binary
     * @property {Long|null} [ptsMs] AudioPacket ptsMs
     * @property {Long|null} [durationMs] AudioPacket durationMs
     * @property {Long|null} [unixMs] AudioPacket unixMs
     */

    /**
     * Constructs a new AudioPacket.
     * @memberof si
     * @classdesc Represents an AudioPacket.
     * @implements IAudioPacket
     * @constructor
     * @param {si.IAudioPacket=} [properties] Properties to set
     */
    function AudioPacket(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * AudioPacket sequence.
     * @member {Long} sequence
     * @memberof si.AudioPacket
     * @instance
     */
    AudioPacket.prototype.sequence = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * AudioPacket binary.
     * @member {Uint8Array} binary
     * @memberof si.AudioPacket
     * @instance
     */
    AudioPacket.prototype.binary = $util.newBuffer([]);

    /**
     * AudioPacket ptsMs.
     * @member {Long} ptsMs
     * @memberof si.AudioPacket
     * @instance
     */
    AudioPacket.prototype.ptsMs = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * AudioPacket durationMs.
     * @member {Long} durationMs
     * @memberof si.AudioPacket
     * @instance
     */
    AudioPacket.prototype.durationMs = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * AudioPacket unixMs.
     * @member {Long} unixMs
     * @memberof si.AudioPacket
     * @instance
     */
    AudioPacket.prototype.unixMs = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * Creates a new AudioPacket instance using the specified properties.
     * @function create
     * @memberof si.AudioPacket
     * @static
     * @param {si.IAudioPacket=} [properties] Properties to set
     * @returns {si.AudioPacket} AudioPacket instance
     */
    AudioPacket.create = function create(properties) {
      return new AudioPacket(properties);
    };

    /**
     * Encodes the specified AudioPacket message. Does not implicitly {@link si.AudioPacket.verify|verify} messages.
     * @function encode
     * @memberof si.AudioPacket
     * @static
     * @param {si.IAudioPacket} message AudioPacket message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AudioPacket.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.sequence != null &&
        Object.hasOwnProperty.call(message, 'sequence')
      )
        writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.sequence);
      if (
        message.binary != null &&
        Object.hasOwnProperty.call(message, 'binary')
      )
        writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.binary);
      if (message.ptsMs != null && Object.hasOwnProperty.call(message, 'ptsMs'))
        writer.uint32(/* id 3, wireType 0 =*/ 24).int64(message.ptsMs);
      if (
        message.durationMs != null &&
        Object.hasOwnProperty.call(message, 'durationMs')
      )
        writer.uint32(/* id 4, wireType 0 =*/ 32).int64(message.durationMs);
      if (
        message.unixMs != null &&
        Object.hasOwnProperty.call(message, 'unixMs')
      )
        writer.uint32(/* id 5, wireType 0 =*/ 40).int64(message.unixMs);
      return writer;
    };

    /**
     * Encodes the specified AudioPacket message, length delimited. Does not implicitly {@link si.AudioPacket.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.AudioPacket
     * @static
     * @param {si.IAudioPacket} message AudioPacket message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AudioPacket.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AudioPacket message from the specified reader or buffer.
     * @function decode
     * @memberof si.AudioPacket
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.AudioPacket} AudioPacket
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AudioPacket.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.AudioPacket();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.sequence = reader.int64();
            break;
          case 2:
            message.binary = reader.bytes();
            break;
          case 3:
            message.ptsMs = reader.int64();
            break;
          case 4:
            message.durationMs = reader.int64();
            break;
          case 5:
            message.unixMs = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an AudioPacket message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.AudioPacket
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.AudioPacket} AudioPacket
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AudioPacket.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AudioPacket message.
     * @function verify
     * @memberof si.AudioPacket
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AudioPacket.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.sequence != null && message.hasOwnProperty('sequence'))
        if (
          !$util.isInteger(message.sequence) &&
          !(
            message.sequence &&
            $util.isInteger(message.sequence.low) &&
            $util.isInteger(message.sequence.high)
          )
        )
          return 'sequence: integer|Long expected';
      if (message.binary != null && message.hasOwnProperty('binary'))
        if (
          !(
            (message.binary && typeof message.binary.length === 'number') ||
            $util.isString(message.binary)
          )
        )
          return 'binary: buffer expected';
      if (message.ptsMs != null && message.hasOwnProperty('ptsMs'))
        if (
          !$util.isInteger(message.ptsMs) &&
          !(
            message.ptsMs &&
            $util.isInteger(message.ptsMs.low) &&
            $util.isInteger(message.ptsMs.high)
          )
        )
          return 'ptsMs: integer|Long expected';
      if (message.durationMs != null && message.hasOwnProperty('durationMs'))
        if (
          !$util.isInteger(message.durationMs) &&
          !(
            message.durationMs &&
            $util.isInteger(message.durationMs.low) &&
            $util.isInteger(message.durationMs.high)
          )
        )
          return 'durationMs: integer|Long expected';
      if (message.unixMs != null && message.hasOwnProperty('unixMs'))
        if (
          !$util.isInteger(message.unixMs) &&
          !(
            message.unixMs &&
            $util.isInteger(message.unixMs.low) &&
            $util.isInteger(message.unixMs.high)
          )
        )
          return 'unixMs: integer|Long expected';
      return null;
    };

    /**
     * Creates an AudioPacket message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.AudioPacket
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.AudioPacket} AudioPacket
     */
    AudioPacket.fromObject = function fromObject(object) {
      if (object instanceof $root.si.AudioPacket) return object;
      let message = new $root.si.AudioPacket();
      if (object.sequence != null)
        if ($util.Long)
          (message.sequence = $util.Long.fromValue(
            object.sequence
          )).unsigned = false;
        else if (typeof object.sequence === 'string')
          message.sequence = parseInt(object.sequence, 10);
        else if (typeof object.sequence === 'number')
          message.sequence = object.sequence;
        else if (typeof object.sequence === 'object')
          message.sequence = new $util.LongBits(
            object.sequence.low >>> 0,
            object.sequence.high >>> 0
          ).toNumber();
      if (object.binary != null)
        if (typeof object.binary === 'string')
          $util.base64.decode(
            object.binary,
            (message.binary = $util.newBuffer(
              $util.base64.length(object.binary)
            )),
            0
          );
        else if (object.binary.length) message.binary = object.binary;
      if (object.ptsMs != null)
        if ($util.Long)
          (message.ptsMs = $util.Long.fromValue(object.ptsMs)).unsigned = false;
        else if (typeof object.ptsMs === 'string')
          message.ptsMs = parseInt(object.ptsMs, 10);
        else if (typeof object.ptsMs === 'number') message.ptsMs = object.ptsMs;
        else if (typeof object.ptsMs === 'object')
          message.ptsMs = new $util.LongBits(
            object.ptsMs.low >>> 0,
            object.ptsMs.high >>> 0
          ).toNumber();
      if (object.durationMs != null)
        if ($util.Long)
          (message.durationMs = $util.Long.fromValue(
            object.durationMs
          )).unsigned = false;
        else if (typeof object.durationMs === 'string')
          message.durationMs = parseInt(object.durationMs, 10);
        else if (typeof object.durationMs === 'number')
          message.durationMs = object.durationMs;
        else if (typeof object.durationMs === 'object')
          message.durationMs = new $util.LongBits(
            object.durationMs.low >>> 0,
            object.durationMs.high >>> 0
          ).toNumber();
      if (object.unixMs != null)
        if ($util.Long)
          (message.unixMs = $util.Long.fromValue(
            object.unixMs
          )).unsigned = false;
        else if (typeof object.unixMs === 'string')
          message.unixMs = parseInt(object.unixMs, 10);
        else if (typeof object.unixMs === 'number')
          message.unixMs = object.unixMs;
        else if (typeof object.unixMs === 'object')
          message.unixMs = new $util.LongBits(
            object.unixMs.low >>> 0,
            object.unixMs.high >>> 0
          ).toNumber();
      return message;
    };

    /**
     * Creates a plain object from an AudioPacket message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.AudioPacket
     * @static
     * @param {si.AudioPacket} message AudioPacket
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AudioPacket.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.sequence =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.sequence = options.longs === String ? '0' : 0;
        if (options.bytes === String) object.binary = '';
        else {
          object.binary = [];
          if (options.bytes !== Array)
            object.binary = $util.newBuffer(object.binary);
        }
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.ptsMs =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.ptsMs = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.durationMs =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.durationMs = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.unixMs =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.unixMs = options.longs === String ? '0' : 0;
      }
      if (message.sequence != null && message.hasOwnProperty('sequence'))
        if (typeof message.sequence === 'number')
          object.sequence =
            options.longs === String
              ? String(message.sequence)
              : message.sequence;
        else
          object.sequence =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.sequence)
              : options.longs === Number
              ? new $util.LongBits(
                  message.sequence.low >>> 0,
                  message.sequence.high >>> 0
                ).toNumber()
              : message.sequence;
      if (message.binary != null && message.hasOwnProperty('binary'))
        object.binary =
          options.bytes === String
            ? $util.base64.encode(message.binary, 0, message.binary.length)
            : options.bytes === Array
            ? Array.prototype.slice.call(message.binary)
            : message.binary;
      if (message.ptsMs != null && message.hasOwnProperty('ptsMs'))
        if (typeof message.ptsMs === 'number')
          object.ptsMs =
            options.longs === String ? String(message.ptsMs) : message.ptsMs;
        else
          object.ptsMs =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.ptsMs)
              : options.longs === Number
              ? new $util.LongBits(
                  message.ptsMs.low >>> 0,
                  message.ptsMs.high >>> 0
                ).toNumber()
              : message.ptsMs;
      if (message.durationMs != null && message.hasOwnProperty('durationMs'))
        if (typeof message.durationMs === 'number')
          object.durationMs =
            options.longs === String
              ? String(message.durationMs)
              : message.durationMs;
        else
          object.durationMs =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.durationMs)
              : options.longs === Number
              ? new $util.LongBits(
                  message.durationMs.low >>> 0,
                  message.durationMs.high >>> 0
                ).toNumber()
              : message.durationMs;
      if (message.unixMs != null && message.hasOwnProperty('unixMs'))
        if (typeof message.unixMs === 'number')
          object.unixMs =
            options.longs === String ? String(message.unixMs) : message.unixMs;
        else
          object.unixMs =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.unixMs)
              : options.longs === Number
              ? new $util.LongBits(
                  message.unixMs.low >>> 0,
                  message.unixMs.high >>> 0
                ).toNumber()
              : message.unixMs;
      return object;
    };

    /**
     * Converts this AudioPacket to JSON.
     * @function toJSON
     * @memberof si.AudioPacket
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AudioPacket.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AudioPacket;
  })();

  si.SimultaneousInterpretationConfiguration = (function () {
    /**
     * Properties of a SimultaneousInterpretationConfiguration.
     * @memberof si
     * @interface ISimultaneousInterpretationConfiguration
     * @property {si.ISpeechRecognitionConfiguration|null} [recognition] SimultaneousInterpretationConfiguration recognition
     * @property {si.ITranslationConfiguration|null} [translation] SimultaneousInterpretationConfiguration translation
     */

    /**
     * Constructs a new SimultaneousInterpretationConfiguration.
     * @memberof si
     * @classdesc Represents a SimultaneousInterpretationConfiguration.
     * @implements ISimultaneousInterpretationConfiguration
     * @constructor
     * @param {si.ISimultaneousInterpretationConfiguration=} [properties] Properties to set
     */
    function SimultaneousInterpretationConfiguration(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SimultaneousInterpretationConfiguration recognition.
     * @member {si.ISpeechRecognitionConfiguration|null|undefined} recognition
     * @memberof si.SimultaneousInterpretationConfiguration
     * @instance
     */
    SimultaneousInterpretationConfiguration.prototype.recognition = null;

    /**
     * SimultaneousInterpretationConfiguration translation.
     * @member {si.ITranslationConfiguration|null|undefined} translation
     * @memberof si.SimultaneousInterpretationConfiguration
     * @instance
     */
    SimultaneousInterpretationConfiguration.prototype.translation = null;

    /**
     * Creates a new SimultaneousInterpretationConfiguration instance using the specified properties.
     * @function create
     * @memberof si.SimultaneousInterpretationConfiguration
     * @static
     * @param {si.ISimultaneousInterpretationConfiguration=} [properties] Properties to set
     * @returns {si.SimultaneousInterpretationConfiguration} SimultaneousInterpretationConfiguration instance
     */
    SimultaneousInterpretationConfiguration.create = function create(
      properties
    ) {
      return new SimultaneousInterpretationConfiguration(properties);
    };

    /**
     * Encodes the specified SimultaneousInterpretationConfiguration message. Does not implicitly {@link si.SimultaneousInterpretationConfiguration.verify|verify} messages.
     * @function encode
     * @memberof si.SimultaneousInterpretationConfiguration
     * @static
     * @param {si.ISimultaneousInterpretationConfiguration} message SimultaneousInterpretationConfiguration message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SimultaneousInterpretationConfiguration.encode = function encode(
      message,
      writer
    ) {
      if (!writer) writer = $Writer.create();
      if (
        message.recognition != null &&
        Object.hasOwnProperty.call(message, 'recognition')
      )
        $root.si.SpeechRecognitionConfiguration.encode(
          message.recognition,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.translation != null &&
        Object.hasOwnProperty.call(message, 'translation')
      )
        $root.si.TranslationConfiguration.encode(
          message.translation,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified SimultaneousInterpretationConfiguration message, length delimited. Does not implicitly {@link si.SimultaneousInterpretationConfiguration.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.SimultaneousInterpretationConfiguration
     * @static
     * @param {si.ISimultaneousInterpretationConfiguration} message SimultaneousInterpretationConfiguration message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SimultaneousInterpretationConfiguration.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SimultaneousInterpretationConfiguration message from the specified reader or buffer.
     * @function decode
     * @memberof si.SimultaneousInterpretationConfiguration
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.SimultaneousInterpretationConfiguration} SimultaneousInterpretationConfiguration
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SimultaneousInterpretationConfiguration.decode = function decode(
      reader,
      length
    ) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.SimultaneousInterpretationConfiguration();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.recognition = $root.si.SpeechRecognitionConfiguration.decode(
              reader,
              reader.uint32()
            );
            break;
          case 2:
            message.translation = $root.si.TranslationConfiguration.decode(
              reader,
              reader.uint32()
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SimultaneousInterpretationConfiguration message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.SimultaneousInterpretationConfiguration
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.SimultaneousInterpretationConfiguration} SimultaneousInterpretationConfiguration
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SimultaneousInterpretationConfiguration.decodeDelimited = function decodeDelimited(
      reader
    ) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SimultaneousInterpretationConfiguration message.
     * @function verify
     * @memberof si.SimultaneousInterpretationConfiguration
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SimultaneousInterpretationConfiguration.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (
        message.recognition != null &&
        message.hasOwnProperty('recognition')
      ) {
        let error = $root.si.SpeechRecognitionConfiguration.verify(
          message.recognition
        );
        if (error) return 'recognition.' + error;
      }
      if (
        message.translation != null &&
        message.hasOwnProperty('translation')
      ) {
        let error = $root.si.TranslationConfiguration.verify(
          message.translation
        );
        if (error) return 'translation.' + error;
      }
      return null;
    };

    /**
     * Creates a SimultaneousInterpretationConfiguration message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.SimultaneousInterpretationConfiguration
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.SimultaneousInterpretationConfiguration} SimultaneousInterpretationConfiguration
     */
    SimultaneousInterpretationConfiguration.fromObject = function fromObject(
      object
    ) {
      if (object instanceof $root.si.SimultaneousInterpretationConfiguration)
        return object;
      let message = new $root.si.SimultaneousInterpretationConfiguration();
      if (object.recognition != null) {
        if (typeof object.recognition !== 'object')
          throw TypeError(
            '.si.SimultaneousInterpretationConfiguration.recognition: object expected'
          );
        message.recognition = $root.si.SpeechRecognitionConfiguration.fromObject(
          object.recognition
        );
      }
      if (object.translation != null) {
        if (typeof object.translation !== 'object')
          throw TypeError(
            '.si.SimultaneousInterpretationConfiguration.translation: object expected'
          );
        message.translation = $root.si.TranslationConfiguration.fromObject(
          object.translation
        );
      }
      return message;
    };

    /**
     * Creates a plain object from a SimultaneousInterpretationConfiguration message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.SimultaneousInterpretationConfiguration
     * @static
     * @param {si.SimultaneousInterpretationConfiguration} message SimultaneousInterpretationConfiguration
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SimultaneousInterpretationConfiguration.toObject = function toObject(
      message,
      options
    ) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.recognition = null;
        object.translation = null;
      }
      if (message.recognition != null && message.hasOwnProperty('recognition'))
        object.recognition = $root.si.SpeechRecognitionConfiguration.toObject(
          message.recognition,
          options
        );
      if (message.translation != null && message.hasOwnProperty('translation'))
        object.translation = $root.si.TranslationConfiguration.toObject(
          message.translation,
          options
        );
      return object;
    };

    /**
     * Converts this SimultaneousInterpretationConfiguration to JSON.
     * @function toJSON
     * @memberof si.SimultaneousInterpretationConfiguration
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SimultaneousInterpretationConfiguration.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SimultaneousInterpretationConfiguration;
  })();

  si.SpeechRecognitionConfiguration = (function () {
    /**
     * Properties of a SpeechRecognitionConfiguration.
     * @memberof si
     * @interface ISpeechRecognitionConfiguration
     * @property {string|null} [languageCode] SpeechRecognitionConfiguration languageCode
     * @property {string|null} [speechProvider] SpeechRecognitionConfiguration speechProvider
     * @property {Array.<string>|null} [speechContexts] SpeechRecognitionConfiguration speechContexts
     * @property {boolean|null} [timestampAlignment] SpeechRecognitionConfiguration timestampAlignment
     */

    /**
     * Constructs a new SpeechRecognitionConfiguration.
     * @memberof si
     * @classdesc Represents a SpeechRecognitionConfiguration.
     * @implements ISpeechRecognitionConfiguration
     * @constructor
     * @param {si.ISpeechRecognitionConfiguration=} [properties] Properties to set
     */
    function SpeechRecognitionConfiguration(properties) {
      this.speechContexts = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SpeechRecognitionConfiguration languageCode.
     * @member {string} languageCode
     * @memberof si.SpeechRecognitionConfiguration
     * @instance
     */
    SpeechRecognitionConfiguration.prototype.languageCode = '';

    /**
     * SpeechRecognitionConfiguration speechProvider.
     * @member {string} speechProvider
     * @memberof si.SpeechRecognitionConfiguration
     * @instance
     */
    SpeechRecognitionConfiguration.prototype.speechProvider = '';

    /**
     * SpeechRecognitionConfiguration speechContexts.
     * @member {Array.<string>} speechContexts
     * @memberof si.SpeechRecognitionConfiguration
     * @instance
     */
    SpeechRecognitionConfiguration.prototype.speechContexts = $util.emptyArray;

    /**
     * SpeechRecognitionConfiguration timestampAlignment.
     * @member {boolean} timestampAlignment
     * @memberof si.SpeechRecognitionConfiguration
     * @instance
     */
    SpeechRecognitionConfiguration.prototype.timestampAlignment = false;

    /**
     * Creates a new SpeechRecognitionConfiguration instance using the specified properties.
     * @function create
     * @memberof si.SpeechRecognitionConfiguration
     * @static
     * @param {si.ISpeechRecognitionConfiguration=} [properties] Properties to set
     * @returns {si.SpeechRecognitionConfiguration} SpeechRecognitionConfiguration instance
     */
    SpeechRecognitionConfiguration.create = function create(properties) {
      return new SpeechRecognitionConfiguration(properties);
    };

    /**
     * Encodes the specified SpeechRecognitionConfiguration message. Does not implicitly {@link si.SpeechRecognitionConfiguration.verify|verify} messages.
     * @function encode
     * @memberof si.SpeechRecognitionConfiguration
     * @static
     * @param {si.ISpeechRecognitionConfiguration} message SpeechRecognitionConfiguration message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpeechRecognitionConfiguration.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.languageCode != null &&
        Object.hasOwnProperty.call(message, 'languageCode')
      )
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.languageCode);
      if (
        message.speechProvider != null &&
        Object.hasOwnProperty.call(message, 'speechProvider')
      )
        writer
          .uint32(/* id 2, wireType 2 =*/ 18)
          .string(message.speechProvider);
      if (message.speechContexts != null && message.speechContexts.length)
        for (let i = 0; i < message.speechContexts.length; ++i)
          writer
            .uint32(/* id 20, wireType 2 =*/ 162)
            .string(message.speechContexts[i]);
      if (
        message.timestampAlignment != null &&
        Object.hasOwnProperty.call(message, 'timestampAlignment')
      )
        writer
          .uint32(/* id 100, wireType 0 =*/ 800)
          .bool(message.timestampAlignment);
      return writer;
    };

    /**
     * Encodes the specified SpeechRecognitionConfiguration message, length delimited. Does not implicitly {@link si.SpeechRecognitionConfiguration.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.SpeechRecognitionConfiguration
     * @static
     * @param {si.ISpeechRecognitionConfiguration} message SpeechRecognitionConfiguration message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpeechRecognitionConfiguration.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SpeechRecognitionConfiguration message from the specified reader or buffer.
     * @function decode
     * @memberof si.SpeechRecognitionConfiguration
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.SpeechRecognitionConfiguration} SpeechRecognitionConfiguration
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpeechRecognitionConfiguration.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.SpeechRecognitionConfiguration();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.languageCode = reader.string();
            break;
          case 2:
            message.speechProvider = reader.string();
            break;
          case 20:
            if (!(message.speechContexts && message.speechContexts.length))
              message.speechContexts = [];
            message.speechContexts.push(reader.string());
            break;
          case 100:
            message.timestampAlignment = reader.bool();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SpeechRecognitionConfiguration message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.SpeechRecognitionConfiguration
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.SpeechRecognitionConfiguration} SpeechRecognitionConfiguration
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpeechRecognitionConfiguration.decodeDelimited = function decodeDelimited(
      reader
    ) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SpeechRecognitionConfiguration message.
     * @function verify
     * @memberof si.SpeechRecognitionConfiguration
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SpeechRecognitionConfiguration.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (
        message.languageCode != null &&
        message.hasOwnProperty('languageCode')
      )
        if (!$util.isString(message.languageCode))
          return 'languageCode: string expected';
      if (
        message.speechProvider != null &&
        message.hasOwnProperty('speechProvider')
      )
        if (!$util.isString(message.speechProvider))
          return 'speechProvider: string expected';
      if (
        message.speechContexts != null &&
        message.hasOwnProperty('speechContexts')
      ) {
        if (!Array.isArray(message.speechContexts))
          return 'speechContexts: array expected';
        for (let i = 0; i < message.speechContexts.length; ++i)
          if (!$util.isString(message.speechContexts[i]))
            return 'speechContexts: string[] expected';
      }
      if (
        message.timestampAlignment != null &&
        message.hasOwnProperty('timestampAlignment')
      )
        if (typeof message.timestampAlignment !== 'boolean')
          return 'timestampAlignment: boolean expected';
      return null;
    };

    /**
     * Creates a SpeechRecognitionConfiguration message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.SpeechRecognitionConfiguration
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.SpeechRecognitionConfiguration} SpeechRecognitionConfiguration
     */
    SpeechRecognitionConfiguration.fromObject = function fromObject(object) {
      if (object instanceof $root.si.SpeechRecognitionConfiguration)
        return object;
      let message = new $root.si.SpeechRecognitionConfiguration();
      if (object.languageCode != null)
        message.languageCode = String(object.languageCode);
      if (object.speechProvider != null)
        message.speechProvider = String(object.speechProvider);
      if (object.speechContexts) {
        if (!Array.isArray(object.speechContexts))
          throw TypeError(
            '.si.SpeechRecognitionConfiguration.speechContexts: array expected'
          );
        message.speechContexts = [];
        for (let i = 0; i < object.speechContexts.length; ++i)
          message.speechContexts[i] = String(object.speechContexts[i]);
      }
      if (object.timestampAlignment != null)
        message.timestampAlignment = Boolean(object.timestampAlignment);
      return message;
    };

    /**
     * Creates a plain object from a SpeechRecognitionConfiguration message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.SpeechRecognitionConfiguration
     * @static
     * @param {si.SpeechRecognitionConfiguration} message SpeechRecognitionConfiguration
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SpeechRecognitionConfiguration.toObject = function toObject(
      message,
      options
    ) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.speechContexts = [];
      if (options.defaults) {
        object.languageCode = '';
        object.speechProvider = '';
        object.timestampAlignment = false;
      }
      if (
        message.languageCode != null &&
        message.hasOwnProperty('languageCode')
      )
        object.languageCode = message.languageCode;
      if (
        message.speechProvider != null &&
        message.hasOwnProperty('speechProvider')
      )
        object.speechProvider = message.speechProvider;
      if (message.speechContexts && message.speechContexts.length) {
        object.speechContexts = [];
        for (let j = 0; j < message.speechContexts.length; ++j)
          object.speechContexts[j] = message.speechContexts[j];
      }
      if (
        message.timestampAlignment != null &&
        message.hasOwnProperty('timestampAlignment')
      )
        object.timestampAlignment = message.timestampAlignment;
      return object;
    };

    /**
     * Converts this SpeechRecognitionConfiguration to JSON.
     * @function toJSON
     * @memberof si.SpeechRecognitionConfiguration
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SpeechRecognitionConfiguration.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SpeechRecognitionConfiguration;
  })();

  si.TranslationConfiguration = (function () {
    /**
     * Properties of a TranslationConfiguration.
     * @memberof si
     * @interface ITranslationConfiguration
     * @property {Array.<string>|null} [languageCodes] TranslationConfiguration languageCodes
     */

    /**
     * Constructs a new TranslationConfiguration.
     * @memberof si
     * @classdesc Represents a TranslationConfiguration.
     * @implements ITranslationConfiguration
     * @constructor
     * @param {si.ITranslationConfiguration=} [properties] Properties to set
     */
    function TranslationConfiguration(properties) {
      this.languageCodes = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * TranslationConfiguration languageCodes.
     * @member {Array.<string>} languageCodes
     * @memberof si.TranslationConfiguration
     * @instance
     */
    TranslationConfiguration.prototype.languageCodes = $util.emptyArray;

    /**
     * Creates a new TranslationConfiguration instance using the specified properties.
     * @function create
     * @memberof si.TranslationConfiguration
     * @static
     * @param {si.ITranslationConfiguration=} [properties] Properties to set
     * @returns {si.TranslationConfiguration} TranslationConfiguration instance
     */
    TranslationConfiguration.create = function create(properties) {
      return new TranslationConfiguration(properties);
    };

    /**
     * Encodes the specified TranslationConfiguration message. Does not implicitly {@link si.TranslationConfiguration.verify|verify} messages.
     * @function encode
     * @memberof si.TranslationConfiguration
     * @static
     * @param {si.ITranslationConfiguration} message TranslationConfiguration message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TranslationConfiguration.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.languageCodes != null && message.languageCodes.length)
        for (let i = 0; i < message.languageCodes.length; ++i)
          writer
            .uint32(/* id 1, wireType 2 =*/ 10)
            .string(message.languageCodes[i]);
      return writer;
    };

    /**
     * Encodes the specified TranslationConfiguration message, length delimited. Does not implicitly {@link si.TranslationConfiguration.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.TranslationConfiguration
     * @static
     * @param {si.ITranslationConfiguration} message TranslationConfiguration message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TranslationConfiguration.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TranslationConfiguration message from the specified reader or buffer.
     * @function decode
     * @memberof si.TranslationConfiguration
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.TranslationConfiguration} TranslationConfiguration
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TranslationConfiguration.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.TranslationConfiguration();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            if (!(message.languageCodes && message.languageCodes.length))
              message.languageCodes = [];
            message.languageCodes.push(reader.string());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a TranslationConfiguration message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.TranslationConfiguration
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.TranslationConfiguration} TranslationConfiguration
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TranslationConfiguration.decodeDelimited = function decodeDelimited(
      reader
    ) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TranslationConfiguration message.
     * @function verify
     * @memberof si.TranslationConfiguration
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TranslationConfiguration.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (
        message.languageCodes != null &&
        message.hasOwnProperty('languageCodes')
      ) {
        if (!Array.isArray(message.languageCodes))
          return 'languageCodes: array expected';
        for (let i = 0; i < message.languageCodes.length; ++i)
          if (!$util.isString(message.languageCodes[i]))
            return 'languageCodes: string[] expected';
      }
      return null;
    };

    /**
     * Creates a TranslationConfiguration message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.TranslationConfiguration
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.TranslationConfiguration} TranslationConfiguration
     */
    TranslationConfiguration.fromObject = function fromObject(object) {
      if (object instanceof $root.si.TranslationConfiguration) return object;
      let message = new $root.si.TranslationConfiguration();
      if (object.languageCodes) {
        if (!Array.isArray(object.languageCodes))
          throw TypeError(
            '.si.TranslationConfiguration.languageCodes: array expected'
          );
        message.languageCodes = [];
        for (let i = 0; i < object.languageCodes.length; ++i)
          message.languageCodes[i] = String(object.languageCodes[i]);
      }
      return message;
    };

    /**
     * Creates a plain object from a TranslationConfiguration message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.TranslationConfiguration
     * @static
     * @param {si.TranslationConfiguration} message TranslationConfiguration
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TranslationConfiguration.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.languageCodes = [];
      if (message.languageCodes && message.languageCodes.length) {
        object.languageCodes = [];
        for (let j = 0; j < message.languageCodes.length; ++j)
          object.languageCodes[j] = message.languageCodes[j];
      }
      return object;
    };

    /**
     * Converts this TranslationConfiguration to JSON.
     * @function toJSON
     * @memberof si.TranslationConfiguration
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TranslationConfiguration.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TranslationConfiguration;
  })();

  si.SimultaneousInterpretationResponse = (function () {
    /**
     * Properties of a SimultaneousInterpretationResponse.
     * @memberof si
     * @interface ISimultaneousInterpretationResponse
     * @property {base.IBaseResp|null} [baseResp] SimultaneousInterpretationResponse baseResp
     * @property {string|null} [taskId] SimultaneousInterpretationResponse taskId
     * @property {si.ISubtitleIRL|null} [subtitle] SimultaneousInterpretationResponse subtitle
     * @property {boolean|null} [endFlag] SimultaneousInterpretationResponse endFlag
     * @property {Long|null} [createTime] SimultaneousInterpretationResponse createTime
     */

    /**
     * Constructs a new SimultaneousInterpretationResponse.
     * @memberof si
     * @classdesc Represents a SimultaneousInterpretationResponse.
     * @implements ISimultaneousInterpretationResponse
     * @constructor
     * @param {si.ISimultaneousInterpretationResponse=} [properties] Properties to set
     */
    function SimultaneousInterpretationResponse(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SimultaneousInterpretationResponse baseResp.
     * @member {base.IBaseResp|null|undefined} baseResp
     * @memberof si.SimultaneousInterpretationResponse
     * @instance
     */
    SimultaneousInterpretationResponse.prototype.baseResp = null;

    /**
     * SimultaneousInterpretationResponse taskId.
     * @member {string} taskId
     * @memberof si.SimultaneousInterpretationResponse
     * @instance
     */
    SimultaneousInterpretationResponse.prototype.taskId = '';

    /**
     * SimultaneousInterpretationResponse subtitle.
     * @member {si.ISubtitleIRL|null|undefined} subtitle
     * @memberof si.SimultaneousInterpretationResponse
     * @instance
     */
    SimultaneousInterpretationResponse.prototype.subtitle = null;

    /**
     * SimultaneousInterpretationResponse endFlag.
     * @member {boolean} endFlag
     * @memberof si.SimultaneousInterpretationResponse
     * @instance
     */
    SimultaneousInterpretationResponse.prototype.endFlag = false;

    /**
     * SimultaneousInterpretationResponse createTime.
     * @member {Long} createTime
     * @memberof si.SimultaneousInterpretationResponse
     * @instance
     */
    SimultaneousInterpretationResponse.prototype.createTime = $util.Long
      ? $util.Long.fromBits(0, 0, true)
      : 0;

    /**
     * Creates a new SimultaneousInterpretationResponse instance using the specified properties.
     * @function create
     * @memberof si.SimultaneousInterpretationResponse
     * @static
     * @param {si.ISimultaneousInterpretationResponse=} [properties] Properties to set
     * @returns {si.SimultaneousInterpretationResponse} SimultaneousInterpretationResponse instance
     */
    SimultaneousInterpretationResponse.create = function create(properties) {
      return new SimultaneousInterpretationResponse(properties);
    };

    /**
     * Encodes the specified SimultaneousInterpretationResponse message. Does not implicitly {@link si.SimultaneousInterpretationResponse.verify|verify} messages.
     * @function encode
     * @memberof si.SimultaneousInterpretationResponse
     * @static
     * @param {si.ISimultaneousInterpretationResponse} message SimultaneousInterpretationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SimultaneousInterpretationResponse.encode = function encode(
      message,
      writer
    ) {
      if (!writer) writer = $Writer.create();
      if (
        message.baseResp != null &&
        Object.hasOwnProperty.call(message, 'baseResp')
      )
        $root.base.BaseResp.encode(
          message.baseResp,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.taskId != null &&
        Object.hasOwnProperty.call(message, 'taskId')
      )
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.taskId);
      if (
        message.subtitle != null &&
        Object.hasOwnProperty.call(message, 'subtitle')
      )
        $root.si.SubtitleIRL.encode(
          message.subtitle,
          writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
        ).ldelim();
      if (
        message.endFlag != null &&
        Object.hasOwnProperty.call(message, 'endFlag')
      )
        writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.endFlag);
      if (
        message.createTime != null &&
        Object.hasOwnProperty.call(message, 'createTime')
      )
        writer.uint32(/* id 6, wireType 0 =*/ 48).uint64(message.createTime);
      return writer;
    };

    /**
     * Encodes the specified SimultaneousInterpretationResponse message, length delimited. Does not implicitly {@link si.SimultaneousInterpretationResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.SimultaneousInterpretationResponse
     * @static
     * @param {si.ISimultaneousInterpretationResponse} message SimultaneousInterpretationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SimultaneousInterpretationResponse.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SimultaneousInterpretationResponse message from the specified reader or buffer.
     * @function decode
     * @memberof si.SimultaneousInterpretationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.SimultaneousInterpretationResponse} SimultaneousInterpretationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SimultaneousInterpretationResponse.decode = function decode(
      reader,
      length
    ) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.SimultaneousInterpretationResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.baseResp = $root.base.BaseResp.decode(
              reader,
              reader.uint32()
            );
            break;
          case 3:
            message.taskId = reader.string();
            break;
          case 4:
            message.subtitle = $root.si.SubtitleIRL.decode(
              reader,
              reader.uint32()
            );
            break;
          case 5:
            message.endFlag = reader.bool();
            break;
          case 6:
            message.createTime = reader.uint64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SimultaneousInterpretationResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.SimultaneousInterpretationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.SimultaneousInterpretationResponse} SimultaneousInterpretationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SimultaneousInterpretationResponse.decodeDelimited = function decodeDelimited(
      reader
    ) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SimultaneousInterpretationResponse message.
     * @function verify
     * @memberof si.SimultaneousInterpretationResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SimultaneousInterpretationResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.baseResp != null && message.hasOwnProperty('baseResp')) {
        let error = $root.base.BaseResp.verify(message.baseResp);
        if (error) return 'baseResp.' + error;
      }
      if (message.taskId != null && message.hasOwnProperty('taskId'))
        if (!$util.isString(message.taskId)) return 'taskId: string expected';
      if (message.subtitle != null && message.hasOwnProperty('subtitle')) {
        let error = $root.si.SubtitleIRL.verify(message.subtitle);
        if (error) return 'subtitle.' + error;
      }
      if (message.endFlag != null && message.hasOwnProperty('endFlag'))
        if (typeof message.endFlag !== 'boolean')
          return 'endFlag: boolean expected';
      if (message.createTime != null && message.hasOwnProperty('createTime'))
        if (
          !$util.isInteger(message.createTime) &&
          !(
            message.createTime &&
            $util.isInteger(message.createTime.low) &&
            $util.isInteger(message.createTime.high)
          )
        )
          return 'createTime: integer|Long expected';
      return null;
    };

    /**
     * Creates a SimultaneousInterpretationResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.SimultaneousInterpretationResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.SimultaneousInterpretationResponse} SimultaneousInterpretationResponse
     */
    SimultaneousInterpretationResponse.fromObject = function fromObject(
      object
    ) {
      if (object instanceof $root.si.SimultaneousInterpretationResponse)
        return object;
      let message = new $root.si.SimultaneousInterpretationResponse();
      if (object.baseResp != null) {
        if (typeof object.baseResp !== 'object')
          throw TypeError(
            '.si.SimultaneousInterpretationResponse.baseResp: object expected'
          );
        message.baseResp = $root.base.BaseResp.fromObject(object.baseResp);
      }
      if (object.taskId != null) message.taskId = String(object.taskId);
      if (object.subtitle != null) {
        if (typeof object.subtitle !== 'object')
          throw TypeError(
            '.si.SimultaneousInterpretationResponse.subtitle: object expected'
          );
        message.subtitle = $root.si.SubtitleIRL.fromObject(object.subtitle);
      }
      if (object.endFlag != null) message.endFlag = Boolean(object.endFlag);
      if (object.createTime != null)
        if ($util.Long)
          (message.createTime = $util.Long.fromValue(
            object.createTime
          )).unsigned = true;
        else if (typeof object.createTime === 'string')
          message.createTime = parseInt(object.createTime, 10);
        else if (typeof object.createTime === 'number')
          message.createTime = object.createTime;
        else if (typeof object.createTime === 'object')
          message.createTime = new $util.LongBits(
            object.createTime.low >>> 0,
            object.createTime.high >>> 0
          ).toNumber(true);
      return message;
    };

    /**
     * Creates a plain object from a SimultaneousInterpretationResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.SimultaneousInterpretationResponse
     * @static
     * @param {si.SimultaneousInterpretationResponse} message SimultaneousInterpretationResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SimultaneousInterpretationResponse.toObject = function toObject(
      message,
      options
    ) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.baseResp = null;
        object.taskId = '';
        object.subtitle = null;
        object.endFlag = false;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.createTime =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.createTime = options.longs === String ? '0' : 0;
      }
      if (message.baseResp != null && message.hasOwnProperty('baseResp'))
        object.baseResp = $root.base.BaseResp.toObject(
          message.baseResp,
          options
        );
      if (message.taskId != null && message.hasOwnProperty('taskId'))
        object.taskId = message.taskId;
      if (message.subtitle != null && message.hasOwnProperty('subtitle'))
        object.subtitle = $root.si.SubtitleIRL.toObject(
          message.subtitle,
          options
        );
      if (message.endFlag != null && message.hasOwnProperty('endFlag'))
        object.endFlag = message.endFlag;
      if (message.createTime != null && message.hasOwnProperty('createTime'))
        if (typeof message.createTime === 'number')
          object.createTime =
            options.longs === String
              ? String(message.createTime)
              : message.createTime;
        else
          object.createTime =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.createTime)
              : options.longs === Number
              ? new $util.LongBits(
                  message.createTime.low >>> 0,
                  message.createTime.high >>> 0
                ).toNumber(true)
              : message.createTime;
      return object;
    };

    /**
     * Converts this SimultaneousInterpretationResponse to JSON.
     * @function toJSON
     * @memberof si.SimultaneousInterpretationResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SimultaneousInterpretationResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SimultaneousInterpretationResponse;
  })();

  si.SimultaneousInterpretationScene = (function () {
    /**
     * Properties of a SimultaneousInterpretationScene.
     * @memberof si
     * @interface ISimultaneousInterpretationScene
     * @property {si.SimultaneousInterpretationScene.Environ|null} [env] SimultaneousInterpretationScene env
     * @property {si.SimultaneousInterpretationScene.Scene|null} [scene] SimultaneousInterpretationScene scene
     */

    /**
     * Constructs a new SimultaneousInterpretationScene.
     * @memberof si
     * @classdesc Represents a SimultaneousInterpretationScene.
     * @implements ISimultaneousInterpretationScene
     * @constructor
     * @param {si.ISimultaneousInterpretationScene=} [properties] Properties to set
     */
    function SimultaneousInterpretationScene(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SimultaneousInterpretationScene env.
     * @member {si.SimultaneousInterpretationScene.Environ} env
     * @memberof si.SimultaneousInterpretationScene
     * @instance
     */
    SimultaneousInterpretationScene.prototype.env = 0;

    /**
     * SimultaneousInterpretationScene scene.
     * @member {si.SimultaneousInterpretationScene.Scene} scene
     * @memberof si.SimultaneousInterpretationScene
     * @instance
     */
    SimultaneousInterpretationScene.prototype.scene = 0;

    /**
     * Creates a new SimultaneousInterpretationScene instance using the specified properties.
     * @function create
     * @memberof si.SimultaneousInterpretationScene
     * @static
     * @param {si.ISimultaneousInterpretationScene=} [properties] Properties to set
     * @returns {si.SimultaneousInterpretationScene} SimultaneousInterpretationScene instance
     */
    SimultaneousInterpretationScene.create = function create(properties) {
      return new SimultaneousInterpretationScene(properties);
    };

    /**
     * Encodes the specified SimultaneousInterpretationScene message. Does not implicitly {@link si.SimultaneousInterpretationScene.verify|verify} messages.
     * @function encode
     * @memberof si.SimultaneousInterpretationScene
     * @static
     * @param {si.ISimultaneousInterpretationScene} message SimultaneousInterpretationScene message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SimultaneousInterpretationScene.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.env != null && Object.hasOwnProperty.call(message, 'env'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.env);
      if (message.scene != null && Object.hasOwnProperty.call(message, 'scene'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.scene);
      return writer;
    };

    /**
     * Encodes the specified SimultaneousInterpretationScene message, length delimited. Does not implicitly {@link si.SimultaneousInterpretationScene.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.SimultaneousInterpretationScene
     * @static
     * @param {si.ISimultaneousInterpretationScene} message SimultaneousInterpretationScene message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SimultaneousInterpretationScene.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SimultaneousInterpretationScene message from the specified reader or buffer.
     * @function decode
     * @memberof si.SimultaneousInterpretationScene
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.SimultaneousInterpretationScene} SimultaneousInterpretationScene
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SimultaneousInterpretationScene.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.SimultaneousInterpretationScene();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.env = reader.int32();
            break;
          case 2:
            message.scene = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SimultaneousInterpretationScene message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.SimultaneousInterpretationScene
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.SimultaneousInterpretationScene} SimultaneousInterpretationScene
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SimultaneousInterpretationScene.decodeDelimited = function decodeDelimited(
      reader
    ) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SimultaneousInterpretationScene message.
     * @function verify
     * @memberof si.SimultaneousInterpretationScene
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SimultaneousInterpretationScene.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.env != null && message.hasOwnProperty('env'))
        switch (message.env) {
          default:
            return 'env: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.scene != null && message.hasOwnProperty('scene'))
        switch (message.scene) {
          default:
            return 'scene: enum value expected';
          case 0:
          case 1:
          case 2:
            break;
        }
      return null;
    };

    /**
     * Creates a SimultaneousInterpretationScene message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.SimultaneousInterpretationScene
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.SimultaneousInterpretationScene} SimultaneousInterpretationScene
     */
    SimultaneousInterpretationScene.fromObject = function fromObject(object) {
      if (object instanceof $root.si.SimultaneousInterpretationScene)
        return object;
      let message = new $root.si.SimultaneousInterpretationScene();
      switch (object.env) {
        case 'UNSPECIFIED':
        case 0:
          message.env = 0;
          break;
        case 'RELEASE':
        case 1:
          message.env = 1;
          break;
        case 'STAGING':
        case 2:
          message.env = 2;
          break;
        case 'DEVELOP':
        case 3:
          message.env = 3;
          break;
      }
      switch (object.scene) {
        case 'BYTE_SI':
        case 0:
          message.scene = 0;
          break;
        case 'BROADCAST':
        case 1:
          message.scene = 1;
          break;
        case 'EXTERNAL':
        case 2:
          message.scene = 2;
          break;
      }
      return message;
    };

    /**
     * Creates a plain object from a SimultaneousInterpretationScene message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.SimultaneousInterpretationScene
     * @static
     * @param {si.SimultaneousInterpretationScene} message SimultaneousInterpretationScene
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SimultaneousInterpretationScene.toObject = function toObject(
      message,
      options
    ) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.env = options.enums === String ? 'UNSPECIFIED' : 0;
        object.scene = options.enums === String ? 'BYTE_SI' : 0;
      }
      if (message.env != null && message.hasOwnProperty('env'))
        object.env =
          options.enums === String
            ? $root.si.SimultaneousInterpretationScene.Environ[message.env]
            : message.env;
      if (message.scene != null && message.hasOwnProperty('scene'))
        object.scene =
          options.enums === String
            ? $root.si.SimultaneousInterpretationScene.Scene[message.scene]
            : message.scene;
      return object;
    };

    /**
     * Converts this SimultaneousInterpretationScene to JSON.
     * @function toJSON
     * @memberof si.SimultaneousInterpretationScene
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SimultaneousInterpretationScene.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Environ enum.
     * @name si.SimultaneousInterpretationScene.Environ
     * @enum {number}
     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
     * @property {number} RELEASE=1 RELEASE value
     * @property {number} STAGING=2 STAGING value
     * @property {number} DEVELOP=3 DEVELOP value
     */
    SimultaneousInterpretationScene.Environ = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'UNSPECIFIED')] = 0;
      values[(valuesById[1] = 'RELEASE')] = 1;
      values[(valuesById[2] = 'STAGING')] = 2;
      values[(valuesById[3] = 'DEVELOP')] = 3;
      return values;
    })();

    /**
     * Scene enum.
     * @name si.SimultaneousInterpretationScene.Scene
     * @enum {number}
     * @property {number} BYTE_SI=0 BYTE_SI value
     * @property {number} BROADCAST=1 BROADCAST value
     * @property {number} EXTERNAL=2 EXTERNAL value
     */
    SimultaneousInterpretationScene.Scene = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'BYTE_SI')] = 0;
      values[(valuesById[1] = 'BROADCAST')] = 1;
      values[(valuesById[2] = 'EXTERNAL')] = 2;
      return values;
    })();

    return SimultaneousInterpretationScene;
  })();

  si.Subtitle = (function () {
    /**
     * Properties of a Subtitle.
     * @memberof si
     * @interface ISubtitle
     * @property {Long|null} [sequence] Subtitle sequence
     * @property {boolean|null} [isFinal] Subtitle isFinal
     * @property {string|null} [utterance] Subtitle utterance
     * @property {string|null} [languageCode] Subtitle languageCode
     * @property {Long|null} [beginTime] Subtitle beginTime
     * @property {Long|null} [endTime] Subtitle endTime
     */

    /**
     * Constructs a new Subtitle.
     * @memberof si
     * @classdesc Represents a Subtitle.
     * @implements ISubtitle
     * @constructor
     * @param {si.ISubtitle=} [properties] Properties to set
     */
    function Subtitle(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Subtitle sequence.
     * @member {Long} sequence
     * @memberof si.Subtitle
     * @instance
     */
    Subtitle.prototype.sequence = $util.Long
      ? $util.Long.fromBits(0, 0, true)
      : 0;

    /**
     * Subtitle isFinal.
     * @member {boolean} isFinal
     * @memberof si.Subtitle
     * @instance
     */
    Subtitle.prototype.isFinal = false;

    /**
     * Subtitle utterance.
     * @member {string} utterance
     * @memberof si.Subtitle
     * @instance
     */
    Subtitle.prototype.utterance = '';

    /**
     * Subtitle languageCode.
     * @member {string} languageCode
     * @memberof si.Subtitle
     * @instance
     */
    Subtitle.prototype.languageCode = '';

    /**
     * Subtitle beginTime.
     * @member {Long} beginTime
     * @memberof si.Subtitle
     * @instance
     */
    Subtitle.prototype.beginTime = $util.Long
      ? $util.Long.fromBits(0, 0, true)
      : 0;

    /**
     * Subtitle endTime.
     * @member {Long} endTime
     * @memberof si.Subtitle
     * @instance
     */
    Subtitle.prototype.endTime = $util.Long
      ? $util.Long.fromBits(0, 0, true)
      : 0;

    /**
     * Creates a new Subtitle instance using the specified properties.
     * @function create
     * @memberof si.Subtitle
     * @static
     * @param {si.ISubtitle=} [properties] Properties to set
     * @returns {si.Subtitle} Subtitle instance
     */
    Subtitle.create = function create(properties) {
      return new Subtitle(properties);
    };

    /**
     * Encodes the specified Subtitle message. Does not implicitly {@link si.Subtitle.verify|verify} messages.
     * @function encode
     * @memberof si.Subtitle
     * @static
     * @param {si.ISubtitle} message Subtitle message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Subtitle.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.sequence != null &&
        Object.hasOwnProperty.call(message, 'sequence')
      )
        writer.uint32(/* id 1, wireType 0 =*/ 8).uint64(message.sequence);
      if (
        message.isFinal != null &&
        Object.hasOwnProperty.call(message, 'isFinal')
      )
        writer.uint32(/* id 2, wireType 0 =*/ 16).bool(message.isFinal);
      if (
        message.utterance != null &&
        Object.hasOwnProperty.call(message, 'utterance')
      )
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.utterance);
      if (
        message.languageCode != null &&
        Object.hasOwnProperty.call(message, 'languageCode')
      )
        writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.languageCode);
      if (
        message.beginTime != null &&
        Object.hasOwnProperty.call(message, 'beginTime')
      )
        writer.uint32(/* id 5, wireType 0 =*/ 40).uint64(message.beginTime);
      if (
        message.endTime != null &&
        Object.hasOwnProperty.call(message, 'endTime')
      )
        writer.uint32(/* id 6, wireType 0 =*/ 48).uint64(message.endTime);
      return writer;
    };

    /**
     * Encodes the specified Subtitle message, length delimited. Does not implicitly {@link si.Subtitle.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.Subtitle
     * @static
     * @param {si.ISubtitle} message Subtitle message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Subtitle.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Subtitle message from the specified reader or buffer.
     * @function decode
     * @memberof si.Subtitle
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.Subtitle} Subtitle
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Subtitle.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.Subtitle();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.sequence = reader.uint64();
            break;
          case 2:
            message.isFinal = reader.bool();
            break;
          case 3:
            message.utterance = reader.string();
            break;
          case 4:
            message.languageCode = reader.string();
            break;
          case 5:
            message.beginTime = reader.uint64();
            break;
          case 6:
            message.endTime = reader.uint64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Subtitle message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.Subtitle
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.Subtitle} Subtitle
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Subtitle.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Subtitle message.
     * @function verify
     * @memberof si.Subtitle
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Subtitle.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.sequence != null && message.hasOwnProperty('sequence'))
        if (
          !$util.isInteger(message.sequence) &&
          !(
            message.sequence &&
            $util.isInteger(message.sequence.low) &&
            $util.isInteger(message.sequence.high)
          )
        )
          return 'sequence: integer|Long expected';
      if (message.isFinal != null && message.hasOwnProperty('isFinal'))
        if (typeof message.isFinal !== 'boolean')
          return 'isFinal: boolean expected';
      if (message.utterance != null && message.hasOwnProperty('utterance'))
        if (!$util.isString(message.utterance))
          return 'utterance: string expected';
      if (
        message.languageCode != null &&
        message.hasOwnProperty('languageCode')
      )
        if (!$util.isString(message.languageCode))
          return 'languageCode: string expected';
      if (message.beginTime != null && message.hasOwnProperty('beginTime'))
        if (
          !$util.isInteger(message.beginTime) &&
          !(
            message.beginTime &&
            $util.isInteger(message.beginTime.low) &&
            $util.isInteger(message.beginTime.high)
          )
        )
          return 'beginTime: integer|Long expected';
      if (message.endTime != null && message.hasOwnProperty('endTime'))
        if (
          !$util.isInteger(message.endTime) &&
          !(
            message.endTime &&
            $util.isInteger(message.endTime.low) &&
            $util.isInteger(message.endTime.high)
          )
        )
          return 'endTime: integer|Long expected';
      return null;
    };

    /**
     * Creates a Subtitle message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.Subtitle
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.Subtitle} Subtitle
     */
    Subtitle.fromObject = function fromObject(object) {
      if (object instanceof $root.si.Subtitle) return object;
      let message = new $root.si.Subtitle();
      if (object.sequence != null)
        if ($util.Long)
          (message.sequence = $util.Long.fromValue(
            object.sequence
          )).unsigned = true;
        else if (typeof object.sequence === 'string')
          message.sequence = parseInt(object.sequence, 10);
        else if (typeof object.sequence === 'number')
          message.sequence = object.sequence;
        else if (typeof object.sequence === 'object')
          message.sequence = new $util.LongBits(
            object.sequence.low >>> 0,
            object.sequence.high >>> 0
          ).toNumber(true);
      if (object.isFinal != null) message.isFinal = Boolean(object.isFinal);
      if (object.utterance != null)
        message.utterance = String(object.utterance);
      if (object.languageCode != null)
        message.languageCode = String(object.languageCode);
      if (object.beginTime != null)
        if ($util.Long)
          (message.beginTime = $util.Long.fromValue(
            object.beginTime
          )).unsigned = true;
        else if (typeof object.beginTime === 'string')
          message.beginTime = parseInt(object.beginTime, 10);
        else if (typeof object.beginTime === 'number')
          message.beginTime = object.beginTime;
        else if (typeof object.beginTime === 'object')
          message.beginTime = new $util.LongBits(
            object.beginTime.low >>> 0,
            object.beginTime.high >>> 0
          ).toNumber(true);
      if (object.endTime != null)
        if ($util.Long)
          (message.endTime = $util.Long.fromValue(
            object.endTime
          )).unsigned = true;
        else if (typeof object.endTime === 'string')
          message.endTime = parseInt(object.endTime, 10);
        else if (typeof object.endTime === 'number')
          message.endTime = object.endTime;
        else if (typeof object.endTime === 'object')
          message.endTime = new $util.LongBits(
            object.endTime.low >>> 0,
            object.endTime.high >>> 0
          ).toNumber(true);
      return message;
    };

    /**
     * Creates a plain object from a Subtitle message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.Subtitle
     * @static
     * @param {si.Subtitle} message Subtitle
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Subtitle.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.sequence =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.sequence = options.longs === String ? '0' : 0;
        object.isFinal = false;
        object.utterance = '';
        object.languageCode = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.beginTime =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.beginTime = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.endTime =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.endTime = options.longs === String ? '0' : 0;
      }
      if (message.sequence != null && message.hasOwnProperty('sequence'))
        if (typeof message.sequence === 'number')
          object.sequence =
            options.longs === String
              ? String(message.sequence)
              : message.sequence;
        else
          object.sequence =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.sequence)
              : options.longs === Number
              ? new $util.LongBits(
                  message.sequence.low >>> 0,
                  message.sequence.high >>> 0
                ).toNumber(true)
              : message.sequence;
      if (message.isFinal != null && message.hasOwnProperty('isFinal'))
        object.isFinal = message.isFinal;
      if (message.utterance != null && message.hasOwnProperty('utterance'))
        object.utterance = message.utterance;
      if (
        message.languageCode != null &&
        message.hasOwnProperty('languageCode')
      )
        object.languageCode = message.languageCode;
      if (message.beginTime != null && message.hasOwnProperty('beginTime'))
        if (typeof message.beginTime === 'number')
          object.beginTime =
            options.longs === String
              ? String(message.beginTime)
              : message.beginTime;
        else
          object.beginTime =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.beginTime)
              : options.longs === Number
              ? new $util.LongBits(
                  message.beginTime.low >>> 0,
                  message.beginTime.high >>> 0
                ).toNumber(true)
              : message.beginTime;
      if (message.endTime != null && message.hasOwnProperty('endTime'))
        if (typeof message.endTime === 'number')
          object.endTime =
            options.longs === String
              ? String(message.endTime)
              : message.endTime;
        else
          object.endTime =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.endTime)
              : options.longs === Number
              ? new $util.LongBits(
                  message.endTime.low >>> 0,
                  message.endTime.high >>> 0
                ).toNumber(true)
              : message.endTime;
      return object;
    };

    /**
     * Converts this Subtitle to JSON.
     * @function toJSON
     * @memberof si.Subtitle
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Subtitle.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Subtitle;
  })();

  si.AvPacketIRL = (function () {
    /**
     * Properties of an AvPacketIRL.
     * @memberof si
     * @interface IAvPacketIRL
     * @property {Long|null} [sequence] AvPacketIRL sequence
     * @property {Uint8Array|null} [bytes] AvPacketIRL bytes
     * @property {Long|null} [pts] AvPacketIRL pts
     * @property {Long|null} [duration] AvPacketIRL duration
     * @property {Long|null} [unixMs] AvPacketIRL unixMs
     */

    /**
     * Constructs a new AvPacketIRL.
     * @memberof si
     * @classdesc Represents an AvPacketIRL.
     * @implements IAvPacketIRL
     * @constructor
     * @param {si.IAvPacketIRL=} [properties] Properties to set
     */
    function AvPacketIRL(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * AvPacketIRL sequence.
     * @member {Long} sequence
     * @memberof si.AvPacketIRL
     * @instance
     */
    AvPacketIRL.prototype.sequence = $util.Long
      ? $util.Long.fromBits(0, 0, true)
      : 0;

    /**
     * AvPacketIRL bytes.
     * @member {Uint8Array} bytes
     * @memberof si.AvPacketIRL
     * @instance
     */
    AvPacketIRL.prototype.bytes = $util.newBuffer([]);

    /**
     * AvPacketIRL pts.
     * @member {Long} pts
     * @memberof si.AvPacketIRL
     * @instance
     */
    AvPacketIRL.prototype.pts = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * AvPacketIRL duration.
     * @member {Long} duration
     * @memberof si.AvPacketIRL
     * @instance
     */
    AvPacketIRL.prototype.duration = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * AvPacketIRL unixMs.
     * @member {Long} unixMs
     * @memberof si.AvPacketIRL
     * @instance
     */
    AvPacketIRL.prototype.unixMs = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * Creates a new AvPacketIRL instance using the specified properties.
     * @function create
     * @memberof si.AvPacketIRL
     * @static
     * @param {si.IAvPacketIRL=} [properties] Properties to set
     * @returns {si.AvPacketIRL} AvPacketIRL instance
     */
    AvPacketIRL.create = function create(properties) {
      return new AvPacketIRL(properties);
    };

    /**
     * Encodes the specified AvPacketIRL message. Does not implicitly {@link si.AvPacketIRL.verify|verify} messages.
     * @function encode
     * @memberof si.AvPacketIRL
     * @static
     * @param {si.IAvPacketIRL} message AvPacketIRL message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AvPacketIRL.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.sequence != null &&
        Object.hasOwnProperty.call(message, 'sequence')
      )
        writer.uint32(/* id 1, wireType 0 =*/ 8).uint64(message.sequence);
      if (message.bytes != null && Object.hasOwnProperty.call(message, 'bytes'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.bytes);
      if (message.pts != null && Object.hasOwnProperty.call(message, 'pts'))
        writer.uint32(/* id 3, wireType 0 =*/ 24).int64(message.pts);
      if (
        message.duration != null &&
        Object.hasOwnProperty.call(message, 'duration')
      )
        writer.uint32(/* id 4, wireType 0 =*/ 32).int64(message.duration);
      if (
        message.unixMs != null &&
        Object.hasOwnProperty.call(message, 'unixMs')
      )
        writer.uint32(/* id 5, wireType 0 =*/ 40).int64(message.unixMs);
      return writer;
    };

    /**
     * Encodes the specified AvPacketIRL message, length delimited. Does not implicitly {@link si.AvPacketIRL.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.AvPacketIRL
     * @static
     * @param {si.IAvPacketIRL} message AvPacketIRL message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AvPacketIRL.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AvPacketIRL message from the specified reader or buffer.
     * @function decode
     * @memberof si.AvPacketIRL
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.AvPacketIRL} AvPacketIRL
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AvPacketIRL.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.AvPacketIRL();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.sequence = reader.uint64();
            break;
          case 2:
            message.bytes = reader.bytes();
            break;
          case 3:
            message.pts = reader.int64();
            break;
          case 4:
            message.duration = reader.int64();
            break;
          case 5:
            message.unixMs = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an AvPacketIRL message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.AvPacketIRL
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.AvPacketIRL} AvPacketIRL
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AvPacketIRL.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AvPacketIRL message.
     * @function verify
     * @memberof si.AvPacketIRL
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AvPacketIRL.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.sequence != null && message.hasOwnProperty('sequence'))
        if (
          !$util.isInteger(message.sequence) &&
          !(
            message.sequence &&
            $util.isInteger(message.sequence.low) &&
            $util.isInteger(message.sequence.high)
          )
        )
          return 'sequence: integer|Long expected';
      if (message.bytes != null && message.hasOwnProperty('bytes'))
        if (
          !(
            (message.bytes && typeof message.bytes.length === 'number') ||
            $util.isString(message.bytes)
          )
        )
          return 'bytes: buffer expected';
      if (message.pts != null && message.hasOwnProperty('pts'))
        if (
          !$util.isInteger(message.pts) &&
          !(
            message.pts &&
            $util.isInteger(message.pts.low) &&
            $util.isInteger(message.pts.high)
          )
        )
          return 'pts: integer|Long expected';
      if (message.duration != null && message.hasOwnProperty('duration'))
        if (
          !$util.isInteger(message.duration) &&
          !(
            message.duration &&
            $util.isInteger(message.duration.low) &&
            $util.isInteger(message.duration.high)
          )
        )
          return 'duration: integer|Long expected';
      if (message.unixMs != null && message.hasOwnProperty('unixMs'))
        if (
          !$util.isInteger(message.unixMs) &&
          !(
            message.unixMs &&
            $util.isInteger(message.unixMs.low) &&
            $util.isInteger(message.unixMs.high)
          )
        )
          return 'unixMs: integer|Long expected';
      return null;
    };

    /**
     * Creates an AvPacketIRL message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.AvPacketIRL
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.AvPacketIRL} AvPacketIRL
     */
    AvPacketIRL.fromObject = function fromObject(object) {
      if (object instanceof $root.si.AvPacketIRL) return object;
      let message = new $root.si.AvPacketIRL();
      if (object.sequence != null)
        if ($util.Long)
          (message.sequence = $util.Long.fromValue(
            object.sequence
          )).unsigned = true;
        else if (typeof object.sequence === 'string')
          message.sequence = parseInt(object.sequence, 10);
        else if (typeof object.sequence === 'number')
          message.sequence = object.sequence;
        else if (typeof object.sequence === 'object')
          message.sequence = new $util.LongBits(
            object.sequence.low >>> 0,
            object.sequence.high >>> 0
          ).toNumber(true);
      if (object.bytes != null)
        if (typeof object.bytes === 'string')
          $util.base64.decode(
            object.bytes,
            (message.bytes = $util.newBuffer(
              $util.base64.length(object.bytes)
            )),
            0
          );
        else if (object.bytes.length) message.bytes = object.bytes;
      if (object.pts != null)
        if ($util.Long)
          (message.pts = $util.Long.fromValue(object.pts)).unsigned = false;
        else if (typeof object.pts === 'string')
          message.pts = parseInt(object.pts, 10);
        else if (typeof object.pts === 'number') message.pts = object.pts;
        else if (typeof object.pts === 'object')
          message.pts = new $util.LongBits(
            object.pts.low >>> 0,
            object.pts.high >>> 0
          ).toNumber();
      if (object.duration != null)
        if ($util.Long)
          (message.duration = $util.Long.fromValue(
            object.duration
          )).unsigned = false;
        else if (typeof object.duration === 'string')
          message.duration = parseInt(object.duration, 10);
        else if (typeof object.duration === 'number')
          message.duration = object.duration;
        else if (typeof object.duration === 'object')
          message.duration = new $util.LongBits(
            object.duration.low >>> 0,
            object.duration.high >>> 0
          ).toNumber();
      if (object.unixMs != null)
        if ($util.Long)
          (message.unixMs = $util.Long.fromValue(
            object.unixMs
          )).unsigned = false;
        else if (typeof object.unixMs === 'string')
          message.unixMs = parseInt(object.unixMs, 10);
        else if (typeof object.unixMs === 'number')
          message.unixMs = object.unixMs;
        else if (typeof object.unixMs === 'object')
          message.unixMs = new $util.LongBits(
            object.unixMs.low >>> 0,
            object.unixMs.high >>> 0
          ).toNumber();
      return message;
    };

    /**
     * Creates a plain object from an AvPacketIRL message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.AvPacketIRL
     * @static
     * @param {si.AvPacketIRL} message AvPacketIRL
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AvPacketIRL.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.sequence =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.sequence = options.longs === String ? '0' : 0;
        if (options.bytes === String) object.bytes = '';
        else {
          object.bytes = [];
          if (options.bytes !== Array)
            object.bytes = $util.newBuffer(object.bytes);
        }
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.pts =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.pts = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.duration =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.duration = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.unixMs =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.unixMs = options.longs === String ? '0' : 0;
      }
      if (message.sequence != null && message.hasOwnProperty('sequence'))
        if (typeof message.sequence === 'number')
          object.sequence =
            options.longs === String
              ? String(message.sequence)
              : message.sequence;
        else
          object.sequence =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.sequence)
              : options.longs === Number
              ? new $util.LongBits(
                  message.sequence.low >>> 0,
                  message.sequence.high >>> 0
                ).toNumber(true)
              : message.sequence;
      if (message.bytes != null && message.hasOwnProperty('bytes'))
        object.bytes =
          options.bytes === String
            ? $util.base64.encode(message.bytes, 0, message.bytes.length)
            : options.bytes === Array
            ? Array.prototype.slice.call(message.bytes)
            : message.bytes;
      if (message.pts != null && message.hasOwnProperty('pts'))
        if (typeof message.pts === 'number')
          object.pts =
            options.longs === String ? String(message.pts) : message.pts;
        else
          object.pts =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.pts)
              : options.longs === Number
              ? new $util.LongBits(
                  message.pts.low >>> 0,
                  message.pts.high >>> 0
                ).toNumber()
              : message.pts;
      if (message.duration != null && message.hasOwnProperty('duration'))
        if (typeof message.duration === 'number')
          object.duration =
            options.longs === String
              ? String(message.duration)
              : message.duration;
        else
          object.duration =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.duration)
              : options.longs === Number
              ? new $util.LongBits(
                  message.duration.low >>> 0,
                  message.duration.high >>> 0
                ).toNumber()
              : message.duration;
      if (message.unixMs != null && message.hasOwnProperty('unixMs'))
        if (typeof message.unixMs === 'number')
          object.unixMs =
            options.longs === String ? String(message.unixMs) : message.unixMs;
        else
          object.unixMs =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.unixMs)
              : options.longs === Number
              ? new $util.LongBits(
                  message.unixMs.low >>> 0,
                  message.unixMs.high >>> 0
                ).toNumber()
              : message.unixMs;
      return object;
    };

    /**
     * Converts this AvPacketIRL to JSON.
     * @function toJSON
     * @memberof si.AvPacketIRL
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AvPacketIRL.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AvPacketIRL;
  })();

  si.AvMetaIRL = (function () {
    /**
     * Properties of an AvMetaIRL.
     * @memberof si
     * @interface IAvMetaIRL
     * @property {si.AvMetaIRL.AvFormat|null} [format] AvMetaIRL format
     * @property {number|null} [rate] AvMetaIRL rate
     * @property {number|null} [numChannels] AvMetaIRL numChannels
     */

    /**
     * Constructs a new AvMetaIRL.
     * @memberof si
     * @classdesc Represents an AvMetaIRL.
     * @implements IAvMetaIRL
     * @constructor
     * @param {si.IAvMetaIRL=} [properties] Properties to set
     */
    function AvMetaIRL(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * AvMetaIRL format.
     * @member {si.AvMetaIRL.AvFormat} format
     * @memberof si.AvMetaIRL
     * @instance
     */
    AvMetaIRL.prototype.format = 0;

    /**
     * AvMetaIRL rate.
     * @member {number} rate
     * @memberof si.AvMetaIRL
     * @instance
     */
    AvMetaIRL.prototype.rate = 0;

    /**
     * AvMetaIRL numChannels.
     * @member {number} numChannels
     * @memberof si.AvMetaIRL
     * @instance
     */
    AvMetaIRL.prototype.numChannels = 0;

    /**
     * Creates a new AvMetaIRL instance using the specified properties.
     * @function create
     * @memberof si.AvMetaIRL
     * @static
     * @param {si.IAvMetaIRL=} [properties] Properties to set
     * @returns {si.AvMetaIRL} AvMetaIRL instance
     */
    AvMetaIRL.create = function create(properties) {
      return new AvMetaIRL(properties);
    };

    /**
     * Encodes the specified AvMetaIRL message. Does not implicitly {@link si.AvMetaIRL.verify|verify} messages.
     * @function encode
     * @memberof si.AvMetaIRL
     * @static
     * @param {si.IAvMetaIRL} message AvMetaIRL message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AvMetaIRL.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.format != null &&
        Object.hasOwnProperty.call(message, 'format')
      )
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.format);
      if (message.rate != null && Object.hasOwnProperty.call(message, 'rate'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.rate);
      if (
        message.numChannels != null &&
        Object.hasOwnProperty.call(message, 'numChannels')
      )
        writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.numChannels);
      return writer;
    };

    /**
     * Encodes the specified AvMetaIRL message, length delimited. Does not implicitly {@link si.AvMetaIRL.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.AvMetaIRL
     * @static
     * @param {si.IAvMetaIRL} message AvMetaIRL message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AvMetaIRL.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AvMetaIRL message from the specified reader or buffer.
     * @function decode
     * @memberof si.AvMetaIRL
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.AvMetaIRL} AvMetaIRL
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AvMetaIRL.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.AvMetaIRL();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.format = reader.int32();
            break;
          case 2:
            message.rate = reader.int32();
            break;
          case 3:
            message.numChannels = reader.int32();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an AvMetaIRL message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.AvMetaIRL
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.AvMetaIRL} AvMetaIRL
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AvMetaIRL.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AvMetaIRL message.
     * @function verify
     * @memberof si.AvMetaIRL
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AvMetaIRL.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.format != null && message.hasOwnProperty('format'))
        switch (message.format) {
          default:
            return 'format: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      if (message.rate != null && message.hasOwnProperty('rate'))
        if (!$util.isInteger(message.rate)) return 'rate: integer expected';
      if (message.numChannels != null && message.hasOwnProperty('numChannels'))
        if (!$util.isInteger(message.numChannels))
          return 'numChannels: integer expected';
      return null;
    };

    /**
     * Creates an AvMetaIRL message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.AvMetaIRL
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.AvMetaIRL} AvMetaIRL
     */
    AvMetaIRL.fromObject = function fromObject(object) {
      if (object instanceof $root.si.AvMetaIRL) return object;
      let message = new $root.si.AvMetaIRL();
      switch (object.format) {
        case 'UNSPECIFIED':
        case 0:
          message.format = 0;
          break;
        case 'AUDIO_LINEAR16':
        case 1:
          message.format = 1;
          break;
        case 'AUDIO_MP3':
        case 2:
          message.format = 2;
          break;
        case 'AUDIO_AAC_ADTS':
        case 3:
          message.format = 3;
          break;
        case 'AUDIO_MOV_MP4_M4A_3GP_3G2_MJ2':
        case 4:
          message.format = 4;
          break;
      }
      if (object.rate != null) message.rate = object.rate | 0;
      if (object.numChannels != null)
        message.numChannels = object.numChannels | 0;
      return message;
    };

    /**
     * Creates a plain object from an AvMetaIRL message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.AvMetaIRL
     * @static
     * @param {si.AvMetaIRL} message AvMetaIRL
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AvMetaIRL.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.format = options.enums === String ? 'UNSPECIFIED' : 0;
        object.rate = 0;
        object.numChannels = 0;
      }
      if (message.format != null && message.hasOwnProperty('format'))
        object.format =
          options.enums === String
            ? $root.si.AvMetaIRL.AvFormat[message.format]
            : message.format;
      if (message.rate != null && message.hasOwnProperty('rate'))
        object.rate = message.rate;
      if (message.numChannels != null && message.hasOwnProperty('numChannels'))
        object.numChannels = message.numChannels;
      return object;
    };

    /**
     * Converts this AvMetaIRL to JSON.
     * @function toJSON
     * @memberof si.AvMetaIRL
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AvMetaIRL.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * AvFormat enum.
     * @name si.AvMetaIRL.AvFormat
     * @enum {number}
     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
     * @property {number} AUDIO_LINEAR16=1 AUDIO_LINEAR16 value
     * @property {number} AUDIO_MP3=2 AUDIO_MP3 value
     * @property {number} AUDIO_AAC_ADTS=3 AUDIO_AAC_ADTS value
     * @property {number} AUDIO_MOV_MP4_M4A_3GP_3G2_MJ2=4 AUDIO_MOV_MP4_M4A_3GP_3G2_MJ2 value
     */
    AvMetaIRL.AvFormat = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'UNSPECIFIED')] = 0;
      values[(valuesById[1] = 'AUDIO_LINEAR16')] = 1;
      values[(valuesById[2] = 'AUDIO_MP3')] = 2;
      values[(valuesById[3] = 'AUDIO_AAC_ADTS')] = 3;
      values[(valuesById[4] = 'AUDIO_MOV_MP4_M4A_3GP_3G2_MJ2')] = 4;
      return values;
    })();

    return AvMetaIRL;
  })();

  si.Timestamp = (function () {
    /**
     * Properties of a Timestamp.
     * @memberof si
     * @interface ITimestamp
     * @property {Long|null} [begin] Timestamp begin
     * @property {Long|null} [end] Timestamp end
     */

    /**
     * Constructs a new Timestamp.
     * @memberof si
     * @classdesc Represents a Timestamp.
     * @implements ITimestamp
     * @constructor
     * @param {si.ITimestamp=} [properties] Properties to set
     */
    function Timestamp(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Timestamp begin.
     * @member {Long} begin
     * @memberof si.Timestamp
     * @instance
     */
    Timestamp.prototype.begin = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * Timestamp end.
     * @member {Long} end
     * @memberof si.Timestamp
     * @instance
     */
    Timestamp.prototype.end = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Creates a new Timestamp instance using the specified properties.
     * @function create
     * @memberof si.Timestamp
     * @static
     * @param {si.ITimestamp=} [properties] Properties to set
     * @returns {si.Timestamp} Timestamp instance
     */
    Timestamp.create = function create(properties) {
      return new Timestamp(properties);
    };

    /**
     * Encodes the specified Timestamp message. Does not implicitly {@link si.Timestamp.verify|verify} messages.
     * @function encode
     * @memberof si.Timestamp
     * @static
     * @param {si.ITimestamp} message Timestamp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Timestamp.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.begin != null && Object.hasOwnProperty.call(message, 'begin'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.begin);
      if (message.end != null && Object.hasOwnProperty.call(message, 'end'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.end);
      return writer;
    };

    /**
     * Encodes the specified Timestamp message, length delimited. Does not implicitly {@link si.Timestamp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.Timestamp
     * @static
     * @param {si.ITimestamp} message Timestamp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Timestamp.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Timestamp message from the specified reader or buffer.
     * @function decode
     * @memberof si.Timestamp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.Timestamp} Timestamp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Timestamp.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.Timestamp();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.begin = reader.int64();
            break;
          case 2:
            message.end = reader.int64();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Timestamp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.Timestamp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.Timestamp} Timestamp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Timestamp.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Timestamp message.
     * @function verify
     * @memberof si.Timestamp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Timestamp.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.begin != null && message.hasOwnProperty('begin'))
        if (
          !$util.isInteger(message.begin) &&
          !(
            message.begin &&
            $util.isInteger(message.begin.low) &&
            $util.isInteger(message.begin.high)
          )
        )
          return 'begin: integer|Long expected';
      if (message.end != null && message.hasOwnProperty('end'))
        if (
          !$util.isInteger(message.end) &&
          !(
            message.end &&
            $util.isInteger(message.end.low) &&
            $util.isInteger(message.end.high)
          )
        )
          return 'end: integer|Long expected';
      return null;
    };

    /**
     * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.Timestamp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.Timestamp} Timestamp
     */
    Timestamp.fromObject = function fromObject(object) {
      if (object instanceof $root.si.Timestamp) return object;
      let message = new $root.si.Timestamp();
      if (object.begin != null)
        if ($util.Long)
          (message.begin = $util.Long.fromValue(object.begin)).unsigned = false;
        else if (typeof object.begin === 'string')
          message.begin = parseInt(object.begin, 10);
        else if (typeof object.begin === 'number') message.begin = object.begin;
        else if (typeof object.begin === 'object')
          message.begin = new $util.LongBits(
            object.begin.low >>> 0,
            object.begin.high >>> 0
          ).toNumber();
      if (object.end != null)
        if ($util.Long)
          (message.end = $util.Long.fromValue(object.end)).unsigned = false;
        else if (typeof object.end === 'string')
          message.end = parseInt(object.end, 10);
        else if (typeof object.end === 'number') message.end = object.end;
        else if (typeof object.end === 'object')
          message.end = new $util.LongBits(
            object.end.low >>> 0,
            object.end.high >>> 0
          ).toNumber();
      return message;
    };

    /**
     * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.Timestamp
     * @static
     * @param {si.Timestamp} message Timestamp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Timestamp.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.begin =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.begin = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.end =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.end = options.longs === String ? '0' : 0;
      }
      if (message.begin != null && message.hasOwnProperty('begin'))
        if (typeof message.begin === 'number')
          object.begin =
            options.longs === String ? String(message.begin) : message.begin;
        else
          object.begin =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.begin)
              : options.longs === Number
              ? new $util.LongBits(
                  message.begin.low >>> 0,
                  message.begin.high >>> 0
                ).toNumber()
              : message.begin;
      if (message.end != null && message.hasOwnProperty('end'))
        if (typeof message.end === 'number')
          object.end =
            options.longs === String ? String(message.end) : message.end;
        else
          object.end =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.end)
              : options.longs === Number
              ? new $util.LongBits(
                  message.end.low >>> 0,
                  message.end.high >>> 0
                ).toNumber()
              : message.end;
      return object;
    };

    /**
     * Converts this Timestamp to JSON.
     * @function toJSON
     * @memberof si.Timestamp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Timestamp.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Timestamp;
  })();

  si.AudioTs = (function () {
    /**
     * Properties of an AudioTs.
     * @memberof si
     * @interface IAudioTs
     * @property {Long|null} [begin] AudioTs begin
     * @property {Long|null} [end] AudioTs end
     * @property {Array.<si.ITimestamp>|null} [passThrough] AudioTs passThrough
     */

    /**
     * Constructs a new AudioTs.
     * @memberof si
     * @classdesc Represents an AudioTs.
     * @implements IAudioTs
     * @constructor
     * @param {si.IAudioTs=} [properties] Properties to set
     */
    function AudioTs(properties) {
      this.passThrough = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * AudioTs begin.
     * @member {Long} begin
     * @memberof si.AudioTs
     * @instance
     */
    AudioTs.prototype.begin = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * AudioTs end.
     * @member {Long} end
     * @memberof si.AudioTs
     * @instance
     */
    AudioTs.prototype.end = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * AudioTs passThrough.
     * @member {Array.<si.ITimestamp>} passThrough
     * @memberof si.AudioTs
     * @instance
     */
    AudioTs.prototype.passThrough = $util.emptyArray;

    /**
     * Creates a new AudioTs instance using the specified properties.
     * @function create
     * @memberof si.AudioTs
     * @static
     * @param {si.IAudioTs=} [properties] Properties to set
     * @returns {si.AudioTs} AudioTs instance
     */
    AudioTs.create = function create(properties) {
      return new AudioTs(properties);
    };

    /**
     * Encodes the specified AudioTs message. Does not implicitly {@link si.AudioTs.verify|verify} messages.
     * @function encode
     * @memberof si.AudioTs
     * @static
     * @param {si.IAudioTs} message AudioTs message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AudioTs.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.begin != null && Object.hasOwnProperty.call(message, 'begin'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.begin);
      if (message.end != null && Object.hasOwnProperty.call(message, 'end'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.end);
      if (message.passThrough != null && message.passThrough.length)
        for (let i = 0; i < message.passThrough.length; ++i)
          $root.si.Timestamp.encode(
            message.passThrough[i],
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified AudioTs message, length delimited. Does not implicitly {@link si.AudioTs.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.AudioTs
     * @static
     * @param {si.IAudioTs} message AudioTs message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AudioTs.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AudioTs message from the specified reader or buffer.
     * @function decode
     * @memberof si.AudioTs
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.AudioTs} AudioTs
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AudioTs.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.AudioTs();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.begin = reader.int64();
            break;
          case 2:
            message.end = reader.int64();
            break;
          case 3:
            if (!(message.passThrough && message.passThrough.length))
              message.passThrough = [];
            message.passThrough.push(
              $root.si.Timestamp.decode(reader, reader.uint32())
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an AudioTs message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.AudioTs
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.AudioTs} AudioTs
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AudioTs.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AudioTs message.
     * @function verify
     * @memberof si.AudioTs
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AudioTs.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.begin != null && message.hasOwnProperty('begin'))
        if (
          !$util.isInteger(message.begin) &&
          !(
            message.begin &&
            $util.isInteger(message.begin.low) &&
            $util.isInteger(message.begin.high)
          )
        )
          return 'begin: integer|Long expected';
      if (message.end != null && message.hasOwnProperty('end'))
        if (
          !$util.isInteger(message.end) &&
          !(
            message.end &&
            $util.isInteger(message.end.low) &&
            $util.isInteger(message.end.high)
          )
        )
          return 'end: integer|Long expected';
      if (
        message.passThrough != null &&
        message.hasOwnProperty('passThrough')
      ) {
        if (!Array.isArray(message.passThrough))
          return 'passThrough: array expected';
        for (let i = 0; i < message.passThrough.length; ++i) {
          let error = $root.si.Timestamp.verify(message.passThrough[i]);
          if (error) return 'passThrough.' + error;
        }
      }
      return null;
    };

    /**
     * Creates an AudioTs message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.AudioTs
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.AudioTs} AudioTs
     */
    AudioTs.fromObject = function fromObject(object) {
      if (object instanceof $root.si.AudioTs) return object;
      let message = new $root.si.AudioTs();
      if (object.begin != null)
        if ($util.Long)
          (message.begin = $util.Long.fromValue(object.begin)).unsigned = false;
        else if (typeof object.begin === 'string')
          message.begin = parseInt(object.begin, 10);
        else if (typeof object.begin === 'number') message.begin = object.begin;
        else if (typeof object.begin === 'object')
          message.begin = new $util.LongBits(
            object.begin.low >>> 0,
            object.begin.high >>> 0
          ).toNumber();
      if (object.end != null)
        if ($util.Long)
          (message.end = $util.Long.fromValue(object.end)).unsigned = false;
        else if (typeof object.end === 'string')
          message.end = parseInt(object.end, 10);
        else if (typeof object.end === 'number') message.end = object.end;
        else if (typeof object.end === 'object')
          message.end = new $util.LongBits(
            object.end.low >>> 0,
            object.end.high >>> 0
          ).toNumber();
      if (object.passThrough) {
        if (!Array.isArray(object.passThrough))
          throw TypeError('.si.AudioTs.passThrough: array expected');
        message.passThrough = [];
        for (let i = 0; i < object.passThrough.length; ++i) {
          if (typeof object.passThrough[i] !== 'object')
            throw TypeError('.si.AudioTs.passThrough: object expected');
          message.passThrough[i] = $root.si.Timestamp.fromObject(
            object.passThrough[i]
          );
        }
      }
      return message;
    };

    /**
     * Creates a plain object from an AudioTs message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.AudioTs
     * @static
     * @param {si.AudioTs} message AudioTs
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AudioTs.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.passThrough = [];
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.begin =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.begin = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.end =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.end = options.longs === String ? '0' : 0;
      }
      if (message.begin != null && message.hasOwnProperty('begin'))
        if (typeof message.begin === 'number')
          object.begin =
            options.longs === String ? String(message.begin) : message.begin;
        else
          object.begin =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.begin)
              : options.longs === Number
              ? new $util.LongBits(
                  message.begin.low >>> 0,
                  message.begin.high >>> 0
                ).toNumber()
              : message.begin;
      if (message.end != null && message.hasOwnProperty('end'))
        if (typeof message.end === 'number')
          object.end =
            options.longs === String ? String(message.end) : message.end;
        else
          object.end =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.end)
              : options.longs === Number
              ? new $util.LongBits(
                  message.end.low >>> 0,
                  message.end.high >>> 0
                ).toNumber()
              : message.end;
      if (message.passThrough && message.passThrough.length) {
        object.passThrough = [];
        for (let j = 0; j < message.passThrough.length; ++j)
          object.passThrough[j] = $root.si.Timestamp.toObject(
            message.passThrough[j],
            options
          );
      }
      return object;
    };

    /**
     * Converts this AudioTs to JSON.
     * @function toJSON
     * @memberof si.AudioTs
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AudioTs.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AudioTs;
  })();

  si.SubtitleTimestamp = (function () {
    /**
     * Properties of a SubtitleTimestamp.
     * @memberof si
     * @interface ISubtitleTimestamp
     * @property {si.ITimestamp|null} [ats] SubtitleTimestamp ats
     * @property {si.ITimestamp|null} [pts] SubtitleTimestamp pts
     * @property {si.ITimestamp|null} [unix] SubtitleTimestamp unix
     */

    /**
     * Constructs a new SubtitleTimestamp.
     * @memberof si
     * @classdesc Represents a SubtitleTimestamp.
     * @implements ISubtitleTimestamp
     * @constructor
     * @param {si.ISubtitleTimestamp=} [properties] Properties to set
     */
    function SubtitleTimestamp(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SubtitleTimestamp ats.
     * @member {si.ITimestamp|null|undefined} ats
     * @memberof si.SubtitleTimestamp
     * @instance
     */
    SubtitleTimestamp.prototype.ats = null;

    /**
     * SubtitleTimestamp pts.
     * @member {si.ITimestamp|null|undefined} pts
     * @memberof si.SubtitleTimestamp
     * @instance
     */
    SubtitleTimestamp.prototype.pts = null;

    /**
     * SubtitleTimestamp unix.
     * @member {si.ITimestamp|null|undefined} unix
     * @memberof si.SubtitleTimestamp
     * @instance
     */
    SubtitleTimestamp.prototype.unix = null;

    /**
     * Creates a new SubtitleTimestamp instance using the specified properties.
     * @function create
     * @memberof si.SubtitleTimestamp
     * @static
     * @param {si.ISubtitleTimestamp=} [properties] Properties to set
     * @returns {si.SubtitleTimestamp} SubtitleTimestamp instance
     */
    SubtitleTimestamp.create = function create(properties) {
      return new SubtitleTimestamp(properties);
    };

    /**
     * Encodes the specified SubtitleTimestamp message. Does not implicitly {@link si.SubtitleTimestamp.verify|verify} messages.
     * @function encode
     * @memberof si.SubtitleTimestamp
     * @static
     * @param {si.ISubtitleTimestamp} message SubtitleTimestamp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubtitleTimestamp.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.ats != null && Object.hasOwnProperty.call(message, 'ats'))
        $root.si.Timestamp.encode(
          message.ats,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (message.pts != null && Object.hasOwnProperty.call(message, 'pts'))
        $root.si.Timestamp.encode(
          message.pts,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      if (message.unix != null && Object.hasOwnProperty.call(message, 'unix'))
        $root.si.Timestamp.encode(
          message.unix,
          writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified SubtitleTimestamp message, length delimited. Does not implicitly {@link si.SubtitleTimestamp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.SubtitleTimestamp
     * @static
     * @param {si.ISubtitleTimestamp} message SubtitleTimestamp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubtitleTimestamp.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SubtitleTimestamp message from the specified reader or buffer.
     * @function decode
     * @memberof si.SubtitleTimestamp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.SubtitleTimestamp} SubtitleTimestamp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubtitleTimestamp.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.SubtitleTimestamp();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.ats = $root.si.Timestamp.decode(reader, reader.uint32());
            break;
          case 2:
            message.pts = $root.si.Timestamp.decode(reader, reader.uint32());
            break;
          case 3:
            message.unix = $root.si.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SubtitleTimestamp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.SubtitleTimestamp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.SubtitleTimestamp} SubtitleTimestamp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubtitleTimestamp.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SubtitleTimestamp message.
     * @function verify
     * @memberof si.SubtitleTimestamp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SubtitleTimestamp.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.ats != null && message.hasOwnProperty('ats')) {
        let error = $root.si.Timestamp.verify(message.ats);
        if (error) return 'ats.' + error;
      }
      if (message.pts != null && message.hasOwnProperty('pts')) {
        let error = $root.si.Timestamp.verify(message.pts);
        if (error) return 'pts.' + error;
      }
      if (message.unix != null && message.hasOwnProperty('unix')) {
        let error = $root.si.Timestamp.verify(message.unix);
        if (error) return 'unix.' + error;
      }
      return null;
    };

    /**
     * Creates a SubtitleTimestamp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.SubtitleTimestamp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.SubtitleTimestamp} SubtitleTimestamp
     */
    SubtitleTimestamp.fromObject = function fromObject(object) {
      if (object instanceof $root.si.SubtitleTimestamp) return object;
      let message = new $root.si.SubtitleTimestamp();
      if (object.ats != null) {
        if (typeof object.ats !== 'object')
          throw TypeError('.si.SubtitleTimestamp.ats: object expected');
        message.ats = $root.si.Timestamp.fromObject(object.ats);
      }
      if (object.pts != null) {
        if (typeof object.pts !== 'object')
          throw TypeError('.si.SubtitleTimestamp.pts: object expected');
        message.pts = $root.si.Timestamp.fromObject(object.pts);
      }
      if (object.unix != null) {
        if (typeof object.unix !== 'object')
          throw TypeError('.si.SubtitleTimestamp.unix: object expected');
        message.unix = $root.si.Timestamp.fromObject(object.unix);
      }
      return message;
    };

    /**
     * Creates a plain object from a SubtitleTimestamp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.SubtitleTimestamp
     * @static
     * @param {si.SubtitleTimestamp} message SubtitleTimestamp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SubtitleTimestamp.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.ats = null;
        object.pts = null;
        object.unix = null;
      }
      if (message.ats != null && message.hasOwnProperty('ats'))
        object.ats = $root.si.Timestamp.toObject(message.ats, options);
      if (message.pts != null && message.hasOwnProperty('pts'))
        object.pts = $root.si.Timestamp.toObject(message.pts, options);
      if (message.unix != null && message.hasOwnProperty('unix'))
        object.unix = $root.si.Timestamp.toObject(message.unix, options);
      return object;
    };

    /**
     * Converts this SubtitleTimestamp to JSON.
     * @function toJSON
     * @memberof si.SubtitleTimestamp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SubtitleTimestamp.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SubtitleTimestamp;
  })();

  si.SentenceInfo = (function () {
    /**
     * Properties of a SentenceInfo.
     * @memberof si
     * @interface ISentenceInfo
     * @property {string|null} [utterance] SentenceInfo utterance
     * @property {si.ISubtitleTimestamp|null} [timestamps] SentenceInfo timestamps
     * @property {Array.<si.IWordInfo>|null} [wordInfo] SentenceInfo wordInfo
     */

    /**
     * Constructs a new SentenceInfo.
     * @memberof si
     * @classdesc Represents a SentenceInfo.
     * @implements ISentenceInfo
     * @constructor
     * @param {si.ISentenceInfo=} [properties] Properties to set
     */
    function SentenceInfo(properties) {
      this.wordInfo = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SentenceInfo utterance.
     * @member {string} utterance
     * @memberof si.SentenceInfo
     * @instance
     */
    SentenceInfo.prototype.utterance = '';

    /**
     * SentenceInfo timestamps.
     * @member {si.ISubtitleTimestamp|null|undefined} timestamps
     * @memberof si.SentenceInfo
     * @instance
     */
    SentenceInfo.prototype.timestamps = null;

    /**
     * SentenceInfo wordInfo.
     * @member {Array.<si.IWordInfo>} wordInfo
     * @memberof si.SentenceInfo
     * @instance
     */
    SentenceInfo.prototype.wordInfo = $util.emptyArray;

    /**
     * Creates a new SentenceInfo instance using the specified properties.
     * @function create
     * @memberof si.SentenceInfo
     * @static
     * @param {si.ISentenceInfo=} [properties] Properties to set
     * @returns {si.SentenceInfo} SentenceInfo instance
     */
    SentenceInfo.create = function create(properties) {
      return new SentenceInfo(properties);
    };

    /**
     * Encodes the specified SentenceInfo message. Does not implicitly {@link si.SentenceInfo.verify|verify} messages.
     * @function encode
     * @memberof si.SentenceInfo
     * @static
     * @param {si.ISentenceInfo} message SentenceInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SentenceInfo.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.utterance != null &&
        Object.hasOwnProperty.call(message, 'utterance')
      )
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.utterance);
      if (
        message.timestamps != null &&
        Object.hasOwnProperty.call(message, 'timestamps')
      )
        $root.si.SubtitleTimestamp.encode(
          message.timestamps,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      if (message.wordInfo != null && message.wordInfo.length)
        for (let i = 0; i < message.wordInfo.length; ++i)
          $root.si.WordInfo.encode(
            message.wordInfo[i],
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified SentenceInfo message, length delimited. Does not implicitly {@link si.SentenceInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.SentenceInfo
     * @static
     * @param {si.ISentenceInfo} message SentenceInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SentenceInfo.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SentenceInfo message from the specified reader or buffer.
     * @function decode
     * @memberof si.SentenceInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.SentenceInfo} SentenceInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SentenceInfo.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.SentenceInfo();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.utterance = reader.string();
            break;
          case 2:
            message.timestamps = $root.si.SubtitleTimestamp.decode(
              reader,
              reader.uint32()
            );
            break;
          case 3:
            if (!(message.wordInfo && message.wordInfo.length))
              message.wordInfo = [];
            message.wordInfo.push(
              $root.si.WordInfo.decode(reader, reader.uint32())
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SentenceInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.SentenceInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.SentenceInfo} SentenceInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SentenceInfo.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SentenceInfo message.
     * @function verify
     * @memberof si.SentenceInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SentenceInfo.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.utterance != null && message.hasOwnProperty('utterance'))
        if (!$util.isString(message.utterance))
          return 'utterance: string expected';
      if (message.timestamps != null && message.hasOwnProperty('timestamps')) {
        let error = $root.si.SubtitleTimestamp.verify(message.timestamps);
        if (error) return 'timestamps.' + error;
      }
      if (message.wordInfo != null && message.hasOwnProperty('wordInfo')) {
        if (!Array.isArray(message.wordInfo)) return 'wordInfo: array expected';
        for (let i = 0; i < message.wordInfo.length; ++i) {
          let error = $root.si.WordInfo.verify(message.wordInfo[i]);
          if (error) return 'wordInfo.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a SentenceInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.SentenceInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.SentenceInfo} SentenceInfo
     */
    SentenceInfo.fromObject = function fromObject(object) {
      if (object instanceof $root.si.SentenceInfo) return object;
      let message = new $root.si.SentenceInfo();
      if (object.utterance != null)
        message.utterance = String(object.utterance);
      if (object.timestamps != null) {
        if (typeof object.timestamps !== 'object')
          throw TypeError('.si.SentenceInfo.timestamps: object expected');
        message.timestamps = $root.si.SubtitleTimestamp.fromObject(
          object.timestamps
        );
      }
      if (object.wordInfo) {
        if (!Array.isArray(object.wordInfo))
          throw TypeError('.si.SentenceInfo.wordInfo: array expected');
        message.wordInfo = [];
        for (let i = 0; i < object.wordInfo.length; ++i) {
          if (typeof object.wordInfo[i] !== 'object')
            throw TypeError('.si.SentenceInfo.wordInfo: object expected');
          message.wordInfo[i] = $root.si.WordInfo.fromObject(
            object.wordInfo[i]
          );
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a SentenceInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.SentenceInfo
     * @static
     * @param {si.SentenceInfo} message SentenceInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SentenceInfo.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.wordInfo = [];
      if (options.defaults) {
        object.utterance = '';
        object.timestamps = null;
      }
      if (message.utterance != null && message.hasOwnProperty('utterance'))
        object.utterance = message.utterance;
      if (message.timestamps != null && message.hasOwnProperty('timestamps'))
        object.timestamps = $root.si.SubtitleTimestamp.toObject(
          message.timestamps,
          options
        );
      if (message.wordInfo && message.wordInfo.length) {
        object.wordInfo = [];
        for (let j = 0; j < message.wordInfo.length; ++j)
          object.wordInfo[j] = $root.si.WordInfo.toObject(
            message.wordInfo[j],
            options
          );
      }
      return object;
    };

    /**
     * Converts this SentenceInfo to JSON.
     * @function toJSON
     * @memberof si.SentenceInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SentenceInfo.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SentenceInfo;
  })();

  si.WordInfo = (function () {
    /**
     * Properties of a WordInfo.
     * @memberof si
     * @interface IWordInfo
     * @property {string|null} [token] WordInfo token
     * @property {boolean|null} [vadEvent] WordInfo vadEvent
     * @property {si.ITimestamp|null} [ats] WordInfo ats
     */

    /**
     * Constructs a new WordInfo.
     * @memberof si
     * @classdesc Represents a WordInfo.
     * @implements IWordInfo
     * @constructor
     * @param {si.IWordInfo=} [properties] Properties to set
     */
    function WordInfo(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * WordInfo token.
     * @member {string} token
     * @memberof si.WordInfo
     * @instance
     */
    WordInfo.prototype.token = '';

    /**
     * WordInfo vadEvent.
     * @member {boolean} vadEvent
     * @memberof si.WordInfo
     * @instance
     */
    WordInfo.prototype.vadEvent = false;

    /**
     * WordInfo ats.
     * @member {si.ITimestamp|null|undefined} ats
     * @memberof si.WordInfo
     * @instance
     */
    WordInfo.prototype.ats = null;

    /**
     * Creates a new WordInfo instance using the specified properties.
     * @function create
     * @memberof si.WordInfo
     * @static
     * @param {si.IWordInfo=} [properties] Properties to set
     * @returns {si.WordInfo} WordInfo instance
     */
    WordInfo.create = function create(properties) {
      return new WordInfo(properties);
    };

    /**
     * Encodes the specified WordInfo message. Does not implicitly {@link si.WordInfo.verify|verify} messages.
     * @function encode
     * @memberof si.WordInfo
     * @static
     * @param {si.IWordInfo} message WordInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WordInfo.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.token != null && Object.hasOwnProperty.call(message, 'token'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.token);
      if (
        message.vadEvent != null &&
        Object.hasOwnProperty.call(message, 'vadEvent')
      )
        writer.uint32(/* id 2, wireType 0 =*/ 16).bool(message.vadEvent);
      if (message.ats != null && Object.hasOwnProperty.call(message, 'ats'))
        $root.si.Timestamp.encode(
          message.ats,
          writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified WordInfo message, length delimited. Does not implicitly {@link si.WordInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.WordInfo
     * @static
     * @param {si.IWordInfo} message WordInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WordInfo.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WordInfo message from the specified reader or buffer.
     * @function decode
     * @memberof si.WordInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.WordInfo} WordInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WordInfo.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.WordInfo();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.token = reader.string();
            break;
          case 2:
            message.vadEvent = reader.bool();
            break;
          case 3:
            message.ats = $root.si.Timestamp.decode(reader, reader.uint32());
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a WordInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.WordInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.WordInfo} WordInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WordInfo.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WordInfo message.
     * @function verify
     * @memberof si.WordInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WordInfo.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.token != null && message.hasOwnProperty('token'))
        if (!$util.isString(message.token)) return 'token: string expected';
      if (message.vadEvent != null && message.hasOwnProperty('vadEvent'))
        if (typeof message.vadEvent !== 'boolean')
          return 'vadEvent: boolean expected';
      if (message.ats != null && message.hasOwnProperty('ats')) {
        let error = $root.si.Timestamp.verify(message.ats);
        if (error) return 'ats.' + error;
      }
      return null;
    };

    /**
     * Creates a WordInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.WordInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.WordInfo} WordInfo
     */
    WordInfo.fromObject = function fromObject(object) {
      if (object instanceof $root.si.WordInfo) return object;
      let message = new $root.si.WordInfo();
      if (object.token != null) message.token = String(object.token);
      if (object.vadEvent != null) message.vadEvent = Boolean(object.vadEvent);
      if (object.ats != null) {
        if (typeof object.ats !== 'object')
          throw TypeError('.si.WordInfo.ats: object expected');
        message.ats = $root.si.Timestamp.fromObject(object.ats);
      }
      return message;
    };

    /**
     * Creates a plain object from a WordInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.WordInfo
     * @static
     * @param {si.WordInfo} message WordInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WordInfo.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.token = '';
        object.vadEvent = false;
        object.ats = null;
      }
      if (message.token != null && message.hasOwnProperty('token'))
        object.token = message.token;
      if (message.vadEvent != null && message.hasOwnProperty('vadEvent'))
        object.vadEvent = message.vadEvent;
      if (message.ats != null && message.hasOwnProperty('ats'))
        object.ats = $root.si.Timestamp.toObject(message.ats, options);
      return object;
    };

    /**
     * Converts this WordInfo to JSON.
     * @function toJSON
     * @memberof si.WordInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WordInfo.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WordInfo;
  })();

  si.SubtitleIRL = (function () {
    /**
     * Properties of a SubtitleIRL.
     * @memberof si
     * @interface ISubtitleIRL
     * @property {si.SubtitleIRL.SubtitleType|null} ["class"] SubtitleIRL class
     * @property {string|null} [languageCode] SubtitleIRL languageCode
     * @property {boolean|null} [definite] SubtitleIRL definite
     * @property {Long|null} [seqId] SubtitleIRL seqId
     * @property {Array.<si.ISentenceInfo>|null} [transformations] SubtitleIRL transformations
     * @property {Long|null} [createTime] SubtitleIRL createTime
     * @property {string|null} [session] SubtitleIRL session
     * @property {string|null} [signature] SubtitleIRL signature
     */

    /**
     * Constructs a new SubtitleIRL.
     * @memberof si
     * @classdesc Represents a SubtitleIRL.
     * @implements ISubtitleIRL
     * @constructor
     * @param {si.ISubtitleIRL=} [properties] Properties to set
     */
    function SubtitleIRL(properties) {
      this.transformations = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SubtitleIRL class.
     * @member {si.SubtitleIRL.SubtitleType} class
     * @memberof si.SubtitleIRL
     * @instance
     */
    SubtitleIRL.prototype['class'] = 0;

    /**
     * SubtitleIRL languageCode.
     * @member {string} languageCode
     * @memberof si.SubtitleIRL
     * @instance
     */
    SubtitleIRL.prototype.languageCode = '';

    /**
     * SubtitleIRL definite.
     * @member {boolean} definite
     * @memberof si.SubtitleIRL
     * @instance
     */
    SubtitleIRL.prototype.definite = false;

    /**
     * SubtitleIRL seqId.
     * @member {Long} seqId
     * @memberof si.SubtitleIRL
     * @instance
     */
    SubtitleIRL.prototype.seqId = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * SubtitleIRL transformations.
     * @member {Array.<si.ISentenceInfo>} transformations
     * @memberof si.SubtitleIRL
     * @instance
     */
    SubtitleIRL.prototype.transformations = $util.emptyArray;

    /**
     * SubtitleIRL createTime.
     * @member {Long} createTime
     * @memberof si.SubtitleIRL
     * @instance
     */
    SubtitleIRL.prototype.createTime = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * SubtitleIRL session.
     * @member {string} session
     * @memberof si.SubtitleIRL
     * @instance
     */
    SubtitleIRL.prototype.session = '';

    /**
     * SubtitleIRL signature.
     * @member {string} signature
     * @memberof si.SubtitleIRL
     * @instance
     */
    SubtitleIRL.prototype.signature = '';

    /**
     * Creates a new SubtitleIRL instance using the specified properties.
     * @function create
     * @memberof si.SubtitleIRL
     * @static
     * @param {si.ISubtitleIRL=} [properties] Properties to set
     * @returns {si.SubtitleIRL} SubtitleIRL instance
     */
    SubtitleIRL.create = function create(properties) {
      return new SubtitleIRL(properties);
    };

    /**
     * Encodes the specified SubtitleIRL message. Does not implicitly {@link si.SubtitleIRL.verify|verify} messages.
     * @function encode
     * @memberof si.SubtitleIRL
     * @static
     * @param {si.ISubtitleIRL} message SubtitleIRL message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubtitleIRL.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message['class'] != null &&
        Object.hasOwnProperty.call(message, 'class')
      )
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message['class']);
      if (
        message.languageCode != null &&
        Object.hasOwnProperty.call(message, 'languageCode')
      )
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.languageCode);
      if (
        message.definite != null &&
        Object.hasOwnProperty.call(message, 'definite')
      )
        writer.uint32(/* id 3, wireType 0 =*/ 24).bool(message.definite);
      if (message.seqId != null && Object.hasOwnProperty.call(message, 'seqId'))
        writer.uint32(/* id 4, wireType 0 =*/ 32).int64(message.seqId);
      if (message.transformations != null && message.transformations.length)
        for (let i = 0; i < message.transformations.length; ++i)
          $root.si.SentenceInfo.encode(
            message.transformations[i],
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
          ).ldelim();
      if (
        message.createTime != null &&
        Object.hasOwnProperty.call(message, 'createTime')
      )
        writer.uint32(/* id 11, wireType 0 =*/ 88).int64(message.createTime);
      if (
        message.session != null &&
        Object.hasOwnProperty.call(message, 'session')
      )
        writer.uint32(/* id 20, wireType 2 =*/ 162).string(message.session);
      if (
        message.signature != null &&
        Object.hasOwnProperty.call(message, 'signature')
      )
        writer.uint32(/* id 21, wireType 2 =*/ 170).string(message.signature);
      return writer;
    };

    /**
     * Encodes the specified SubtitleIRL message, length delimited. Does not implicitly {@link si.SubtitleIRL.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.SubtitleIRL
     * @static
     * @param {si.ISubtitleIRL} message SubtitleIRL message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubtitleIRL.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SubtitleIRL message from the specified reader or buffer.
     * @function decode
     * @memberof si.SubtitleIRL
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.SubtitleIRL} SubtitleIRL
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubtitleIRL.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.SubtitleIRL();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message['class'] = reader.int32();
            break;
          case 2:
            message.languageCode = reader.string();
            break;
          case 3:
            message.definite = reader.bool();
            break;
          case 4:
            message.seqId = reader.int64();
            break;
          case 5:
            if (!(message.transformations && message.transformations.length))
              message.transformations = [];
            message.transformations.push(
              $root.si.SentenceInfo.decode(reader, reader.uint32())
            );
            break;
          case 11:
            message.createTime = reader.int64();
            break;
          case 20:
            message.session = reader.string();
            break;
          case 21:
            message.signature = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SubtitleIRL message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.SubtitleIRL
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.SubtitleIRL} SubtitleIRL
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubtitleIRL.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SubtitleIRL message.
     * @function verify
     * @memberof si.SubtitleIRL
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SubtitleIRL.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message['class'] != null && message.hasOwnProperty('class'))
        switch (message['class']) {
          default:
            return 'class: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (
        message.languageCode != null &&
        message.hasOwnProperty('languageCode')
      )
        if (!$util.isString(message.languageCode))
          return 'languageCode: string expected';
      if (message.definite != null && message.hasOwnProperty('definite'))
        if (typeof message.definite !== 'boolean')
          return 'definite: boolean expected';
      if (message.seqId != null && message.hasOwnProperty('seqId'))
        if (
          !$util.isInteger(message.seqId) &&
          !(
            message.seqId &&
            $util.isInteger(message.seqId.low) &&
            $util.isInteger(message.seqId.high)
          )
        )
          return 'seqId: integer|Long expected';
      if (
        message.transformations != null &&
        message.hasOwnProperty('transformations')
      ) {
        if (!Array.isArray(message.transformations))
          return 'transformations: array expected';
        for (let i = 0; i < message.transformations.length; ++i) {
          let error = $root.si.SentenceInfo.verify(message.transformations[i]);
          if (error) return 'transformations.' + error;
        }
      }
      if (message.createTime != null && message.hasOwnProperty('createTime'))
        if (
          !$util.isInteger(message.createTime) &&
          !(
            message.createTime &&
            $util.isInteger(message.createTime.low) &&
            $util.isInteger(message.createTime.high)
          )
        )
          return 'createTime: integer|Long expected';
      if (message.session != null && message.hasOwnProperty('session'))
        if (!$util.isString(message.session)) return 'session: string expected';
      if (message.signature != null && message.hasOwnProperty('signature'))
        if (!$util.isString(message.signature))
          return 'signature: string expected';
      return null;
    };

    /**
     * Creates a SubtitleIRL message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.SubtitleIRL
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.SubtitleIRL} SubtitleIRL
     */
    SubtitleIRL.fromObject = function fromObject(object) {
      if (object instanceof $root.si.SubtitleIRL) return object;
      let message = new $root.si.SubtitleIRL();
      switch (object['class']) {
        case 'UNSPECIFIED':
        case 0:
          message['class'] = 0;
          break;
        case 'TRANSCRIPT':
        case 1:
          message['class'] = 1;
          break;
        case 'SEGMENT':
        case 2:
          message['class'] = 2;
          break;
        case 'TRANSLATION':
        case 3:
          message['class'] = 3;
          break;
      }
      if (object.languageCode != null)
        message.languageCode = String(object.languageCode);
      if (object.definite != null) message.definite = Boolean(object.definite);
      if (object.seqId != null)
        if ($util.Long)
          (message.seqId = $util.Long.fromValue(object.seqId)).unsigned = false;
        else if (typeof object.seqId === 'string')
          message.seqId = parseInt(object.seqId, 10);
        else if (typeof object.seqId === 'number') message.seqId = object.seqId;
        else if (typeof object.seqId === 'object')
          message.seqId = new $util.LongBits(
            object.seqId.low >>> 0,
            object.seqId.high >>> 0
          ).toNumber();
      if (object.transformations) {
        if (!Array.isArray(object.transformations))
          throw TypeError('.si.SubtitleIRL.transformations: array expected');
        message.transformations = [];
        for (let i = 0; i < object.transformations.length; ++i) {
          if (typeof object.transformations[i] !== 'object')
            throw TypeError('.si.SubtitleIRL.transformations: object expected');
          message.transformations[i] = $root.si.SentenceInfo.fromObject(
            object.transformations[i]
          );
        }
      }
      if (object.createTime != null)
        if ($util.Long)
          (message.createTime = $util.Long.fromValue(
            object.createTime
          )).unsigned = false;
        else if (typeof object.createTime === 'string')
          message.createTime = parseInt(object.createTime, 10);
        else if (typeof object.createTime === 'number')
          message.createTime = object.createTime;
        else if (typeof object.createTime === 'object')
          message.createTime = new $util.LongBits(
            object.createTime.low >>> 0,
            object.createTime.high >>> 0
          ).toNumber();
      if (object.session != null) message.session = String(object.session);
      if (object.signature != null)
        message.signature = String(object.signature);
      return message;
    };

    /**
     * Creates a plain object from a SubtitleIRL message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.SubtitleIRL
     * @static
     * @param {si.SubtitleIRL} message SubtitleIRL
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SubtitleIRL.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.transformations = [];
      if (options.defaults) {
        object['class'] = options.enums === String ? 'UNSPECIFIED' : 0;
        object.languageCode = '';
        object.definite = false;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.seqId =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.seqId = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.createTime =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.createTime = options.longs === String ? '0' : 0;
        object.session = '';
        object.signature = '';
      }
      if (message['class'] != null && message.hasOwnProperty('class'))
        object['class'] =
          options.enums === String
            ? $root.si.SubtitleIRL.SubtitleType[message['class']]
            : message['class'];
      if (
        message.languageCode != null &&
        message.hasOwnProperty('languageCode')
      )
        object.languageCode = message.languageCode;
      if (message.definite != null && message.hasOwnProperty('definite'))
        object.definite = message.definite;
      if (message.seqId != null && message.hasOwnProperty('seqId'))
        if (typeof message.seqId === 'number')
          object.seqId =
            options.longs === String ? String(message.seqId) : message.seqId;
        else
          object.seqId =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.seqId)
              : options.longs === Number
              ? new $util.LongBits(
                  message.seqId.low >>> 0,
                  message.seqId.high >>> 0
                ).toNumber()
              : message.seqId;
      if (message.transformations && message.transformations.length) {
        object.transformations = [];
        for (let j = 0; j < message.transformations.length; ++j)
          object.transformations[j] = $root.si.SentenceInfo.toObject(
            message.transformations[j],
            options
          );
      }
      if (message.createTime != null && message.hasOwnProperty('createTime'))
        if (typeof message.createTime === 'number')
          object.createTime =
            options.longs === String
              ? String(message.createTime)
              : message.createTime;
        else
          object.createTime =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.createTime)
              : options.longs === Number
              ? new $util.LongBits(
                  message.createTime.low >>> 0,
                  message.createTime.high >>> 0
                ).toNumber()
              : message.createTime;
      if (message.session != null && message.hasOwnProperty('session'))
        object.session = message.session;
      if (message.signature != null && message.hasOwnProperty('signature'))
        object.signature = message.signature;
      return object;
    };

    /**
     * Converts this SubtitleIRL to JSON.
     * @function toJSON
     * @memberof si.SubtitleIRL
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SubtitleIRL.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * SubtitleType enum.
     * @name si.SubtitleIRL.SubtitleType
     * @enum {number}
     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
     * @property {number} TRANSCRIPT=1 TRANSCRIPT value
     * @property {number} SEGMENT=2 SEGMENT value
     * @property {number} TRANSLATION=3 TRANSLATION value
     */
    SubtitleIRL.SubtitleType = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'UNSPECIFIED')] = 0;
      values[(valuesById[1] = 'TRANSCRIPT')] = 1;
      values[(valuesById[2] = 'SEGMENT')] = 2;
      values[(valuesById[3] = 'TRANSLATION')] = 3;
      return values;
    })();

    return SubtitleIRL;
  })();

  si.SubtitleIRLArray = (function () {
    /**
     * Properties of a SubtitleIRLArray.
     * @memberof si
     * @interface ISubtitleIRLArray
     * @property {Array.<si.ISubtitleIRL>|null} [subtitleIRLArray] SubtitleIRLArray subtitleIRLArray
     */

    /**
     * Constructs a new SubtitleIRLArray.
     * @memberof si
     * @classdesc Represents a SubtitleIRLArray.
     * @implements ISubtitleIRLArray
     * @constructor
     * @param {si.ISubtitleIRLArray=} [properties] Properties to set
     */
    function SubtitleIRLArray(properties) {
      this.subtitleIRLArray = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SubtitleIRLArray subtitleIRLArray.
     * @member {Array.<si.ISubtitleIRL>} subtitleIRLArray
     * @memberof si.SubtitleIRLArray
     * @instance
     */
    SubtitleIRLArray.prototype.subtitleIRLArray = $util.emptyArray;

    /**
     * Creates a new SubtitleIRLArray instance using the specified properties.
     * @function create
     * @memberof si.SubtitleIRLArray
     * @static
     * @param {si.ISubtitleIRLArray=} [properties] Properties to set
     * @returns {si.SubtitleIRLArray} SubtitleIRLArray instance
     */
    SubtitleIRLArray.create = function create(properties) {
      return new SubtitleIRLArray(properties);
    };

    /**
     * Encodes the specified SubtitleIRLArray message. Does not implicitly {@link si.SubtitleIRLArray.verify|verify} messages.
     * @function encode
     * @memberof si.SubtitleIRLArray
     * @static
     * @param {si.ISubtitleIRLArray} message SubtitleIRLArray message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubtitleIRLArray.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.subtitleIRLArray != null && message.subtitleIRLArray.length)
        for (let i = 0; i < message.subtitleIRLArray.length; ++i)
          $root.si.SubtitleIRL.encode(
            message.subtitleIRLArray[i],
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified SubtitleIRLArray message, length delimited. Does not implicitly {@link si.SubtitleIRLArray.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.SubtitleIRLArray
     * @static
     * @param {si.ISubtitleIRLArray} message SubtitleIRLArray message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubtitleIRLArray.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SubtitleIRLArray message from the specified reader or buffer.
     * @function decode
     * @memberof si.SubtitleIRLArray
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.SubtitleIRLArray} SubtitleIRLArray
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubtitleIRLArray.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.SubtitleIRLArray();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            if (!(message.subtitleIRLArray && message.subtitleIRLArray.length))
              message.subtitleIRLArray = [];
            message.subtitleIRLArray.push(
              $root.si.SubtitleIRL.decode(reader, reader.uint32())
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SubtitleIRLArray message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.SubtitleIRLArray
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.SubtitleIRLArray} SubtitleIRLArray
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubtitleIRLArray.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SubtitleIRLArray message.
     * @function verify
     * @memberof si.SubtitleIRLArray
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SubtitleIRLArray.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (
        message.subtitleIRLArray != null &&
        message.hasOwnProperty('subtitleIRLArray')
      ) {
        if (!Array.isArray(message.subtitleIRLArray))
          return 'subtitleIRLArray: array expected';
        for (let i = 0; i < message.subtitleIRLArray.length; ++i) {
          let error = $root.si.SubtitleIRL.verify(message.subtitleIRLArray[i]);
          if (error) return 'subtitleIRLArray.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a SubtitleIRLArray message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.SubtitleIRLArray
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.SubtitleIRLArray} SubtitleIRLArray
     */
    SubtitleIRLArray.fromObject = function fromObject(object) {
      if (object instanceof $root.si.SubtitleIRLArray) return object;
      let message = new $root.si.SubtitleIRLArray();
      if (object.subtitleIRLArray) {
        if (!Array.isArray(object.subtitleIRLArray))
          throw TypeError(
            '.si.SubtitleIRLArray.subtitleIRLArray: array expected'
          );
        message.subtitleIRLArray = [];
        for (let i = 0; i < object.subtitleIRLArray.length; ++i) {
          if (typeof object.subtitleIRLArray[i] !== 'object')
            throw TypeError(
              '.si.SubtitleIRLArray.subtitleIRLArray: object expected'
            );
          message.subtitleIRLArray[i] = $root.si.SubtitleIRL.fromObject(
            object.subtitleIRLArray[i]
          );
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a SubtitleIRLArray message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.SubtitleIRLArray
     * @static
     * @param {si.SubtitleIRLArray} message SubtitleIRLArray
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SubtitleIRLArray.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.subtitleIRLArray = [];
      if (message.subtitleIRLArray && message.subtitleIRLArray.length) {
        object.subtitleIRLArray = [];
        for (let j = 0; j < message.subtitleIRLArray.length; ++j)
          object.subtitleIRLArray[j] = $root.si.SubtitleIRL.toObject(
            message.subtitleIRLArray[j],
            options
          );
      }
      return object;
    };

    /**
     * Converts this SubtitleIRLArray to JSON.
     * @function toJSON
     * @memberof si.SubtitleIRLArray
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SubtitleIRLArray.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SubtitleIRLArray;
  })();

  si.SubtitleIRLExtra = (function () {
    /**
     * Properties of a SubtitleIRLExtra.
     * @memberof si
     * @interface ISubtitleIRLExtra
     * @property {si.ISubtitleIRL|null} [subtitle] SubtitleIRLExtra subtitle
     * @property {boolean|null} [sentenceBeginOffset] SubtitleIRLExtra sentenceBeginOffset
     * @property {boolean|null} [sentenceEndOffset] SubtitleIRLExtra sentenceEndOffset
     * @property {si.ITimestamp|null} [mockTimestamps] SubtitleIRLExtra mockTimestamps
     * @property {Long|null} [delayMs] SubtitleIRLExtra delayMs
     * @property {string|null} [speechProvider] SubtitleIRLExtra speechProvider
     */

    /**
     * Constructs a new SubtitleIRLExtra.
     * @memberof si
     * @classdesc Represents a SubtitleIRLExtra.
     * @implements ISubtitleIRLExtra
     * @constructor
     * @param {si.ISubtitleIRLExtra=} [properties] Properties to set
     */
    function SubtitleIRLExtra(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SubtitleIRLExtra subtitle.
     * @member {si.ISubtitleIRL|null|undefined} subtitle
     * @memberof si.SubtitleIRLExtra
     * @instance
     */
    SubtitleIRLExtra.prototype.subtitle = null;

    /**
     * SubtitleIRLExtra sentenceBeginOffset.
     * @member {boolean} sentenceBeginOffset
     * @memberof si.SubtitleIRLExtra
     * @instance
     */
    SubtitleIRLExtra.prototype.sentenceBeginOffset = false;

    /**
     * SubtitleIRLExtra sentenceEndOffset.
     * @member {boolean} sentenceEndOffset
     * @memberof si.SubtitleIRLExtra
     * @instance
     */
    SubtitleIRLExtra.prototype.sentenceEndOffset = false;

    /**
     * SubtitleIRLExtra mockTimestamps.
     * @member {si.ITimestamp|null|undefined} mockTimestamps
     * @memberof si.SubtitleIRLExtra
     * @instance
     */
    SubtitleIRLExtra.prototype.mockTimestamps = null;

    /**
     * SubtitleIRLExtra delayMs.
     * @member {Long} delayMs
     * @memberof si.SubtitleIRLExtra
     * @instance
     */
    SubtitleIRLExtra.prototype.delayMs = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * SubtitleIRLExtra speechProvider.
     * @member {string} speechProvider
     * @memberof si.SubtitleIRLExtra
     * @instance
     */
    SubtitleIRLExtra.prototype.speechProvider = '';

    /**
     * Creates a new SubtitleIRLExtra instance using the specified properties.
     * @function create
     * @memberof si.SubtitleIRLExtra
     * @static
     * @param {si.ISubtitleIRLExtra=} [properties] Properties to set
     * @returns {si.SubtitleIRLExtra} SubtitleIRLExtra instance
     */
    SubtitleIRLExtra.create = function create(properties) {
      return new SubtitleIRLExtra(properties);
    };

    /**
     * Encodes the specified SubtitleIRLExtra message. Does not implicitly {@link si.SubtitleIRLExtra.verify|verify} messages.
     * @function encode
     * @memberof si.SubtitleIRLExtra
     * @static
     * @param {si.ISubtitleIRLExtra} message SubtitleIRLExtra message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubtitleIRLExtra.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (
        message.subtitle != null &&
        Object.hasOwnProperty.call(message, 'subtitle')
      )
        $root.si.SubtitleIRL.encode(
          message.subtitle,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
        ).ldelim();
      if (
        message.sentenceBeginOffset != null &&
        Object.hasOwnProperty.call(message, 'sentenceBeginOffset')
      )
        writer
          .uint32(/* id 4, wireType 0 =*/ 32)
          .bool(message.sentenceBeginOffset);
      if (
        message.sentenceEndOffset != null &&
        Object.hasOwnProperty.call(message, 'sentenceEndOffset')
      )
        writer
          .uint32(/* id 5, wireType 0 =*/ 40)
          .bool(message.sentenceEndOffset);
      if (
        message.mockTimestamps != null &&
        Object.hasOwnProperty.call(message, 'mockTimestamps')
      )
        $root.si.Timestamp.encode(
          message.mockTimestamps,
          writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
        ).ldelim();
      if (
        message.delayMs != null &&
        Object.hasOwnProperty.call(message, 'delayMs')
      )
        writer.uint32(/* id 7, wireType 0 =*/ 56).int64(message.delayMs);
      if (
        message.speechProvider != null &&
        Object.hasOwnProperty.call(message, 'speechProvider')
      )
        writer
          .uint32(/* id 10, wireType 2 =*/ 82)
          .string(message.speechProvider);
      return writer;
    };

    /**
     * Encodes the specified SubtitleIRLExtra message, length delimited. Does not implicitly {@link si.SubtitleIRLExtra.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.SubtitleIRLExtra
     * @static
     * @param {si.ISubtitleIRLExtra} message SubtitleIRLExtra message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubtitleIRLExtra.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SubtitleIRLExtra message from the specified reader or buffer.
     * @function decode
     * @memberof si.SubtitleIRLExtra
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.SubtitleIRLExtra} SubtitleIRLExtra
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubtitleIRLExtra.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.SubtitleIRLExtra();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.subtitle = $root.si.SubtitleIRL.decode(
              reader,
              reader.uint32()
            );
            break;
          case 4:
            message.sentenceBeginOffset = reader.bool();
            break;
          case 5:
            message.sentenceEndOffset = reader.bool();
            break;
          case 6:
            message.mockTimestamps = $root.si.Timestamp.decode(
              reader,
              reader.uint32()
            );
            break;
          case 7:
            message.delayMs = reader.int64();
            break;
          case 10:
            message.speechProvider = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SubtitleIRLExtra message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.SubtitleIRLExtra
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.SubtitleIRLExtra} SubtitleIRLExtra
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubtitleIRLExtra.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SubtitleIRLExtra message.
     * @function verify
     * @memberof si.SubtitleIRLExtra
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SubtitleIRLExtra.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.subtitle != null && message.hasOwnProperty('subtitle')) {
        let error = $root.si.SubtitleIRL.verify(message.subtitle);
        if (error) return 'subtitle.' + error;
      }
      if (
        message.sentenceBeginOffset != null &&
        message.hasOwnProperty('sentenceBeginOffset')
      )
        if (typeof message.sentenceBeginOffset !== 'boolean')
          return 'sentenceBeginOffset: boolean expected';
      if (
        message.sentenceEndOffset != null &&
        message.hasOwnProperty('sentenceEndOffset')
      )
        if (typeof message.sentenceEndOffset !== 'boolean')
          return 'sentenceEndOffset: boolean expected';
      if (
        message.mockTimestamps != null &&
        message.hasOwnProperty('mockTimestamps')
      ) {
        let error = $root.si.Timestamp.verify(message.mockTimestamps);
        if (error) return 'mockTimestamps.' + error;
      }
      if (message.delayMs != null && message.hasOwnProperty('delayMs'))
        if (
          !$util.isInteger(message.delayMs) &&
          !(
            message.delayMs &&
            $util.isInteger(message.delayMs.low) &&
            $util.isInteger(message.delayMs.high)
          )
        )
          return 'delayMs: integer|Long expected';
      if (
        message.speechProvider != null &&
        message.hasOwnProperty('speechProvider')
      )
        if (!$util.isString(message.speechProvider))
          return 'speechProvider: string expected';
      return null;
    };

    /**
     * Creates a SubtitleIRLExtra message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.SubtitleIRLExtra
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.SubtitleIRLExtra} SubtitleIRLExtra
     */
    SubtitleIRLExtra.fromObject = function fromObject(object) {
      if (object instanceof $root.si.SubtitleIRLExtra) return object;
      let message = new $root.si.SubtitleIRLExtra();
      if (object.subtitle != null) {
        if (typeof object.subtitle !== 'object')
          throw TypeError('.si.SubtitleIRLExtra.subtitle: object expected');
        message.subtitle = $root.si.SubtitleIRL.fromObject(object.subtitle);
      }
      if (object.sentenceBeginOffset != null)
        message.sentenceBeginOffset = Boolean(object.sentenceBeginOffset);
      if (object.sentenceEndOffset != null)
        message.sentenceEndOffset = Boolean(object.sentenceEndOffset);
      if (object.mockTimestamps != null) {
        if (typeof object.mockTimestamps !== 'object')
          throw TypeError(
            '.si.SubtitleIRLExtra.mockTimestamps: object expected'
          );
        message.mockTimestamps = $root.si.Timestamp.fromObject(
          object.mockTimestamps
        );
      }
      if (object.delayMs != null)
        if ($util.Long)
          (message.delayMs = $util.Long.fromValue(
            object.delayMs
          )).unsigned = false;
        else if (typeof object.delayMs === 'string')
          message.delayMs = parseInt(object.delayMs, 10);
        else if (typeof object.delayMs === 'number')
          message.delayMs = object.delayMs;
        else if (typeof object.delayMs === 'object')
          message.delayMs = new $util.LongBits(
            object.delayMs.low >>> 0,
            object.delayMs.high >>> 0
          ).toNumber();
      if (object.speechProvider != null)
        message.speechProvider = String(object.speechProvider);
      return message;
    };

    /**
     * Creates a plain object from a SubtitleIRLExtra message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.SubtitleIRLExtra
     * @static
     * @param {si.SubtitleIRLExtra} message SubtitleIRLExtra
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SubtitleIRLExtra.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.subtitle = null;
        object.sentenceBeginOffset = false;
        object.sentenceEndOffset = false;
        object.mockTimestamps = null;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.delayMs =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.delayMs = options.longs === String ? '0' : 0;
        object.speechProvider = '';
      }
      if (message.subtitle != null && message.hasOwnProperty('subtitle'))
        object.subtitle = $root.si.SubtitleIRL.toObject(
          message.subtitle,
          options
        );
      if (
        message.sentenceBeginOffset != null &&
        message.hasOwnProperty('sentenceBeginOffset')
      )
        object.sentenceBeginOffset = message.sentenceBeginOffset;
      if (
        message.sentenceEndOffset != null &&
        message.hasOwnProperty('sentenceEndOffset')
      )
        object.sentenceEndOffset = message.sentenceEndOffset;
      if (
        message.mockTimestamps != null &&
        message.hasOwnProperty('mockTimestamps')
      )
        object.mockTimestamps = $root.si.Timestamp.toObject(
          message.mockTimestamps,
          options
        );
      if (message.delayMs != null && message.hasOwnProperty('delayMs'))
        if (typeof message.delayMs === 'number')
          object.delayMs =
            options.longs === String
              ? String(message.delayMs)
              : message.delayMs;
        else
          object.delayMs =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.delayMs)
              : options.longs === Number
              ? new $util.LongBits(
                  message.delayMs.low >>> 0,
                  message.delayMs.high >>> 0
                ).toNumber()
              : message.delayMs;
      if (
        message.speechProvider != null &&
        message.hasOwnProperty('speechProvider')
      )
        object.speechProvider = message.speechProvider;
      return object;
    };

    /**
     * Converts this SubtitleIRLExtra to JSON.
     * @function toJSON
     * @memberof si.SubtitleIRLExtra
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SubtitleIRLExtra.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SubtitleIRLExtra;
  })();

  si.AllSubtitleIRLExtra = (function () {
    /**
     * Properties of an AllSubtitleIRLExtra.
     * @memberof si
     * @interface IAllSubtitleIRLExtra
     * @property {Array.<si.ISubtitleIRLExtra>|null} [subtitles] AllSubtitleIRLExtra subtitles
     */

    /**
     * Constructs a new AllSubtitleIRLExtra.
     * @memberof si
     * @classdesc Represents an AllSubtitleIRLExtra.
     * @implements IAllSubtitleIRLExtra
     * @constructor
     * @param {si.IAllSubtitleIRLExtra=} [properties] Properties to set
     */
    function AllSubtitleIRLExtra(properties) {
      this.subtitles = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * AllSubtitleIRLExtra subtitles.
     * @member {Array.<si.ISubtitleIRLExtra>} subtitles
     * @memberof si.AllSubtitleIRLExtra
     * @instance
     */
    AllSubtitleIRLExtra.prototype.subtitles = $util.emptyArray;

    /**
     * Creates a new AllSubtitleIRLExtra instance using the specified properties.
     * @function create
     * @memberof si.AllSubtitleIRLExtra
     * @static
     * @param {si.IAllSubtitleIRLExtra=} [properties] Properties to set
     * @returns {si.AllSubtitleIRLExtra} AllSubtitleIRLExtra instance
     */
    AllSubtitleIRLExtra.create = function create(properties) {
      return new AllSubtitleIRLExtra(properties);
    };

    /**
     * Encodes the specified AllSubtitleIRLExtra message. Does not implicitly {@link si.AllSubtitleIRLExtra.verify|verify} messages.
     * @function encode
     * @memberof si.AllSubtitleIRLExtra
     * @static
     * @param {si.IAllSubtitleIRLExtra} message AllSubtitleIRLExtra message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AllSubtitleIRLExtra.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.subtitles != null && message.subtitles.length)
        for (let i = 0; i < message.subtitles.length; ++i)
          $root.si.SubtitleIRLExtra.encode(
            message.subtitles[i],
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified AllSubtitleIRLExtra message, length delimited. Does not implicitly {@link si.AllSubtitleIRLExtra.verify|verify} messages.
     * @function encodeDelimited
     * @memberof si.AllSubtitleIRLExtra
     * @static
     * @param {si.IAllSubtitleIRLExtra} message AllSubtitleIRLExtra message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AllSubtitleIRLExtra.encodeDelimited = function encodeDelimited(
      message,
      writer
    ) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AllSubtitleIRLExtra message from the specified reader or buffer.
     * @function decode
     * @memberof si.AllSubtitleIRLExtra
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {si.AllSubtitleIRLExtra} AllSubtitleIRLExtra
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AllSubtitleIRLExtra.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.si.AllSubtitleIRLExtra();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            if (!(message.subtitles && message.subtitles.length))
              message.subtitles = [];
            message.subtitles.push(
              $root.si.SubtitleIRLExtra.decode(reader, reader.uint32())
            );
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an AllSubtitleIRLExtra message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof si.AllSubtitleIRLExtra
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {si.AllSubtitleIRLExtra} AllSubtitleIRLExtra
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AllSubtitleIRLExtra.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AllSubtitleIRLExtra message.
     * @function verify
     * @memberof si.AllSubtitleIRLExtra
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AllSubtitleIRLExtra.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (message.subtitles != null && message.hasOwnProperty('subtitles')) {
        if (!Array.isArray(message.subtitles))
          return 'subtitles: array expected';
        for (let i = 0; i < message.subtitles.length; ++i) {
          let error = $root.si.SubtitleIRLExtra.verify(message.subtitles[i]);
          if (error) return 'subtitles.' + error;
        }
      }
      return null;
    };

    /**
     * Creates an AllSubtitleIRLExtra message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof si.AllSubtitleIRLExtra
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {si.AllSubtitleIRLExtra} AllSubtitleIRLExtra
     */
    AllSubtitleIRLExtra.fromObject = function fromObject(object) {
      if (object instanceof $root.si.AllSubtitleIRLExtra) return object;
      let message = new $root.si.AllSubtitleIRLExtra();
      if (object.subtitles) {
        if (!Array.isArray(object.subtitles))
          throw TypeError('.si.AllSubtitleIRLExtra.subtitles: array expected');
        message.subtitles = [];
        for (let i = 0; i < object.subtitles.length; ++i) {
          if (typeof object.subtitles[i] !== 'object')
            throw TypeError(
              '.si.AllSubtitleIRLExtra.subtitles: object expected'
            );
          message.subtitles[i] = $root.si.SubtitleIRLExtra.fromObject(
            object.subtitles[i]
          );
        }
      }
      return message;
    };

    /**
     * Creates a plain object from an AllSubtitleIRLExtra message. Also converts values to other types if specified.
     * @function toObject
     * @memberof si.AllSubtitleIRLExtra
     * @static
     * @param {si.AllSubtitleIRLExtra} message AllSubtitleIRLExtra
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AllSubtitleIRLExtra.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.subtitles = [];
      if (message.subtitles && message.subtitles.length) {
        object.subtitles = [];
        for (let j = 0; j < message.subtitles.length; ++j)
          object.subtitles[j] = $root.si.SubtitleIRLExtra.toObject(
            message.subtitles[j],
            options
          );
      }
      return object;
    };

    /**
     * Converts this AllSubtitleIRLExtra to JSON.
     * @function toJSON
     * @memberof si.AllSubtitleIRLExtra
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AllSubtitleIRLExtra.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AllSubtitleIRLExtra;
  })();

  return si;
})());

export const pbbp2 = ($root.pbbp2 = (() => {
  /**
   * Namespace pbbp2.
   * @exports pbbp2
   * @namespace
   */
  const pbbp2 = {};

  pbbp2.Header = (function () {
    /**
     * Properties of a Header.
     * @memberof pbbp2
     * @interface IHeader
     * @property {string} key Header key
     * @property {string} value Header value
     */

    /**
     * Constructs a new Header.
     * @memberof pbbp2
     * @classdesc Represents a Header.
     * @implements IHeader
     * @constructor
     * @param {pbbp2.IHeader=} [properties] Properties to set
     */
    function Header(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Header key.
     * @member {string} key
     * @memberof pbbp2.Header
     * @instance
     */
    Header.prototype.key = '';

    /**
     * Header value.
     * @member {string} value
     * @memberof pbbp2.Header
     * @instance
     */
    Header.prototype.value = '';

    /**
     * Creates a new Header instance using the specified properties.
     * @function create
     * @memberof pbbp2.Header
     * @static
     * @param {pbbp2.IHeader=} [properties] Properties to set
     * @returns {pbbp2.Header} Header instance
     */
    Header.create = function create(properties) {
      return new Header(properties);
    };

    /**
     * Encodes the specified Header message. Does not implicitly {@link pbbp2.Header.verify|verify} messages.
     * @function encode
     * @memberof pbbp2.Header
     * @static
     * @param {pbbp2.IHeader} message Header message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Header.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.key);
      writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.value);
      return writer;
    };

    /**
     * Encodes the specified Header message, length delimited. Does not implicitly {@link pbbp2.Header.verify|verify} messages.
     * @function encodeDelimited
     * @memberof pbbp2.Header
     * @static
     * @param {pbbp2.IHeader} message Header message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Header.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Header message from the specified reader or buffer.
     * @function decode
     * @memberof pbbp2.Header
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {pbbp2.Header} Header
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Header.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.pbbp2.Header();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.key = reader.string();
            break;
          case 2:
            message.value = reader.string();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      if (!message.hasOwnProperty('key'))
        throw $util.ProtocolError("missing required 'key'", {
          instance: message,
        });
      if (!message.hasOwnProperty('value'))
        throw $util.ProtocolError("missing required 'value'", {
          instance: message,
        });
      return message;
    };

    /**
     * Decodes a Header message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof pbbp2.Header
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {pbbp2.Header} Header
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Header.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Header message.
     * @function verify
     * @memberof pbbp2.Header
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Header.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (!$util.isString(message.key)) return 'key: string expected';
      if (!$util.isString(message.value)) return 'value: string expected';
      return null;
    };

    /**
     * Creates a Header message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof pbbp2.Header
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {pbbp2.Header} Header
     */
    Header.fromObject = function fromObject(object) {
      if (object instanceof $root.pbbp2.Header) return object;
      let message = new $root.pbbp2.Header();
      if (object.key != null) message.key = String(object.key);
      if (object.value != null) message.value = String(object.value);
      return message;
    };

    /**
     * Creates a plain object from a Header message. Also converts values to other types if specified.
     * @function toObject
     * @memberof pbbp2.Header
     * @static
     * @param {pbbp2.Header} message Header
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Header.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.key = '';
        object.value = '';
      }
      if (message.key != null && message.hasOwnProperty('key'))
        object.key = message.key;
      if (message.value != null && message.hasOwnProperty('value'))
        object.value = message.value;
      return object;
    };

    /**
     * Converts this Header to JSON.
     * @function toJSON
     * @memberof pbbp2.Header
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Header.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Header;
  })();

  pbbp2.Frame = (function () {
    /**
     * Properties of a Frame.
     * @memberof pbbp2
     * @interface IFrame
     * @property {Long} SeqID Frame SeqID
     * @property {Long} LogID Frame LogID
     * @property {number} service Frame service
     * @property {number} method Frame method
     * @property {Array.<pbbp2.IHeader>|null} [headers] Frame headers
     * @property {string|null} [payloadEncoding] Frame payloadEncoding
     * @property {string|null} [payloadType] Frame payloadType
     * @property {Uint8Array|null} [payload] Frame payload
     */

    /**
     * Constructs a new Frame.
     * @memberof pbbp2
     * @classdesc Represents a Frame.
     * @implements IFrame
     * @constructor
     * @param {pbbp2.IFrame=} [properties] Properties to set
     */
    function Frame(properties) {
      this.headers = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Frame SeqID.
     * @member {Long} SeqID
     * @memberof pbbp2.Frame
     * @instance
     */
    Frame.prototype.SeqID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;

    /**
     * Frame LogID.
     * @member {Long} LogID
     * @memberof pbbp2.Frame
     * @instance
     */
    Frame.prototype.LogID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;

    /**
     * Frame service.
     * @member {number} service
     * @memberof pbbp2.Frame
     * @instance
     */
    Frame.prototype.service = 0;

    /**
     * Frame method.
     * @member {number} method
     * @memberof pbbp2.Frame
     * @instance
     */
    Frame.prototype.method = 0;

    /**
     * Frame headers.
     * @member {Array.<pbbp2.IHeader>} headers
     * @memberof pbbp2.Frame
     * @instance
     */
    Frame.prototype.headers = $util.emptyArray;

    /**
     * Frame payloadEncoding.
     * @member {string} payloadEncoding
     * @memberof pbbp2.Frame
     * @instance
     */
    Frame.prototype.payloadEncoding = '';

    /**
     * Frame payloadType.
     * @member {string} payloadType
     * @memberof pbbp2.Frame
     * @instance
     */
    Frame.prototype.payloadType = '';

    /**
     * Frame payload.
     * @member {Uint8Array} payload
     * @memberof pbbp2.Frame
     * @instance
     */
    Frame.prototype.payload = $util.newBuffer([]);

    /**
     * Creates a new Frame instance using the specified properties.
     * @function create
     * @memberof pbbp2.Frame
     * @static
     * @param {pbbp2.IFrame=} [properties] Properties to set
     * @returns {pbbp2.Frame} Frame instance
     */
    Frame.create = function create(properties) {
      return new Frame(properties);
    };

    /**
     * Encodes the specified Frame message. Does not implicitly {@link pbbp2.Frame.verify|verify} messages.
     * @function encode
     * @memberof pbbp2.Frame
     * @static
     * @param {pbbp2.IFrame} message Frame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Frame.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      writer.uint32(/* id 1, wireType 0 =*/ 8).uint64(message.SeqID);
      writer.uint32(/* id 2, wireType 0 =*/ 16).uint64(message.LogID);
      writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.service);
      writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.method);
      if (message.headers != null && message.headers.length)
        for (let i = 0; i < message.headers.length; ++i)
          $root.pbbp2.Header.encode(
            message.headers[i],
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
          ).ldelim();
      if (
        message.payloadEncoding != null &&
        Object.hasOwnProperty.call(message, 'payloadEncoding')
      )
        writer
          .uint32(/* id 6, wireType 2 =*/ 50)
          .string(message.payloadEncoding);
      if (
        message.payloadType != null &&
        Object.hasOwnProperty.call(message, 'payloadType')
      )
        writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.payloadType);
      if (
        message.payload != null &&
        Object.hasOwnProperty.call(message, 'payload')
      )
        writer.uint32(/* id 8, wireType 2 =*/ 66).bytes(message.payload);
      return writer;
    };

    /**
     * Encodes the specified Frame message, length delimited. Does not implicitly {@link pbbp2.Frame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof pbbp2.Frame
     * @static
     * @param {pbbp2.IFrame} message Frame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Frame.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Frame message from the specified reader or buffer.
     * @function decode
     * @memberof pbbp2.Frame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {pbbp2.Frame} Frame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Frame.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.pbbp2.Frame();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1:
            message.SeqID = reader.uint64();
            break;
          case 2:
            message.LogID = reader.uint64();
            break;
          case 3:
            message.service = reader.int32();
            break;
          case 4:
            message.method = reader.int32();
            break;
          case 5:
            if (!(message.headers && message.headers.length))
              message.headers = [];
            message.headers.push(
              $root.pbbp2.Header.decode(reader, reader.uint32())
            );
            break;
          case 6:
            message.payloadEncoding = reader.string();
            break;
          case 7:
            message.payloadType = reader.string();
            break;
          case 8:
            message.payload = reader.bytes();
            break;
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      if (!message.hasOwnProperty('SeqID'))
        throw $util.ProtocolError("missing required 'SeqID'", {
          instance: message,
        });
      if (!message.hasOwnProperty('LogID'))
        throw $util.ProtocolError("missing required 'LogID'", {
          instance: message,
        });
      if (!message.hasOwnProperty('service'))
        throw $util.ProtocolError("missing required 'service'", {
          instance: message,
        });
      if (!message.hasOwnProperty('method'))
        throw $util.ProtocolError("missing required 'method'", {
          instance: message,
        });
      return message;
    };

    /**
     * Decodes a Frame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof pbbp2.Frame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {pbbp2.Frame} Frame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Frame.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Frame message.
     * @function verify
     * @memberof pbbp2.Frame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Frame.verify = function verify(message) {
      if (typeof message !== 'object' || message === null)
        return 'object expected';
      if (
        !$util.isInteger(message.SeqID) &&
        !(
          message.SeqID &&
          $util.isInteger(message.SeqID.low) &&
          $util.isInteger(message.SeqID.high)
        )
      )
        return 'SeqID: integer|Long expected';
      if (
        !$util.isInteger(message.LogID) &&
        !(
          message.LogID &&
          $util.isInteger(message.LogID.low) &&
          $util.isInteger(message.LogID.high)
        )
      )
        return 'LogID: integer|Long expected';
      if (!$util.isInteger(message.service)) return 'service: integer expected';
      if (!$util.isInteger(message.method)) return 'method: integer expected';
      if (message.headers != null && message.hasOwnProperty('headers')) {
        if (!Array.isArray(message.headers)) return 'headers: array expected';
        for (let i = 0; i < message.headers.length; ++i) {
          let error = $root.pbbp2.Header.verify(message.headers[i]);
          if (error) return 'headers.' + error;
        }
      }
      if (
        message.payloadEncoding != null &&
        message.hasOwnProperty('payloadEncoding')
      )
        if (!$util.isString(message.payloadEncoding))
          return 'payloadEncoding: string expected';
      if (message.payloadType != null && message.hasOwnProperty('payloadType'))
        if (!$util.isString(message.payloadType))
          return 'payloadType: string expected';
      if (message.payload != null && message.hasOwnProperty('payload'))
        if (
          !(
            (message.payload && typeof message.payload.length === 'number') ||
            $util.isString(message.payload)
          )
        )
          return 'payload: buffer expected';
      return null;
    };

    /**
     * Creates a Frame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof pbbp2.Frame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {pbbp2.Frame} Frame
     */
    Frame.fromObject = function fromObject(object) {
      if (object instanceof $root.pbbp2.Frame) return object;
      let message = new $root.pbbp2.Frame();
      if (object.SeqID != null)
        if ($util.Long)
          (message.SeqID = $util.Long.fromValue(object.SeqID)).unsigned = true;
        else if (typeof object.SeqID === 'string')
          message.SeqID = parseInt(object.SeqID, 10);
        else if (typeof object.SeqID === 'number') message.SeqID = object.SeqID;
        else if (typeof object.SeqID === 'object')
          message.SeqID = new $util.LongBits(
            object.SeqID.low >>> 0,
            object.SeqID.high >>> 0
          ).toNumber(true);
      if (object.LogID != null)
        if ($util.Long)
          (message.LogID = $util.Long.fromValue(object.LogID)).unsigned = true;
        else if (typeof object.LogID === 'string')
          message.LogID = parseInt(object.LogID, 10);
        else if (typeof object.LogID === 'number') message.LogID = object.LogID;
        else if (typeof object.LogID === 'object')
          message.LogID = new $util.LongBits(
            object.LogID.low >>> 0,
            object.LogID.high >>> 0
          ).toNumber(true);
      if (object.service != null) message.service = object.service | 0;
      if (object.method != null) message.method = object.method | 0;
      if (object.headers) {
        if (!Array.isArray(object.headers))
          throw TypeError('.pbbp2.Frame.headers: array expected');
        message.headers = [];
        for (let i = 0; i < object.headers.length; ++i) {
          if (typeof object.headers[i] !== 'object')
            throw TypeError('.pbbp2.Frame.headers: object expected');
          message.headers[i] = $root.pbbp2.Header.fromObject(object.headers[i]);
        }
      }
      if (object.payloadEncoding != null)
        message.payloadEncoding = String(object.payloadEncoding);
      if (object.payloadType != null)
        message.payloadType = String(object.payloadType);
      if (object.payload != null)
        if (typeof object.payload === 'string')
          $util.base64.decode(
            object.payload,
            (message.payload = $util.newBuffer(
              $util.base64.length(object.payload)
            )),
            0
          );
        else if (object.payload.length) message.payload = object.payload;
      return message;
    };

    /**
     * Creates a plain object from a Frame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof pbbp2.Frame
     * @static
     * @param {pbbp2.Frame} message Frame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Frame.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.headers = [];
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.SeqID =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.SeqID = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, true);
          object.LogID =
            options.longs === String
              ? long.toString()
              : options.longs === Number
              ? long.toNumber()
              : long;
        } else object.LogID = options.longs === String ? '0' : 0;
        object.service = 0;
        object.method = 0;
        object.payloadEncoding = '';
        object.payloadType = '';
        if (options.bytes === String) object.payload = '';
        else {
          object.payload = [];
          if (options.bytes !== Array)
            object.payload = $util.newBuffer(object.payload);
        }
      }
      if (message.SeqID != null && message.hasOwnProperty('SeqID'))
        if (typeof message.SeqID === 'number')
          object.SeqID =
            options.longs === String ? String(message.SeqID) : message.SeqID;
        else
          object.SeqID =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.SeqID)
              : options.longs === Number
              ? new $util.LongBits(
                  message.SeqID.low >>> 0,
                  message.SeqID.high >>> 0
                ).toNumber(true)
              : message.SeqID;
      if (message.LogID != null && message.hasOwnProperty('LogID'))
        if (typeof message.LogID === 'number')
          object.LogID =
            options.longs === String ? String(message.LogID) : message.LogID;
        else
          object.LogID =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.LogID)
              : options.longs === Number
              ? new $util.LongBits(
                  message.LogID.low >>> 0,
                  message.LogID.high >>> 0
                ).toNumber(true)
              : message.LogID;
      if (message.service != null && message.hasOwnProperty('service'))
        object.service = message.service;
      if (message.method != null && message.hasOwnProperty('method'))
        object.method = message.method;
      if (message.headers && message.headers.length) {
        object.headers = [];
        for (let j = 0; j < message.headers.length; ++j)
          object.headers[j] = $root.pbbp2.Header.toObject(
            message.headers[j],
            options
          );
      }
      if (
        message.payloadEncoding != null &&
        message.hasOwnProperty('payloadEncoding')
      )
        object.payloadEncoding = message.payloadEncoding;
      if (message.payloadType != null && message.hasOwnProperty('payloadType'))
        object.payloadType = message.payloadType;
      if (message.payload != null && message.hasOwnProperty('payload'))
        object.payload =
          options.bytes === String
            ? $util.base64.encode(message.payload, 0, message.payload.length)
            : options.bytes === Array
            ? Array.prototype.slice.call(message.payload)
            : message.payload;
      return object;
    };

    /**
     * Converts this Frame to JSON.
     * @function toJSON
     * @memberof pbbp2.Frame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Frame.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Frame;
  })();

  return pbbp2;
})());

export { $root as default };
